export default {
  translation: {
    Automation_flow_templates: "قوالب التدفق",
    Automation_ai_templates: "قوالب الذكاء الاصطناعي",
    Automation_sample: "نموذج",
    Automation_sample_notice: "يمكنك استخدام القوالب الجاهزة وتعديلها",
    Automation_template_number: "القالب رقم {{number}}",
    Automation_beginner: "مبتدئ",
    Automation_intermediate: "متوسط",
    Automation_advanced: "متقدم",
    Automation_trending: "رائج",
    Automation_sample_cart: "استعادة سلة التسوق",
    Automation_sample_cart_description: "فكرة نموذجية: ساعد المتسوقين على العودة إلى سلتهم والإجابة عن أسئلتهم.",
    Automation_sample_language: "محادثات متعددة اللغات",
    Automation_sample_language_description: "فكرة نموذجية: وجّه الزوار إلى محادثة بلغتهم المفضلة.",
    Automation_sample_support: "مساعد دعم العملاء",
    Automation_sample_support_description: "فكرة نموذجية: أجب عن الأسئلة الشائعة ووجّه العملاء إلى الخطوة التالية.",
    Automation_sample_welcome: "الترحيب بالعملاء الجدد",
    Automation_sample_welcome_description: "فكرة نموذجية: رحّب بالزوار الجدد وعرّفهم بمنتجاتك وخدماتك.",
    Automation_flow_history: "سجل التدفقات",
    Automation_ai_history: "سجل الذكاء الاصطناعي",
    Automation_loaded_count: "العناصر المحمّلة؛ تشير + إلى وجود المزيد.",
    Automation_sort_newest: " الأحدث أولاً",
    Automation_sort_oldest: " الأقدم أولاً",
    Automation_sort_title: " حسب العنوان",
    Automation_connected_posts: "المنشورات المتصلة",
    Automation_not_connected: "غير متصل بأي منشور.",
    Automation_connections_access: "يلزم إذن التعليقات وصلاحية الأتمتة والتعليقات لعرض الاتصالات.",
    Automation_checking_connections: "جارٍ التحقق من اتصالات المنشورات...",
    Automation_connections_retry: "تعذّر التحقق من جميع الاتصالات. حاول مجددًا.",
    aiSuggestedPrompts_title: "المطالبات المقترحة",
    aiSuggestedPrompts_openImage: "فتح الصورة بملء الشاشة",
    aiSuggestedPrompts_explain: "اختر مطالبة لاستخدامها كنقطة بداية.",
    aiSuggestedPrompts_category: "فئة المطالبة",
    aiSuggestedPrompts_subCategory: "الفئة الفرعية",
    aiSuggestedPrompts_allCategories: "جميع الفئات",
    aiSuggestedPrompts_loading: "جارٍ التحميل...",
    aiSuggestedPrompts_empty: "لم يتم العثور على مطالبات مقترحة.",
    aiSuggestedPrompts_loadMore: "تحميل المزيد",
    aiSuggestedPrompts_prompt: "المطالبة",
    aiSuggestedPrompts_copy: "نسخ المطالبة",
    aiSuggestedPrompts_showMore: "عرض المزيد",
    aiSuggestedPrompts_showLess: "عرض أقل",
    unpin: "إلغاء التثبيت",
    pin: "تثبيت",
    usethisPrompt: "استخدم في البرومبت",
    AudienceTooltip:
      "لقياس تفاعلك الحالي بشكل أدق، يتم عرض الإحصاءات بناءً على أدائك خلال آخر 30 يومًا؛ بينما تعتمد إحصاءات Instagram على كامل فترة نشاط الحساب، وقد تختلف عن هذه البيانات",
    toggleShowAll: "عرض الكل",
    toggleShowmonthly: "عرض الشهري",
    Nodetutorial: "شرح الكتلة",
    Dublicate: "تكرار",
    zoomout: "تصغير",
    fitscreen: "ملاءمة الشاشة",
    zoomin: "تكبير",
    shortcuts: "الاختصارات",
    History_saved: "السجلات المحفوظة",
    Data_Management_explain: "يمكنك حفظ سير العمل الخاص بك، وإذا لزم الأمر، استيراد سير العمل من منصات أخرى.",
    flow_shortcuts_explain: "اختصارات لوحة المفاتيح لزيادة السرعة والكفاءة في إدارة سير العمل.",
    Workflow_Statistics: "إحصائيات سير العمل",
    Nodes: "العُقد",
    Connections: "الاتصالات",
    Last_Auto_saved: "آخر حفظ تلقائي",
    Canvas_Behavior: "سلوك اللوحة",
    Canvas_Behavior_explain: "اضبط شبكة المحاذاة وحدود التحريك لتحكم أفضل",
    Data_Management: "إدارة البيانات",
    importJSON_success: "تم استيراد الملف بنجاح",
    importJSON_error: "خطأ في استيراد الملف",
    exportJSON: "تصدير JSON",
    importJSON: "استيراد JSON",

    quantity: "الكمية",
    allquantity: "إجمالي الكمية",
    remainingquantity: "الكمية المتبقية",
    Connecting: "جارٍ الاتصال",
    Connected: "متصل",
    EmailNotification: "إشعارات البريد الإلكتروني",
    EmailNotificationExplain: "يتم إرسال إشعارات النظام إلى هذا البريد الإلكتروني.",
    MobileNotification: "إشعارات الجوال",
    MobileNotificationExplain: "يتم إرسال إشعارات النظام إلى هذا الرقم المحمول.",
    Responded: "تم الرد",
    notimelimit: "بدون قيود زمنية",
    usersettingexplain: "معلومات حساب إنستغرام تتغير فقط داخل إنستغرام ويتم تحديثها تلقائيًا هنا.",
    loading: "...جارٍ التحميل",
    Beginner: "مبتدئ",
    Basic: "أساسي",
    Growing: "نامي",
    Advanced: "متقدم",
    Professional: "محترف",
    Special: "خاص",
    Unavailable: "غير متاح",
    level: "المستوى",
    daysAgo: "منذ أيام",
    hoursAgo: "منذ ساعات",
    minutesAgo: "منذ دقائق",
    justNow: "الآن",
    bestposts: "أفضل المشاركات",
    upgradeyouraccount: "قم بترقية حسابك",
    featureNotAvailable: "هذه الميزة غير متاحة",
    featureNotAvailableDesc: "قم بترقية حسابك للاستفادة من هذه الميزة.",
    likeaprouser: "ابدأ مشروعًا حقيقيًا",
    followerrate: "معدل نمو المتابعين",
    shoppertitle: "كل شيء جاهز للبيع 👌",
    advertisertitle: "كل شيء جاهز للإعلان 👌",
    shopperdescription: "تابع أداء المبيعات بدقة.",
    advertiserdescription: "تابع أداء الإعلانات بدقة.",
    syncingAccountTitle: "جارٍ جلب المعلومات",
    syncingAccountDescription: "جارٍ تحديث معلومات Instagram الخاصة بك في برنسی",
    syncingAccountDescriptiontooltip: "سيتم تحديث بعض معلوماتك خلال الـ24 ساعة القادمة.",
    subscriptionExpiringTitle: "اشتراكك على وشك الانتهاء",
    subscriptionExpiringDescription: "جدّد اشتراكك لمواصلة استخدام الميزات المتاحة.",
    subscriptionDaysRemaining: "متبقي {{days}} أيام",
    priceHistory: "تاريخ الأسعار",
    menu: "القائمة",
    unselect: "إلغاء الاختيار",
    shopper: "بائع",
    onlinestore: "متجر إلكتروني",
    onlinestoreExplain: "كل ما تحتاجه لزيادة مبيعاتك في مكان واحد.",
    influencerExplain: "جميع أدوات المُعلنين الاینفلونسر بطريقة احترافية",
    advertiser: "مُعلِن",
    influencer: "الاینفلونسر",
    skip: "تخطي",
    skipfornow: "تخطي الآن",
    freedays: "٤٠ يومًا",
    freedaysExplain:
      "إذا كان لديك صفحة إنستغرام نشطة وتنمو، فهذا الباقة مصممة خصيصًا لك. تم تفعيل الوصول الكامل للأدوات، التحليلات، إدارة المحتوى، الرسائل، التعليقات، وإنشاء مدير مشارك في Brancy.",
    instagramerplanactive: "خطتك الإنستغرامية مفعلة",
    influencerplanactive: "خطة المؤثر الخاصة بك مفعلة",
    onlinestoreplanactive: "خطة المتجر الإلكتروني الخاصة بك مفعلة",

    // #region landing page
    SwitchtoUserpanel: "الدخول كمستخدم",
    chooselanguage: "اختر اللغة",
    chooselanguageExplain: "اختر لغتك المفضلة",
    chooseTheme: "اختر المظهر",
    chooseThemeExplain: "اختر المظهر الذي تفضله",
    chooseCalendar: "اختر التقويم",
    chooseCalendarExplain: "اختر نوع التقويم الذي تفضله",
    setupchooseexplain: "يمكنك تغيير هذه الإعدادات لاحقًا من قسم الإعدادات",

    Lottery: "اليانصيب",
    services: "الميزات",
    markets: "المنصات",
    pricing: "التسعير",
    page1_text1: "إدارة الأعمال على إنستغرام",
    page1_text2: "مع الجيل التالي من",
    page1_StartNow: "بداية مجانية مع الوصول إلى أدوات احترافية",
    page1_services: "الخدمات",
    page1_analytics: "التحليلات",
    page1_transportation: "النقل",
    page1_financial_solutions: "الحلول المالية",
    page1_customer_communication: "التواصل مع العملاء",
    page1_content_management: "إدارة المحتوى",
    page1_artificial_intelligence: "الذكاء الصناعي",
    page1_tools: "الأدوات",
    page1_advertises: "إدارة الإعلانات",
    page2_text1: "أكثر الخدمات والحلول التجارية شمولاً",
    page2_text2: "برنسی أداة قوية لإدارة حسابك على إنستجرام، حيث توفر لك الأدوات التي تحتاجها للنجاح.",
    page2_ads_statistics_title: "الإحصائيات",
    page2_ads_statistics_description: "أداة متقدمة لتحليل الأداء",
    page2_ads_statistics_servicedescription:
      "استخدم هذه الأداة المتقدمة لمراقبة جميع مؤشرات الأداء الرئيسية للإعلانات بدقة وبلحظة وتحليل. احصل على رؤية كاملة ومهنية لتحسين حملاتك الإعلانية.",
    page2_ads_calendar_title: "التقويم العملي",
    page2_ads_calendar_description: "أفضل إدارة للإعلانات",
    page2_ads_calendar_servicedescription:
      "قم بإدارة جميع إعلاناتك – المقبولة منك والمقترحة بالذكاء الاصطناعي – في تقويم ذكي مع جدول زمني متقدم ومنظم. تجربة تخطيط سريعة وخالية من الأخطاء.",
    page2_ads_adlist_title: "قائمة الإعلانات",
    page2_ads_adlist_description: "عرض قائمة الإعلانات في انتظار الموافقة",
    page2_ads_adlist_servicedescription:
      "شاهد قائمة واضحة ومصنفة للإعلانات بانتظار موافقتك وقم بالموافقة أو الرفض بنقرة واحدة. سهل وأحترافي لإدارة الإعلانات.",
    page2_store_addproduct_title: "إضافة منتج",
    page2_store_addproduct_description: "التعرف على جميع المنتجات من صفحتك",
    page2_store_addproduct_servicedescription:
      "نظامنا الذكي يكتشف جميع المنتجات في منشورات صفحتك ويجهزها تلقائياً للإضافة. يسرّع عملك ويقلل الأخطاء.",
    page2_store_productlist_title: "قائمة المنتجات",
    page2_store_productlist_description: "إدارة المخزون والمنتجات",
    page2_store_productlist_servicedescription:
      "إدارة المنتجات والمخزون بشكل محترف ودقيق وبدون عناء. كل شيء ذكي ومتوفّر مع تقارير كاملة.",
    page2_store_orders_title: "الطلبات",
    page2_store_orders_description: "إدارة الطلبات، الفواتير والشحن",
    page2_store_orders_servicedescription:
      "جميع خطوات إدارة الطلبات من التسجيل إلى إصدار الفاتورة والشحن مع تتبع تلقائي. تجربة سريعة ودقيقة وخالية من العيوب للعملاء.",
    page2_store_statistics_title: "الإحصائيات",
    page2_store_statistics_description: "أداة تحليل أداء متقدمة",
    page2_store_statistics_servicedescription:
      "تابع المبيعات والدخل واتجاهات نمو المتجر من زوايا متعددة باتخاذ قرارات ذكية بناءً على البيانات.",
    page2_delivery_smartshipping_title: "تكلفة الشحن الذكية",
    page2_delivery_smartshipping_description: "التكلفة حسب الأصل، الوجهة، الأبعاد والوزن",
    page2_delivery_smartshipping_servicedescription:
      "يتم حساب تكلفة الشحن بدقة وبشكل آلي بناءً على الأصل، الوجهة، الأبعاد والوزن. يقدم تكلفة دقيقة بدون خطأ بشري.",
    page2_delivery_postalservice_title: "الخدمة البريدية",
    page2_delivery_postalservice_description: "جمع وإرسال الطرود",
    page2_delivery_postalservice_servicedescription:
      "تُجمع طرودك بذكاء من المتجر وتُرسل إلى الوجهة بدون متابعة يدوية. تجربة لوجستية سهلة وسريعة ومنظمة.",
    page2_delivery_tracking_title: "تتبع الطرود",
    page2_delivery_tracking_description: "عرض وتتبع الطرود تلقائياً",
    page2_delivery_tracking_servicedescription:
      "تتبع تلقائي مع عرض حالة دقيقة وفورية للعملاء، مما يضمن الشفافية والثقة الكاملة.",
    page2_jobs_subadmin_title: "الأدمين المساعد",
    page2_jobs_subadmin_description: "إمكانية إضافة أدمين مساعد",
    page2_jobs_subadmin_servicedescription:
      "أضف أدمين مساعد بأمان دون مشاركة كلمة المرور واضبط صلاحيات كل شخص حسب الحاجة. تحكم كامل وأمان مضمون.",
    page2_ids_store_title: "متجر ID",
    page2_ids_store_description: "شراء وبيع معرفات إنستغرام",
    page2_ids_store_servicedescription:
      "اشترِ وبع حسابات إنستغرام بأمان مع التحقق من الهوية. تحليل دقيق، تسعير ذكي، مزادات، وتحقق من إحصائيات الصفحة—all in one place.",
    page2_publish_contentmanagement_title: "إدارة المحتوى",
    page2_publish_contentmanagement_description: "إدارة البوستات والستوريز",
    page2_publish_contentmanagement_servicedescription:
      "إدارة جميع البوستات والستوريز في منصة ذكية ومتقدمة مع الجدولة، التصنيف والنشر السريع لتجربة سهلة في إدارة السوشيال ميديا.",
    page2_publish_contentpublishing_title: "نشر المحتوى",
    page2_publish_contentpublishing_description: "نشر البوستات والستوريز المجدولة",
    page2_publish_contentpublishing_servicedescription:
      "انشر البوستات والستوريز بذكاء وفق جدول زمني. النظام يقترح أفضل وقت بناءً على تحليل سلوك المتابعين.",
    page2_publish_analytics_title: "تحليل البوست والستوري",
    page2_publish_analytics_description: "تحليل شامل للمحتوى",
    page2_publish_analytics_servicedescription:
      "احصل على رؤى عميقة لأداء المحتوى وردود فعل الجمهور وحسّن استراتيجية المحتوى الخاصة بك.",
    page2_publish_statistics_title: "الإحصائيات",
    page2_publish_statistics_description: "أدوات تحليل الأداء المتقدمة",
    page2_publish_statistics_servicedescription:
      "أدوات تحليل المحتوى الأكثر تقدماً مع تفاصيل كاملة لأداء البوستات والستوريز، رسوم بيانية وتحليلات دقيقة لاتخاذ قرارات أفضل.",
    page2_extension_biolink_title: "بایو لینک",
    page2_extension_biolink_description: "أكثر من رابط بسيط في البايو",
    page2_extension_biolink_servicedescription:
      "صفحة مخصصة وجميلة تعرض جميع روابطك المهمة مع تصميم متجاوب وتخصيص كامل، تتجاوز رابط بسيط.",
    page2_extension_paymentgateway_title: "بوابة الدفع",
    page2_extension_paymentgateway_description: "بوابة دفع مخصصة",
    page2_extension_paymentgateway_servicedescription:
      "بوابة دفع آمنة ومخصصة بدون الحاجة لمهارات تقنية، مع تقارير مفصلة وإدارة المعاملات في بيئة سهلة الاستخدام.",
    page2_extension_customwebsite_title: "موقع مخصص",
    page2_extension_customwebsite_description: "موقع مخصص يناسب صفحتك",
    page2_extension_customwebsite_servicedescription:
      "موقع مخصص يتوافق مع الهوية البصرية لصفحتك، بدون الحاجة للبرمجة. عرض منتجاتك وخدماتك بشكل احترافي وجميل.",
    page4_menu_instagram_management: "إدارة صفحة إنستغرام",
    page4_menu_admin_subadmin: "الأدمين والساب أدمين",
    page4_menu_store_shipping: "المتجر والشحن",
    page4_menu_advertising: "الإعلانات",
    page4_menu_hashtag_management: "إدارة الهاشتاغ",
    page4_menu_ai_analysis: "تحليل ذكي بالذكاء الاصطناعي",
    page4_menu_ad_scheduling: "جدولة الإعلانات",
    page4_menu_financial_wallet: "المالية والمحفظة",
    page4_menu_page_statistics: "إحصائيات الصفحة",
    page4_menu_professional_messaging: "الرسائل الاحترافية",

    page4_content_instagram_management_text:
      "إدارة جميع أجزاء صفحتك—من نشر المحتوى للرد على التعليقات والدايركت—بشكل متكامل واحترافي، بدون الحاجة لتطبيقات متعددة!",
    page4_content_admin_subadmin_text:
      "كون فريقك! عيّن أدوار مخصصة، حد من الوصول وراقب الأنشطة بدون قلق من الأخطاء البشرية.",
    page4_content_store_shipping_text:
      "متجر إنستغرام حقيقي! إدارة المخزون، الطلبات، الفواتير وتتبع الشحن من لوحة واحدة. البيع أونلاين أصبح أسهل!",
    page4_content_advertising_text:
      "صمم، نفّذ وحلل إعلانات إنستغرام بنقرات قليلة! جذب الجمهور المستهدف، قياس العائد وعدم إهدار الميزانية.",
    page4_content_hashtag_management_text:
      "اختر هاشتاغاتك بذكاء! تحليل أفضل الهاشتاغات، التخزين والتصنيف الذكي مع اقتراحات لكل منشور لزيادة المشاهدات.",
    page4_content_ai_analysis_text:
      "راقب سلوك المتابعين بدقة! اكتشف الأنماط، الاهتمامات وأوقات النشاط الذهبية بالذكاء الاصطناعي وحقق الفوز باستراتيجيتك.",
    page4_content_ad_scheduling_text:
      "اجعل إعلاناتك تعمل حتى وأنت نائم! خطط حملاتك، حدد مواعيد البداية والنهاية وازدهر بدون قلق.",
    page4_content_financial_wallet_text:
      "سيطر على جميع المعاملات! تتبع الدخل، المصروفات، رصيد المحفظة وتقارير مالية كاملة لإدارة أفضل لرأس مال صفحتك.",
    page4_content_page_statistics_text:
      "إحصائيات دقيقة وحقيقية لنمو الصفحة: معدل التفاعل، نمو المتابعين، أداء المنشورات، المشاهدات والكثير من البيانات لاتخاذ قرارات ذكية.",
    page4_content_professional_messaging_text:
      "جرّب التسويق عبر الدايركت الحقيقي! أرسل رسائل جماعية، اضبط الردود التلقائية وأدِر محادثات المتابعين باحترافية بدون ارتباك.",

    shipping: "الشحن",
    jobs: "التوظيف",
    IDstore: "متجر ID",
    page3_text1: "الحل لجميع احتياجات عملك",
    page5_whyBrancy: "لماذا برنسی؟",
    page5_title1: "شريك رسمي وآمن لإنستجرام",
    page5_title2: "نظام متكامل، توفير ذكي",
    page5_title3: "تفاعل ذكي بشكل احترافي",
    page5_title4: "لوحة تحكم متطورة وذكية",
    page5_title5: "نظام مبيعات ولوجستيات ذكي",
    page5_explain1: "إدارة ذكية بدون بيانات حساسة؛ آمن ومتوافق مع إنستغرام.",
    page5_explain2: "كل الأدوات في مكان واحد؛ ٧٠٪ تقليل تكلفة، ٨٥٪ توفير وقت.",
    page5_explain3: "ردود تلقائية بالذكاء الاصطناعي؛ ٤٠٪ تفاعل أكثر، ٩٥٪ احتفاظ بالعملاء.",
    page5_explain4: "واجهة سريعة، تحليل لحظي، مشرفين، جدولة وتقارير.",
    page5_explain5: "البيع عبر الدایرکت؛ بوابة آمنة، متجر، شحن ومخزون ذكي.",
    page5_explain6: "موقع ورابط Bio احترافي؛ بيع، حجز، سيو وشبكات.",

    page5_title6: "موقع إلكتروني ذكي مخصص",
    page9_plantitle: "اختر عدد الفالور لعرض الباقة المناسبة",

    page9_planheader: "ابدأ باحتراف واستمتع بالميزات!",
    page9_planexplain: "١٥ يوماً من الوصول الكامل والمجاني وغير المحدود!",
    page9_freeplan: "مجاني",
    page9_basicplan: "أساسي",
    page9_proplan: "محترف",
    page9_adsplan: "إعلانات",
    page9_storeplan: "متجر",
    page9_monthly: "شهريًا",
    page9_Compare: "مقارنة الخطط بالتفصيل",
    page9_content_management: "إدارة البست استوری",
    page9_analize_management: "تحليلات متقدمة وأدوات إحصائية",
    page9_message_management: "إدارة دایرکت کامنت",
    page9_biolink_management: "رابط Bio ذكي وموقع مخصص",
    page9_subadmin_management: "توظيف وإدارة الإداريين الفرعيين",
    page9_basicoption: "الميزات الأساسية",
    page9_ticket_management: "البيع عبر الدايركت والتذاكر",
    page9_finance_management: "بوابة الدفع والمحفظة",
    page9_store_management: "إدارة ذكية لمخزون المتجر",
    page9_logestic_management: "الشحن والتسليم التلقائي",
    page9_storeanalize_management: "تحليلات متقدمة",
    page9_calendar_management: "تقويم جدولة الإعلانات",
    page9_advertise_management: "إدارة الإعلانات الذكية",
    page9_adsanalize_management: "تحليلات متقدمة للإعلانات",
    page9_campagin_management: "إنشاء والمشاركة في الحملات",
    page9_adsticket_management: "إرسال تلقائي لملاحظات الإعلانات إلى العملاء",

    page6_Header: "آلاف الأعمال النشطة",
    page6_Explain: "انضمت معظم الشركات الناجحة إلى عائلة برنسی الكبيرة",
    page10_header: "ماذا يقول عملاؤنا",
    page8_HelpCenter: "مركز المساعدة",
    page8_Community: "المجتمع",
    page8_learn: "تعلم",
    page8_Blog: "المدونة",
    page8_FAQ: "الأسئلة الشائعة",
    Addfaq: "إضافة الأسئلة الشائعة",
    addfaqexplain: "يمكنك إضافة حتى 4 أسئلة شائعة",
    faqEmptyState: "سيتم عرض أسئلتك الشائعة هنا",

    page8_Support: "الدعم",
    support_Online: "الدعم عبر الإنترنت",
    support_EnterBlog: "الدخول إلى المدونة",
    page8_CommunityExplain: "تواصل مع المستخدمين الآخرين، شارك تجاربك واستفد من النصائح الجماعية للنمو المزيد.",
    page8_learnExplain:
      "في هذا القسم، ستتعلم أحدث الاستراتيجيات لاستخدام إنستغرام في الأعمال التجارية. كل ما تحتاجه لنمو عملك ستجده هنا.",
    page8_BlogExplain:
      "احصل على أحدث المقالات والمحتوى التعليمي. معلومات محدثة في مجالات الأعمال المختلفة والتسويق الرقمي بانتظارك.",
    page8_FAQExplain:
      "تم الإجابة على الأسئلة المتداولة هنا. للحصول على أي إرشادات حول الخدمات أو المنتجات، يرجى الرجوع إلى هذا القسم.",
    page8_SupportExplain: "فريق الدعم لدينا جاهز لمساعدتك. إذا كان لديك أي مشكلة أو سؤال، لا تتردد في الاتصال بنا.",
    page8_CommunityBTN: "دعونا نتعلم معًا",
    page8_learnBTN: "تعلم سريع",
    page8_BlogBTN: "آخر الأخبار",
    page8_FAQBTN: "إجابات فورية",
    page8_SupportBTN: "نحن هنا للمساعدة",
    footer_Brancy: "برنسی",
    footer_AboutUs: "من نحن",
    footer_ContactUs: "اتصل بنا",
    footer_JoinUs: "انضم إلينا",
    footer_OrgChart: "الهيكل التنظيمي",
    footer_FollowUs: "تابعنا",
    footer_Solutions: "الحلول",
    footer_HelpCenter: "مركز المساعدة",
    footer_Support: "الدعم",
    footer_FAQ: "الأسئلة الشائعة",
    footer_ReportAnIssue: "الإبلاغ عن مشكلة",
    footer_TrustLegal: "الثقة والمسائل القانونية",
    footer_TermsAndConditions: "الشروط والأحكام",
    footer_PrivacyNotice: "إشعار الخصوصية",
    footer_CookieNotice: "إشعار ملفات تعريف الارتباط",
    footer_Blog: "مدونة",
    footer_ProductUpdates: "أحدث التحديثات",
    footer_Articles: "مقالات",
    footer_LatestNews: "آخر الأخبار",
    installPromptMessage: "تثبيت تطبيق برنسی على الويب",
    install: "تثبيت",
    installStep1: "اضغط زر المشاركة في شريط الأسفل.",
    installStep2: "قم بتمرير القائمة المفتوحة للأعلى واختر Add to Home Screen.",
    installStep3: "اضغط Add في أعلى الصفحة.",
    joinUs_subtitle: "انضم إلى برنسی؛ حيث تتشكل الابتكارات والمستقبل المستدام.",
    joinUs_whyWorkWithUs: "لماذا برنسی؟",
    joinUs_whyWorkWithUsDescription:
      "برنسی ليست مجرد بيئة عمل؛ إنها منصة استراتيجية للنمو المهني والشخصي. نحن نؤمن بأن المؤسسات الرائدة تُبنى بالمواهب المتميزة. التزامنا هو خلق بيئة ديناميكية وشفافة وداعمة لتمكين أعضاء الفريق من ترك تأثير دائم.",
    joinUs_openPositions: "الوظائف الشاغرة",
    joinUs_openPositionsDescription: "استكشف الفرص المتاحة واختر الدور الذي يتناسب مع خبرتك ومسارك المهني.",
    joinUs_frontendDeveloper: "مطور Frontend",
    joinUs_frontendDeveloperDescription:
      "تصميم وتنفيذ تجارب مستخدم حديثة باستخدام React وTypeScript. دور أساسي في تحسين جودة وكفاءة المنتجات.",
    joinUs_backendDeveloper: "مطور Backend",
    joinUs_backendDeveloperDescription:
      "تصميم وتطوير أنظمة قابلة للتوسع وآمنة باستخدام Node.js والتقنيات السحابية. يتطلب تفكيراً نظامياً وحلاً للمشكلات المعقدة.",
    joinUs_uiUxDesigner: "مصمم UI/UX",
    joinUs_uiUxDesignerDescription:
      "ابتكار واجهات قياسية وتجارب بديهية لضمان رضا وولاء المستخدمين. الانتباه للتفاصيل والإبداع ضروري.",
    joinUs_productManager: "مدير المنتج",
    joinUs_productManagerDescription:
      "قيادة استراتيجية المنتج وتنسيق الفرق لتقديم حلول تنافسية وفعالة. مثالي للأشخاص ذوي الرؤية التحليلية وقدرة إدارة أصحاب المصلحة.",
    joinUs_marketingSpecialist: "أخصائي التسويق",
    joinUs_marketingSpecialistDescription:
      "التخطيط وتنفيذ الحملات الرقمية وتعزيز مكانة العلامة التجارية. مزيج من المهارات التحليلية والإبداع.",
    joinUs_customerSupport: "أخصائي دعم العملاء",
    joinUs_customerSupportDescription:
      "تقديم دعم احترافي، وحل المشكلات، وتحسين تجربة المستخدم. يتطلب دقة وصبراً ومهارات تواصل قوية.",
    joinUs_engineering: "الهندسة",
    joinUs_design: "التصميم",
    joinUs_product: "المنتج",
    joinUs_marketing: "التسويق",
    joinUs_support: "الدعم",
    joinUs_remoteOnsite: "عن بُعد / حضوري",
    joinUs_onsite: "حضوري",
    joinUs_remote: "عن بُعد",
    joinUs_fullTime: "دوام كامل",
    joinUs_partTimeFullTime: "دوام جزئي / كامل",
    joinUs_applyNow: "قدّم الآن",
    joinUs_applicationProcess: "عملية التوظيف في برنسی",
    joinUs_submitApplication: "إرسال الطلب",
    joinUs_submitApplicationDescription: "أرسل سيرتك الذاتية ومهاراتك. سيقوم فريقنا بمراجعتها بعناية.",
    joinUs_initialScreening: "الفرز الأولي",
    joinUs_initialScreeningDescription:
      "يقوم قسم الموارد البشرية بمراجعة السير الذاتية خلال ٣ إلى ٥ أيام عمل ويتواصل إذا كان هناك تطابق.",
    joinUs_technicalInterview: "المقابلة الفنية",
    joinUs_technicalInterviewDescription: "تقييم المعرفة والخبرة الفنية من خلال مقابلات متخصصة مع الفرق.",
    joinUs_finalInterview: "المقابلة النهائية",
    joinUs_finalInterviewDescription: "جلسة نهائية مع المدراء التنفيذيين والفرق الرئيسية لضمان توافق الأهداف والقيم.",
    joinUs_welcomeAboard: "مرحباً بك",
    joinUs_welcomeAboardDescription: "بعد القبول، تبدأ عملية الانضمام الشاملة لتعريفك بثقافة وأهداف المنظمة.",
    joinUs_readyToJoinUs: "هل لم تجد المنصب الذي ترغب به؟",
    joinUs_readyToJoinUsDescription:
      "نرحب دائماً بالأفراد المهرة والمتحمسين. أرسل سيرتك الذاتية ووضح رؤيتك للتعاون مع برنسی.",
    joinUs_sendYourResume: "أرسل سيرتك الذاتية",

    aboutUs_pageTitle: "عن برنسی",
    aboutUs_metaDescription:
      "تعرّف على برنسي، منصة شاملة ودولية لإدارة شبكات التواصل الاجتماعي والأعمال الرقمية؛ حيث يلتقي الابتكار والثقة والنمو المستدام لصنع مستقبل الاقتصاد الرقمي.",
    aboutUs_subtitle: "الإدارة الذكية للاقتصاد الرقمي مع برنسي",
    aboutUs_ourStoryTitle: "قصتنا",
    aboutUs_ourStoryPara1:
      "وُلدت برنسي بهدف إعادة تعريف إدارة الأعمال عبر الإنترنت؛ نقطة يلتقي فيها التكنولوجيا المتقدمة مع الاحتياجات الحقيقية لأصحاب الأعمال. نحن لا نقدّم مجرد أداة، بل أنشأنا بيئة تمكّن الأعمال من العمل كمنظمة كبيرة واحترافية.",
    aboutUs_ourStoryPara2:
      "هذا الطريق تأسس على إيمان: يجب أن تسهّل التكنولوجيا نمو الإنسان والأعمال، لا أن تكون عائقًا أمامها.",
    aboutUs_innovationTitle: "الابتكار كميزة أساسية",
    aboutUs_innovationPara1:
      "تستفيد برنسي من الذكاء الاصطناعي، والبيانات الضخمة، وتقنيات الويب الحديثة لتقديم تجربة سلسة وآمنة وفعّالة للمستخدمين. كل ميزة مصممة مع التركيز على البساطة والإنتاجية القصوى.",
    aboutUs_innovationPara2:
      "بالنسبة لنا، الابتكار لا يقتصر على التكنولوجيا؛ بل هو نهج استراتيجي متجذر في ثقافتنا التنظيمية ورؤيتنا للمستقبل.",
    aboutUs_coreValuesTitle: "قيمنا الأساسية",
    aboutUs_innovationFirstTitle: "الريادة في الابتكار",
    aboutUs_innovationFirstDesc: "نحن دائمًا في سعي لتقديم حلول تلبي احتياجات مستقبل الأعمال الرقمية.",
    aboutUs_trustSecurityTitle: "الثقة والأمان",
    aboutUs_trustSecurityDesc: "أمن البيانات وشفافية العمليات هي أولويتنا ليتمكن المستخدمون من النمو بثقة كاملة.",
    aboutUs_globalCommunityTitle: "مجتمع عالمي",
    aboutUs_globalCommunityDesc: "برنسي تتجاوز الحدود الجغرافية وتربط منظومة عالمية من الأعمال والمتخصصين.",
    aboutUs_sustainableGrowthTitle: "النمو المستدام",
    aboutUs_sustainableGrowthDesc:
      "نحن ملتزمون بالتوسع الذكي والمستدام المتوافق مع المبادئ الأخلاقية والمسؤولية الاجتماعية.",
    aboutUs_userEmpowermentTitle: "تمكين المستخدمين",
    aboutUs_userEmpowermentDesc: "توفر أدواتنا البديهية ومواردنا التعليمية وصولًا متساويًا إلى الفرص الرقمية للجميع.",
    aboutUs_continuousEvolutionTitle: "التطور المستمر",
    aboutUs_continuousEvolutionDesc:
      "في عالم ديناميكي، التغيير جزء من مسارنا. نحن نتقدم دائمًا بالتعلم والتحسين المستمر.",
    aboutUs_globalImpactTitle: "الأثر العالمي",
    aboutUs_globalImpactPara:
      "اليوم، برنسي منصة تمكّن الملايين من رواد الأعمال والأعمال؛ جسر بين الفرص الرقمية ومستقبل بلا حدود.",
    aboutUs_activeUsers: "المستخدمون النشطون",
    aboutUs_countries: "الدول المشمولة",
    aboutUs_uptime: "توفر النظام",
    aboutUs_support: "دعم مخصص",
    aboutUs_teamTitle: "فريق برنسي",
    aboutUs_teamPara1:
      "فريقنا مزيج من خبراء التكنولوجيا، والاستراتيجيين، والمبدعين من جميع أنحاء العالم، اجتمعوا بهدف مشترك وهو تطوير الاقتصاد الرقمي.",
    aboutUs_teamPara2:
      "من خبرة رواد الصناعة إلى طاقة المواهب الشابة، نحن في برنسي نقود حركة عالمية تشكل جيلًا جديدًا من التجارة الرقمية.",

    // #region  landing page
    Dashboard: "لوحة التحكم",
    greeting1: "الشمس استيقظت معك،",
    greeting2: "صباح مليء بالطاقة،",
    greeting3: "يومك سعيد،",
    greeting4: "مساء الخير،",
    greeting5: "مساء ذهبي سعيد،",
    greeting6: "الليل قريب",
    greeting7: "تصبح على خير وهدوء،",
    greetingtext1: "الصباح الباكر حقًا سحري🌅",
    greetingtext2: "العالم في انتظار خطواتك 💪",
    greetingtext3: "وقت الشاي والابتسامة ☕😊",
    greetingtext4: "استمتع بطعامك اللذيذ 🍽️",
    greetingtext5: "الشمس لا تزال في السماء، امض قدمًا 🌟",
    greetingtext6: "اصنع نهاية رائعة 🌇",
    greetingtext7: "احلم كبيرًا وابدأ غدًا🌙",
    userpanel_yourorders: "طلباتك",
    userpanel_SavedProducts: "المنتجات المحفوظة",
    userpanel_NoSavedProducts: "لا توجد منتجات محفوظة متاحة.",
    userpanel_Startexplore: "ابدأ الاستكشاف بين الملايين",
    userpanel_Startexploreexplain: "الأسواق، المنتجات والصفحات",
    userpanel_TicketSupportExplain: "تتبع الطلب، محادثة مع البائع",
    userpanel_TicketSupport: "تواصل من خلال التذكرة",

    userpanel_UseInstagram: "إدارة Instagram باحترافية.",
    userpanel_FreeProPanel: "ProPanel مجاني",
    userpanel_Premiumaccount: "حساب بريميوم",
    userpanel_daysFreePremium: "٤٠ يوم بريميوم مجاني",
    userpanel_LimitedOffer: "عرض محدود!",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "اللون",
    button: "زر",
    Liter: "لتر",
    FrontFace: "الوجه الأمامي",
    SideFace: "الوجه الجانبي",
    TopFace: "الوجه العلوي",
    Area: "المساحة",
    Perimeter: "المحيط",
    Volume: "الحجم",
    inSystem: "في النظام",
    sending: "إرسال",
    uploadsRemaining: "المتبقي للرفع",
    logoutExplain: "أنت تحاول تسجيل الخروج من برنسی",
    welcomeToBrancy: "مرحبًا بك في برانسي!",
    notloginexplain: "لاستخدام خدمات برانسي، يرجى ربط حساب إنستغرام الخاص بك.",
    welcomeToBrancyExplain: "أدخل معرّف إنستغرام الخاص بك لإعداد لوحة الإدارة النهائية.",
    welcomeToBrancyExplainPhone: "أدخل رقم هاتفك لإعداد لوحة الإدارة النهائية.",
    loginWithGoogle: "دخول Google",
    loginWithMobile: "دخول SMS",

    or: "أو",
    InstagramID: "اسم المستخدم (ID) في إنستغرام",
    EmptyNotification: "لا توجد إشعارات بعد",
    Notification_NewMessage: "لديك رسالة جديدة من {{sender}}",
    Notification_NewOrder: "لديك طلب جديد من {{sender}}",
    Notification_ImagesCreatedBy: "تم إنشاء صورك بنجاح بواسطة نموذج {{version}}.",
    Notification_VideoCreatedBy: "تم إنشاء فيديوك بنجاح بواسطة نموذج {{version}}.",
    Notification_MediaCreationFailed: "فشل إنشاء الوسائط بواسطة نموذج {{version}}: {{metadata}}",
    Notification_VideoCreationFailed: "فشل إنشاء الفيديو بواسطة نموذج {{version}}: {{metadata}}",
    Notification_NewPost: "منشور جديد",
    Notification_UploadPostFailed: "فشل رفع المنشور",
    Notification_NewStory: "قصة جديدة",
    Notification_UploadStoryFailed: "فشل رفع القصة",
    Notification_NewVideo: "فيديو جديد",
    Notification_VideoCreationFailedTitle: "فشل إنشاء الفيديو",
    Notification_YouHaveNewMessage: "لديك رسالة جديدة",
    Notification_AccountDeauthorized: "تم إلغاء ترخيص حساب إنستغرام",
    EnterYourText: "أدخل نصك",
    EnterYourphonenumber: "أدخل رقم هاتفك",
    CopyText: "نسخ النص",
    successfulCopy: "تم النسخ",
    download: "تحميل",
    automatic: "تلقائي",
    manual: "يدوي",
    phonenumber: "رقم الهاتف",
    SendVerificationCode: "إرسال الرمز",
    ShowUserDashboard: "الانتقال إلى لوحة التحكم",
    VerificationCode: "رمز التحقق",
    VerificationCodeExplain: "يرجى إدخال رمز التحقق المرسل إلى هاتفك.",
    remainingTime: "الوقت المتبقي",
    createtime: "وقت الإنشاء",
    ResendVerificationCode: "إعادة إرسال رمز التحقق",
    VerifyCode: "تحقق من الرمز",
    Verify: "تأكيد",
    VerifyAddress: "تأكيد العنوان",
    Continue: "متابعة",
    metaRedirect_aiAnalysisNotice: "يرجى ملاحظة أن تحليل صفحتك باستخدام الذكاء الاصطناعي قد يستغرق عدة ساعات.",
    Efficiency: "الكفاءة",
    logout: "تسجيل الخروج",
    notallowed: "غير مسموح",
    notallowedExplain: "غير مسموح لك بالوصول إلى هذه الميزة",
    notallowedExplainPage: "غير مسموح لك بالوصول إلى هذه الصفحة",
    CreateAutomationFlow: "إنشاء تدفق الأتمتة",
    CreateAutomationFlowExplain: "قم بأتمتة تفاعلات إنستغرام باستخدام مُنشئ سير عمل مرئي.",
    CreateAutomationAI: "إنشاء ذكاء اصطناعي للأتمتة",
    CreateAutomationAIExplain: "قم بأتمتة تفاعلات إنستغرام من خلال الردود المدفوعة بالذكاء الاصطناعي.",
    flowProperties_notworking_privateReply:
      "⚠️ ملاحظة: لا يعمل هذا الفلو في المحادثات الخاصة مع الأصدقاء، ويُستخدم فقط للرد التلقائي على التعليقات ورسائل Direct",
    flowProperties_privateReply_requiresFollower:
      "لا يمكن استخدام هذا الفلو للردود الخاصة. لتفعيله، فعّل خيار «يجب أن يتابع المستخدم الصفحة» في الإعدادات.",

    max: "الحد الأقصى",
    needPass: "التأكيد والتفعيل",
    needPassExplain: "للوصول الكامل إلى هذه الميزة، يلزم كلمة مرور حساب إنستجرام",
    soon: "قريبًا",
    soonExplain: "هذه الميزة ستكون متاحة قريبًا",
    underdevelop: "قيد التطوير",
    reject: "رفض",
    rejected: "تم الرفض",
    approved: "تم الرفض",
    ExpirationTime: "وقت الانتهاء",
    send: "إرسال",
    accept: "قبول",
    selectall: "تحديد الكل",
    General: "عام",
    Business: "الأعمال",
    undo: "التراجع",
    redo: "إعادة",
    total: "المجموع الكلي",
    Unknown: "غير معروف",
    close: "إغلاق",
    closed: "مغلق",
    admin: "المشرف",
    user: "المستخدم",
    stop: "إيقاف",
    save: "حفظ",
    discard: "تجاهل",
    all: "الكل",
    update: "تحديث",
    like: "لايك",
    dislike: "إلغاء الإعجاب",
    next: "التالي",
    cancel: "إلغاء",
    canceled: "تم الإلغاء",
    comment: "تعليق",
    mention: "منشن",
    add: "إضافة",
    icon: "أيقونة",
    copylist: "نسخ القائمة",
    reply: "رد",
    replies: "الردود",
    PrivateReply: "رد خاص",
    copy: "نسخ",
    everywhere: "في كل مكان",
    UnHide: "إظهار",
    show: "عرض",
    Hide: "إخفاء",
    pageSummary: "ملخص الصفحة",
    summaryGeneralIntro: "نظرة عامة على الصفحة",
    summaryUserEngagement: "تحليل تفاعل المستخدمين",
    summaryContentStrategy: "مراجعة استراتيجية المحتوى",
    summaryPostingSchedule: "تقييم جدول النشر",
    summaryImprovementSuggestions: "اقتراحات التحسين والنمو",
    Ignore: "تجاهل",
    Orange: "برتقالي",
    Purple: "أرجواني",
    Green: "أخضر",
    White: "أبيض",
    DarkGray: "رمادي داكن",
    Blue: "أزرق",
    LightGray: "رمادي فاتح",
    Brown: "بني",
    Pink: "وردي",
    Yellow: "أصفر",
    Silver: "فضي",
    Black: "أسود",
    Red: "أحمر",
    select: "اختر",
    back: "رجوع",
    start: "ابدأ",
    country: "الدولة",
    device: "الجهاز",
    yourdevice: "جهازك",
    otherdevice: "جهاز آخر",
    SessionID: "معرف الجلسة",
    header: "العنوان",
    upload: "رفع",
    active: "نشط",
    activate: "تفعيل",
    activateAll: "تفعيل الكل",
    DeactivateAll: "تعطيل الكل",
    signout: "تسجيل الخروج",
    switchaccount: "تبديل الحساب",
    instagramConnect: "اتصال حساب إنستغرام",
    CollaboratorExplain: "مشاركة Post أو Reels بشكل مشترك بين عدة صفحات إنستغرام",
    Renew_Subscription: "تجديد الاشتراك",
    upgrade: "ترقية",
    deactive: "غير نشط",
    Deactivate: "تعطيل",
    done: "تم",
    text: "نص",
    PlaceHolder: "يتم الكتابة...",
    media: "فيديو/صورة",
    ReplyStory: "رد على Story",
    photo: "صورة",
    audio: "رسالة صوتية",
    Generic: "عام",
    StoryMention: "منشن في Story",
    FileShare: "ملف",
    voice: "صوتي",

    abort: "إلغاء",
    Pending: "قيد الانتظار",
    Preparing: "جاري التحضير",
    Finished: "منتهي",
    finish: "إنهاء",
    exportJPG: "تصدير JPG",
    exportPDF: "تصدير PDF",
    exportXlxs: "تصدير Excel",
    dismiss: "رفض",
    empty: "فارغ",
    searching: "...جارٍ البحث ",
    searchMessage: "ابحث عن أشخاص أو كلمة مفتاحية",
    searchKeyword: "ابحث عن كلمة مفتاحية",
    Recommended: "موصى به",
    VERFIED: "تم التحقق",
    SuccessADS: "نجاح الإعلانات",
    SuccessSALES: "نجاح المبيعات",
    StartOrder: "ابدأ الطلب",
    Startshoping: "ابدأ التسوق",
    question: "سؤال",
    Answer: "إجابة",
    shareStory: "مشاركة استوري",
    search: "بحث",
    searchLocation: "بحث عن موقع",
    searchPeople: "بحث عن أشخاص",
    edit: "تحرير",
    delete: "حذف",
    deletecover: "حذف الغلاف",
    details: "تفاصيل",
    Insights: "إحصاءات",
    new: "جديد",
    comments: "تعليقات",
    nocomment: "لا توجد تعليقات",
    SimilarProducts: "منتجات مشابهة",
    QandA: "الأسئلة",
    caption: "التسمية التوضيحية",
    collaborator: "صفحة المتعاون",
    collaboratorpost: "منشور المتعاون",
    sidebar_Home: "المنزل",
    sidebar_Page: "إدارة الصفحة",
    sidebar_Message: "الرسائل",
    sidebar_Wallet: "محفظة",
    sidebar_biolink: "رابط البايو",
    sidebar_Advertise: "إعلانات",
    sidebar_Store: "متجر",
    sidebar_Stores: "المتاجر",
    sidebar_Business: "الأعمال",
    sidebar_Setting: "الإعدادات",
    //0️⃣ General -> navbar
    navbar_Post: "منشور",
    navbar_Live: "بث مباشر",
    navbar_Story: "استوری",
    navbar_Feed: "فید",
    navbar_Reels: "ریلز",
    navbar_Statistics: "الإحصاءات",
    navbarTools: "أدوات",
    navbar_Direct: "الرسائل",
    navbar_Comments: "تعليقات",
    navbar_Ticket: "تذاكر",
    navbar_AI: "الذكاء الاصطناعي",
    navbar_ContentCreator: "صانع المحتوى",
    navbar_Properties: "الخصائص",
    navbar_AIAndFlow: "الذكاء الاصطناعي و ایجنت",
    navbar_Payment: "المدفوعات",
    navbar_Title: "عنوان",
    navbar_Home: "الرئيسية",
    navbar_Biolink: "رابطى",
    navbar_Calendar: "التقويم",
    navbar_AdList: "قائمة الإعلانات",
    navbar_General: "عام",
    navbar_SubAdmin: "المديرين الفرعيين",
    navbar_HelpCenter: "المساعدة والدعم",

    addnewaccount: "إضافة حساب",
    addedaccounts: "الحسابات المضافة",
    SwitchtoAccountexplain: "جميع حساباتك المضافة في البرنسی تظهر هنا",
    SwitchtoAccount: "الدخول إلى الحساب",
    accountmanagement: "إدارة الحساب",
    subadmininvitation: "دعوة تعاون",
    subadmininvitationexplain: "دعوة لإدارة إنستغرام كمشرف مساعد",

    navbar_Products: "المنتجات",
    navbar_Orders: "الطلبات",
    navbar_totalOrders: "إجمالي الطلبات",
    //0️⃣ countdown
    countdown_Days: "يوم",
    countdown_Hours: "ساعة",
    countdown_Minutes: "دقيقة",
    Expired: "منتهي",
    justnow: "الآن",
    LessThanAMinute: "أقل من دقيقة",
    ExpiresIn: "ينتهي خلال",

    ExportPDF: "تصدير PDF",
    ExportJPG: "تصدير JPG",
    ShareTo: "مشاركة إلى",
    Expand: "توسيع",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "طلبات متابعة",
    home_UnreadNewComments: "تعليقات جديدة غير مقروءة",
    home_Last24H: "آخر ٢٤ ساعة",
    home_Last30Days: "خلال آخر ٣٠ يومًا",
    home_LastLikes: "إعجابات جديدة",
    home_LastPost: "آخر منشور",
    home_Followings: "الذين تتابعهم",
    home_Followers: "متابعين",
    AudienceLocation: "موقع الجمهور النشط",
    AudienceGender: "جنس الجمهور النشط",
    AudienceAge: "عمر الجمهور النشط",

    AudienceGenderStats: "لديك {{female}} من الإناث، و{{male}} من الذكور، و{{unknown}} غير محددين الجنس",

    AudienceAgeStats:
      "معظم جمهورك من الفئة العمرية {{ageRange}} ({{percentage}}%) لذا يجب أن يكون المحتوى جذاباً ومناسباً للفئة {{ageCategory}}.",

    AgeCategoryYoung: "الشباب",
    AgeCategoryMiddleAged: "متوسطي العمر",
    AgeCategoryOlder: "كبار السن",

    AudienceLocationStats:
      "أكثر جمهورك النشط من دولة {{country}} بعدد {{countryCount, number}} أشخاص، ومن مدينة {{city}} بعدد {{cityCount, number}} أشخاص",

    // 1️⃣ Home -> last like
    lastLike: "آخر إعجابات",
    // 1️⃣ Home -> last message
    lastMessage: "آخر الرسائل",
    lastOrder: "آخر الطلبات",
    lastTransaction: "آخر المعاملات",
    // 1️⃣ Home -> last follower
    LastFollowers: "آخر المتابعين",
    // #endregion home Section
    // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "إنشاء منشور جديد",
    Postnotvisible: "هل لا يظهر الـ Post؟",
    Storynotvisible: "هل لا تظهر الـ Story؟",
    SmartPageAnalysis: "تحليلات ذكية للصفحة",
    EducationAndGuidance: "التعليم والإرشاد",
    HowToUseBrancy: "كيفية استخدام برنسی",
    BrancyKnowsYou: "برنسی يعرفك",
    BrancyKnowsYouExplain:
      "يقوم برنسی بتحليل صفحتك بعمق لبناء صورة متكاملة عن هويتك الرقمية؛ بدءًا من شخصيتك وعملك وأنشطتك، وصولًا إلى نبرة وأسلوب تواصلك، ونوع المحتوى، وطريقة تقديمه، وأوقات النشر، وأسلوب تفاعلك مع جمهورك.\n\nويأخذ هذا التحليل أيضًا في الاعتبار طريقة تفاعلك عبر جميع نقاط التواصل في صفحتك؛ بدءًا من الرد على التعليقات والرسائل المباشرة، وصولًا إلى أسلوب الكتابة، وطريقة التعامل مع الجمهور، والاستجابة للمواقف المختلفة.\n\nدون الحاجة إلى تدريب يدوي أو ضبط نبرة الصوت أو إدخال معلومات إضافية؛ برنسی يعرفك وينسّق الذكاء الاصطناعي وفق هويتك وأسلوبك الحقيقي.",
    CreateYourDigitalVersion: "إنشاء نسختك الرقمية",
    CreateNewStrory: "إنشاء قصة جديدة",
    PostDraft: "مسودة المنشور",
    StoryDraft: "مسودة القصة",
    publishError: "خطأ في النشر",
    DeletedPost: "منشور محذوف",
    errorDraft_title: "حدث خطأ أثناء نشر المنشور",
    errorDraft_configFailed: "إعدادات نشر المنشور غير صحيحة، يرجى التحقق والتصحيح.",
    errorDraft_invalidTags: "الوسوم غير الصالحة: ",
    errorDraft_unknown: "خطأ غير معروف! يرجى المحاولة مرة أخرى.",
    errorDraft_uploadError: "فشل تحميل الصورة، يرجى المحاولة مرة أخرى.",
    errorDraft_userCancel: "تم إلغاء نشر المنشور من قبلك.",
    InvalidAspectRatio: "نسبة الأبعاد غير صالحة",
    SizeLimitExceed: "حجم الملف يتجاوز الحد المسموح",
    UnSupportMediaType: "نوع الوسائط غير مدعوم",
    NotPublishedAtTheTime: "لم يتم نشر المنشور في الوقت المحدد",
    NotSuccessLogin: "فشل في تسجيل الدخول",

    NewScheduledPost: "منشور مجدول جديد",
    thereAreNoPost: "لم تقم بإنشاء أي Post مجدول بعد",
    ScheduledPost: "منشور مجدول",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "إنشاء قصة جديدة",
    pageStory_CreateNewStories: "قصة مجدولة جديدة",
    pageStory_thereAreNoStories: "لم تقم بإنشاء أي Story مجدولة بعد",
    pageStory_ScheduledStories: "قصة مجدولة",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "إدارة أبرز النقاط",
    pageStory_thereAreNoHighlight: "لا توجد أبرز النقاط",
    pageStory_HighlightTitle: "أبرز النقاط / المجلدات",
    pageStatistics_YourBestFollowers: "أفضل المتابعين لديك",
    pageStatistics_YourBestFollowersExplain:
      "يتم حسابه بناءً على مجموع تفاعل الصفحة بالكامل (بما في ذلك الإعجابات، التعليقات، والمشاركات).",
    pageStatistics_LoadMore: "تحميل المزيد",
    pageStatistics_UnFollowers: "إلغاء المتابعة",
    pageStatistics_Followers: "المتابعين",
    pageStatistics_NewFollowers: "المتابعين الجدد",
    pageStatistics_ActiveFollowers: "المتابعين النشطين",
    pageStatistics_MediaFollows: "متابعات الوسائط",
    pageStatistics_Reach: "الوصول",
    pageStatistics_ProfileVisit: "زيارات الملف الشخصي",
    pageStatistics_30Days: "٣٠ يوم",
    pageStatistics_60Days: "٦٠ يوم",
    pageStatistics_90Days: "٩٠ يوم",
    pageStatistics_120Days: "١٢٠ يوم",
    pageStatistics_WorstTime: "أسوأ وقت",
    pageStatistics_BestTime: "أفضل وقت",
    pageStatistics_likes: "إعجابات",
    pageStatistics_Engagements: "تفاعلات",
    pageStatistics_Impression: "الإنطباع",
    pageStatistics_Views: "مشاهدات",
    pageStatistics_RePosts: "إعادة النشر",
    pageStatistics_followerViews: "فالورز الزوار",
    pageStatistics_ghostViewers: "المشاهدون الخفيون",
    pageStatistics_Comments: "تعليقات",
    pageStatistics_Shares: "مشاركات",
    pageStatistics_summary: "ملخص",
    pageStatistics_EmptyList: "!لا توجد بيانات بعد",
    pageStatistics_from: "مقارنة بـ",
    pageStatistics_post: "المنشورات",
    pageStatistics_stories: "القصص",
    pageStatistics_MaxView: "أقصى وصول",
    pageStatistics_MinView: "أدنى وصول",
    pageStatistics_MaxCommentLike: "أقصى عدد تعليقات و إعجابات",
    pageStatistics_MinCommentLike: "أدنى عدد تعليقات و إعجابات",
    pageStatistics_PostTimeAnalysis: "تحليل وقت المنشورات",
    pageStatistics_Rate: "المعدل",
    pageStatistics_RateExplain: "بناءً على أعلى عدد من التعليقات المستلمة عبر الصفحة بالكامل",
    pageStatistics_24HourHeatmap: "الخريطة الحرارية لمدة 24 ساعة",
    pageStatistics_Low: "منخفض",
    pageStatistics_High: "عالٍ",
    pageStatistics_TopHour: "الساعة الأفضل",
    pageStatistics_WeakHour: "الساعة الأضعف",
    pageStatistics_AverageHour: "الساعة المتوسطة",
    pageStatistics_TopMinute: "الدقيقة الأفضل",
    pageStatistics_WeakMinute: "الدقيقة الأضعف",
    pageStatistics_AverageMinute: "الدقيقة المتوسطة",
    pageStatistics_HourExcellentLevel:
      "هذه الساعة تمتلك مستوى تفاعل ممتاز (أكثر من 80% من السعة). التفاعل في هذه الفترة أعلى من المتوسط بنسبة {{percentage}}%، مما يجعلها مثالية لنشر المحتوى المهم.",
    pageStatistics_HourGoodLevel:
      "هذه الساعة تمتلك مستوى تفاعل جيد (60–80% من السعة). التفاعل في هذه الفترة أعلى من المتوسط بنسبة {{percentage}}%، وهي مناسبة لنشر المحتوى العادي.",
    pageStatistics_HourAverageLevel:
      "هذه الساعة تمتلك مستوى تفاعل متوسط (40–60% من السعة). للحصول على نتائج أفضل، يُنصح بتجربة الساعات ذات الشدة الأعلى (اللون الأخضر). الفرق عن أفضل وقت: {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "هذه الساعة تمتلك مستوى تفاعل ضعيف (20–40% من السعة). يُنصح بالنشر خلال الساعات ذات الشدة الأعلى.",
    pageStatistics_HourVeryWeakLevel:
      "هذه الساعة تمتلك مستوى تفاعل ضعيف جدًا (أقل من 20% من السعة). التفاعل منخفض عن المتوقع ولا يُنصح بالنشر.",
    pageStatistics_MinuteTopDescription:
      "هذه الدقيقة من ضمن أفضل 10 دقائق في ساعة {{hour}}:00. للحصول على أقصى تفاعل، يُنصح بالنشر في هذا الوقت بالضبط. الفرق عن أضعف دقيقة: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "التفاعل في هذه الدقيقة منخفض. النشر في الدقائق الأولى أو المتوسطة من الساعة قد يعطي نتائج أفضل. الفرق عن أفضل دقيقة: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "التفاعل في هذا الوقت متوسط. لتحسين النتائج، قم بمراجعة الدقائق ذات التصنيف الأعلى في هذه الساعة.",
    pageStatistics_PeakEngagement: "أعلى مستوى للتفاعل",
    pageStatistics_StableGrowth: "نمو ثابت",
    pageStatistics_HighEngagementProbability: "احتمال تفاعل مرتفع",
    pageStatistics_LowestEngagement: "أقل تفاعل لحظي",
    pageStatistics_SustainedLowPeriod: "فترة انخفاض مستمر",
    pageStatistics_LowEngagementProbability: "احتمال تفاعل منخفض",
    pageStatistics_BestTimes: "أفضل الأوقات",
    pageStatistics_WorstTimes: "أسوأ الأوقات",
    pageStatistics_EngagementPrediction: "توقع التفاعل",
    pageStatistics_PeakTimeDescription:
      "أعلى نسبة تفاعل تحدث في هذه اللحظة. يُنصح بالنشر في هذا الوقت للوصول إلى أكبر عدد من الجمهور.",
    pageStatistics_StableTimeDescription:
      "من هذا الوقت يبدأ التفاعل بالارتفاع ويظل فوق المتوسط. مناسب للحصول على تفاعل مستقر.",
    pageStatistics_SecondaryTimeDescription: "يمكن توقع نتائج جيدة عند النشر في هذا الوقت.",
    pageStatistics_LowestTimeDescription:
      "أقل تفاعل لحظي يحدث في هذا الوقت. النشر في هذه الساعة يؤدي لفقدان {{percentage}}% من التفاعل المحتمل.",
    pageStatistics_SustainedLowTimeDescription:
      "يبدأ التفاعل بالانخفاض من هذا الوقت ويظل منخفضًا لفترة. لا يُنصح بالنشر.",
    pageStatistics_SecondaryLowTimeDescription: "لحظة ضعيفة أخرى باحتمال تفاعل منخفض. لا يُنصح بالنشر في هذا الوقت.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} تفاعل ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} تفاعل",

    // statistics suggestions box
    Statistics_UnFollowers_up_title: "انخفاض في عدد الـUnfollowers💡 حان الوقت لتعزيز استراتيجية الحفاظ",
    Statistics_UnFollowers_up_summary:
      "الانخفاض قلّ، وهذا يعني أن المحتوى الأخير كان فعالًا. استمر في هذا المسار بدقة أكبر.",
    Statistics_UnFollowers_up_action1: "حلّل آخر ثلاث Posts من حيث الغلاف، السطر الأول، وCTA.",
    Statistics_UnFollowers_up_action2: "أنشئ تقويمًا أسبوعيًا بناءً على هذه الصيغ وسجّل التغييرات.",
    Statistics_UnFollowers_up_action3: "اصنع Story ترحيبية وHighlight منسق للـFollowers الجدد.",
    Statistics_UnFollowers_up_urgency: "متوسط",

    Statistics_UnFollowers_neutral_title: "ثبات معدل الانفولو 💡اجمع بيانات من المستخدمين قبل أي تغيير",
    Statistics_UnFollowers_neutral_summary: "سلوك الجمهور لم يتغير؛ عليك قياس آرائهم مباشرة والقيام باختبارات قصيرة.",
    Statistics_UnFollowers_neutral_action1: "ضع Story فيها استطلاع لمعرفة ما الذي يجذبهم أكثر.",
    Statistics_UnFollowers_neutral_action2: "انشر Post واحد أسبوعيًا بصيغة ثابتة وقارن النتائج.",
    Statistics_UnFollowers_neutral_action3: "اجمع أكثر ثلاث مشكلات مذكورة في الـComments وأنشئ Post لحل كل واحدة.",
    Statistics_UnFollowers_neutral_urgency: "منخفض",

    Statistics_UnFollowers_down_title: "زيادة في الأنفالور 💡تحتاج إلى تصحيح سريع",
    Statistics_UnFollowers_down_summary:
      "ارتفاع الأنفالور يعني وجود إشارة سلبية في المحتوى أو وتيرة النشر؛ تحتاج لاختبار سريع وردّ فعل فوري.",
    Statistics_UnFollowers_down_action1:
      "تحقّق من بيانات آخر 7 أيام وحدّد المنشورَين اللذين سبّبا أكبر عدد من الأنفالور.",
    Statistics_UnFollowers_down_action2: "انشر منشورًا صادقًا أو خلف الكواليس واسأل الجمهور مباشرة عن السبب.",
    Statistics_UnFollowers_down_action3: "انشر Story سؤال مفتوح: «ليش عملت Unfollow؟» وصنّف الإجابات.",
    Statistics_UnFollowers_down_urgency: "عالٍ",

    Statistics_UnFollowers_zero_title: "لا يوجد نشاط مسجّل 💡لا توجد بيانات للتحليل",
    Statistics_UnFollowers_zero_summary:
      "بسبب غياب النشاط، لا توجد أي إشارات للتحليل؛ يجب أولاً إعادة تشغيل دورة النشر.",
    Statistics_UnFollowers_zero_action1: "انشر منشورًا ذا قيمة لإنشاء أول إشارة سلوكية.",
    Statistics_UnFollowers_zero_action2: "انشر Story تفاعلية (Poll أو Question) للحصول على تفاعل أولي.",
    Statistics_UnFollowers_zero_action3: "انشر منشورًا قصيرًا للتعريف أو التحديث لبدء الوصول الطبيعي.",
    Statistics_UnFollowers_zero_urgency: "عالٍ",

    Statistics_Followers_up_title: "زيادة المتابعين 💡رحّب بالداخلين بشكل صحيح",
    Statistics_Followers_up_summary:
      "النمو في ارتفاع؛ من لحظة دخولهم يجب أن تبني لهم تجربة إيجابية ليصبحوا متابعين نشطين.",
    Statistics_Followers_up_action1: "أنشئ Highlight ترحيبي بتنسيق «ماذا ستجد وماذا سيفيدك».",
    Statistics_Followers_up_action2: "خطّط لتعاونين خفيفين أو Mention للحفاظ على جذب مستمر وعالي الجودة.",
    Statistics_Followers_up_action3: "افحص جودة المتابعين عبر إحصائيات الحملات وبيانات دخول Reels.",
    Statistics_Followers_up_urgency: "متوسط",

    Statistics_Followers_neutral_title: "نمو ثابت 💡وقت الاختبارات القصيرة",
    Statistics_Followers_neutral_summary: "نمو الصفحة ثابت؛ تحتاج لاختبارات لمدة 7 أيام لمعرفة ما يؤثر على الجذب.",
    Statistics_Followers_neutral_action1: "نفّذ اختبار 7 أيام على الهاشتاغ، وقت النشر، والأغلفة المختلفة.",
    Statistics_Followers_neutral_action2: "سجّل النتائج وحوّل أفضل تركيبة إلى تنسيق ثابت.",
    Statistics_Followers_neutral_action3: "أنشئ فيديو تعريفي قصير ليعرف الداخلون الجدد بسرعة ما ينتظرهم.",
    Statistics_Followers_neutral_urgency: "متوسط",

    Statistics_Followers_down_title: "انخفاض في الجذب 💡من المحتمل أن المحتوى الأخير لا يتوافق مع الشخصيّة",
    Statistics_Followers_down_summary: "انخفاض الجذب يعني وجود إشارة عدم توافق بين المحتوى الحالي والجمهور المستهدف.",
    Statistics_Followers_down_action1: "اعثر على ثلاثة اختلافات بين الشخصيّة والمحتوى الأخير وقم بإصلاحها.",
    Statistics_Followers_down_action2: "أعد كتابة الـ Bio والـ CTA وأغلفة عدة Posts حديثة وقم باختبارها بسرعة.",
    Statistics_Followers_down_action3: "نفّذ حملة تعاون صغيرة أو UGC لإعادة تنشيط صورة الصفحة.",
    Statistics_Followers_down_urgency: "عالٍ",

    Statistics_Followers_zero_title: "لا يوجد نشاط حديث 💡لا توجد بيانات جذب",
    Statistics_Followers_zero_summary:
      "بسبب عدم وجود نشر أو خطوات جذب، لا توجد أي إشارات للتحليل؛ يجب إعادة تفعيل دورة الجذب.",
    Statistics_Followers_zero_action1: "انشر خمس Reels قصيرة مع خطّاف مدّته 3 ثوانٍ لصنع أولى المدخلات.",
    Statistics_Followers_zero_action2: "انشر Post تعريفي أو تحديثي لبدء الوصول الطبيعي.",
    Statistics_Followers_zero_action3: "نفّذ حملة جذب صغيرة (حتى لو محلية) لإعادة تشغيل النمو.",
    Statistics_Followers_zero_urgency: "عالٍ",

    Statistics_MediaFollows_up_title: "ارتفاع دخول الـ Explore 💡أفضل طريقة هي إنشاء سلسلة محتوى",
    Statistics_MediaFollows_up_summary: "لديك إحالات ودخول خارجي؛ حوّل الصيغ الناجحة إلى سلسلة منتظمة.",
    Statistics_MediaFollows_up_action1: "حوّل الصيغة الناجحة إلى 3 إلى 5 أجزاء مع CTA موحّد في جميع الأجزاء.",
    Statistics_MediaFollows_up_action2: "اختر غلافًا ثابتًا وجدولًا منتظمًا ليعتاد الجمهور على متابعة السلسلة.",
    Statistics_MediaFollows_up_action3: "راقب التوزيع في الأيام الأولى وركّز على المصدر الذي يجلب دخولًا سريعًا.",
    Statistics_MediaFollows_up_urgency: "متوسط",

    Statistics_MediaFollows_neutral_title: "إحالة متوسطة 💡وقت اختبار A/B للغلاف والمصدر",
    Statistics_MediaFollows_neutral_summary: "لزيادة دخول الـ Explore يجب تحسين الغلاف ومصدر الإحالة.",
    Statistics_MediaFollows_neutral_action1: "انشر غلافين A/B وقارن أداءهما خلال 48 ساعة.",
    Statistics_MediaFollows_neutral_action2: "قم بحصر المصادر الأكثر جلبًا للدخول واستهدفها مجددًا.",
    Statistics_MediaFollows_neutral_action3: "أنشئ بنكًا للصيغ الناجحة لتسهيل تكرارها.",
    Statistics_MediaFollows_neutral_urgency: "منخفض",

    Statistics_MediaFollows_down_title: "انخفاض في جذب الإكسبلور 💡محتوى أكثر جاذبية مطلوب",
    Statistics_MediaFollows_down_summary: "للوصول من الإكسبلور، يكون المحتوى العملي أو القابل للتحميل أكثر فعالية.",
    Statistics_MediaFollows_down_action1: "أنشئ ملف PDF أو قائمة تحقق قابلة للتحميل وقدّم رابطًا لمشاركتها بسهولة.",
    Statistics_MediaFollows_down_action2: "انشر محتوى تعليميًا قصيرًا وجرّب الإعلان الموجّه عليه.",
    Statistics_MediaFollows_down_action3: "افحص الروابط ومسارات الإحالة تقنيًا للتأكد من عدم وجود أعطال.",
    Statistics_MediaFollows_down_urgency: "عالي",

    Statistics_MediaFollows_zero_title: "لا يوجد نشاط 💡لم يتم إنشاء إشارة للإكسبلور",
    Statistics_MediaFollows_zero_summary:
      "بسبب عدم النشر أو إجراءات الجذب، لا توجد بيانات للتحليل؛ يجب تفعيل دورة الإنتاج أولًا.",
    Statistics_MediaFollows_zero_action1: "ابدأ بالاستمرارية في إنشاء ونشر محتوى جذاب للمستخدمين.",
    Statistics_MediaFollows_zero_action2: "انشر خمسة محتويات قصيرة يوميًا لتكوين أولى إشارات الإحالة.",
    Statistics_MediaFollows_zero_action3: "ضع Post تعزيزي في اليوم الأول لإنشاء أول دخول.",
    Statistics_MediaFollows_zero_urgency: "عالي",

    Statistics_Reach_up_title: "زيادة Reach 💡حان وقت التوسع",
    Statistics_Reach_up_summary: "ارتفع الوصول؛ كرر أفضل الصيغ للحفاظ على موجة النمو.",
    Statistics_Reach_up_action_1: "أعد نشر اثنين من أعلى صيغ Reach في أوقات الذروة.",
    Statistics_Reach_up_action_2: "ثبت الهاشتاغات الفعالة وضعها دائمًا في التعليق.",
    Statistics_Reach_up_action_3: "أنشئ Posts قابلة للمشاركة بشكل كبير لزيادة Reach العضوي.",
    Statistics_Reach_up_urgency: "متوسط",

    Statistics_Reach_neutral_title: "Reach مستقر 💡يحتاج للتجربة",
    Statistics_Reach_neutral_summary: "لكسر حالة الركود، التعاون الخفيف أو اختبار الهاشتاغات هو الخيار الأفضل.",
    Statistics_Reach_neutral_action_1: "نسق cross-Post مع صفحة مشابهة في نفس المجال.",
    Statistics_Reach_neutral_action_2: "انشر Reelين تعليميين أو ترفيهيين وقم بتقييم التعليقات.",
    Statistics_Reach_neutral_action_3: "تحقق من قائمة الهاشتاغ الأسبوعية واعثر على أفضل تركيبة.",
    Statistics_Reach_neutral_urgency: "منخفض",

    Statistics_Reach_down_title: "انخفاض Reach 💡يجب التصرف سريعًا",
    Statistics_Reach_down_summary: "الوصول انخفض؛ المحتوى القابل للمشاركة والاختبارات القصيرة أولوية.",
    Statistics_Reach_down_action_1: "قم بإجراء اختبار لمدة 7 أيام على Reels ذات الإمكانات العالية.",
    Statistics_Reach_down_action_2: "أنشئ Posts قابلة للمشاركة وقم بتعزيزها بإعلان قصير.",
    Statistics_Reach_down_action_3: "أعد كتابة العنوان، الغلاف، والهاشتاغات ثم أعد نشر Post.",
    Statistics_Reach_down_urgency: "مرتفع",

    Statistics_Reach_zero_title: "لم يُسجّل Reach 💡النشاط منخفض",
    Statistics_Reach_zero_summary:
      "بسبب عدم وجود منشورات أو إشارات كافية، لا توجد بيانات للـ Reach؛ يجب تنشيط دورة المحتوى.",
    Statistics_Reach_zero_action_1: "تحقق من جمع البيانات (API/logs) للتأكد من عمله بشكل صحيح.",
    Statistics_Reach_zero_action_2: "انشر 5 Reels رائجة وقم بتعزيز واحدة من اليوم الثاني.",
    Statistics_Reach_zero_action_3: "اختبر نظام جدولة النشر وأعد ضبطه إذا لزم الأمر.",
    Statistics_Reach_zero_urgency: "مرتفع",

    Statistics_ProfileVisit_up_title: "زيارات الملف الشخصي مرتفعة 💡ركز على التحويل",
    Statistics_ProfileVisit_up_summary: "حركة المرور جيدة؛ يجب تحسين Bio وCTA بسرعة لتحويل الزيارات إلى فالو و clicks.",
    Statistics_ProfileVisit_up_action_1: "أعد كتابة Bio مع عرض قيمة واضح وCTA مباشر.",
    Statistics_ProfileVisit_up_action_2: "أنشئ Highlights الرئيسية حتى يفهم المستخدم ما شاهده وما ينتظره.",
    Statistics_ProfileVisit_up_action_3: "انشر Post بعرض خاص لزيادة معدل النقر على الرابط.",
    Statistics_ProfileVisit_up_urgency: "مرتفع",

    Statistics_ProfileVisit_neutral_title: "الزيارات موجودة، التحويل منخفض 💡أنشئ Leads",
    Statistics_ProfileVisit_neutral_summary: "لديك حركة مرور لكن التحويل منخفض؛ Lead جذاب يمكن أن يغير المسار.",
    Statistics_ProfileVisit_neutral_action_1: "أضف ملف مجاني أو قائمة مرجعية داخل Highlights.",
    Statistics_ProfileVisit_neutral_action_2: "عزز التعليقات التوضيحية بـCTA مرتبطة بالملف الشخصي.",
    Statistics_ProfileVisit_neutral_action_3: "زد من Stories الداعية والموجهة للملف الشخصي.",
    Statistics_ProfileVisit_neutral_urgency: "متوسط",

    Statistics_ProfileVisit_down_title: "انخفاض زيارات الملف الشخصي 💡تحتاج إلى Hook أقوى",
    Statistics_ProfileVisit_down_summary: "فضول المستخدم أقل؛ بداية التعليقات وCTA يجب أن تكون أكثر جاذبية ووضوحًا.",
    Statistics_ProfileVisit_down_action_1: "أعد كتابة التعليقات مع Hook من 3-5 كلمات.",
    Statistics_ProfileVisit_down_action_2: "أضف Stories موجهة واجعل الرابط بارزًا.",
    Statistics_ProfileVisit_down_action_3: "انشر Post جذاب لتشجيع المستخدمين على زيارة الملف الشخصي.",
    Statistics_ProfileVisit_down_urgency: "مرتفع",

    Statistics_ProfileVisit_zero_title: "لا زيارات للملف الشخصي 💡النشاط غير كافٍ",
    Statistics_ProfileVisit_zero_summary:
      "بسبب عدم النشر أو عدم وجود إشارات كافية، لم تُسجل زيارات للملف الشخصي؛ يجب إعادة تفعيل دورة التفاعل.",
    Statistics_ProfileVisit_zero_action_1: "تحقق من حالة الحساب للتأكد من أنه عام (public).",
    Statistics_ProfileVisit_zero_action_2: "انشر Post جذاب مع CTA واضح.",
    Statistics_ProfileVisit_zero_action_3: "قم بتحديث Highlights المهمة لإنشاء أول إشارة زيارة.",
    Statistics_ProfileVisit_zero_urgency: "مرتفع",

    Statistics_Likes_up_title: "الإعجابات جيدة 💡كوّن عادة",
    Statistics_Likes_up_summary: "المستخدمون يقومون باللايك؛ الهدف الآن تحويل هذا السلوك إلى عادة مستمرة.",
    Statistics_Likes_up_action_1: "وثق التنسيقات الناجحة (cover، template، الطول).",
    Statistics_Likes_up_action_2: "ضع CTA بسيط للإعجابات في نهاية Post (مثلاً 'إذا كنت موافق ❤').",
    Statistics_Likes_up_action_3: "قم بإجراء A/B صغير للcover والثواني الثلاث الأولى.",
    Statistics_Likes_up_urgency: "متوسط",

    Statistics_Likes_neutral_title: "الإعجابات يمكن زيادتها 💡حسّن Hook و Cover",
    Statistics_Likes_neutral_summary: "هناك إمكانية؛ تغيير cover و hook يمكن أن يزيد معدل الإعجاب.",
    Statistics_Likes_neutral_action_1: "حسّن واختبر cover والثواني الثلاث الأولى.",
    Statistics_Likes_neutral_action_2: "استخدم CTA عاطفي أو سؤال لدعوة الإعجاب.",
    Statistics_Likes_neutral_action_3: "قم باستطلاع صغير لفهم تفضيلات الجمهور البصرية.",
    Statistics_Likes_neutral_urgency: "منخفض",

    Statistics_Likes_down_title: "انخفاض الإعجابات 💡أعد تصميم الهوية البصرية",
    Statistics_Likes_down_summary: "قد لا تكون الرسالة أو الصورة قوية؛ ركز على اللحظة الأولى من المحتوى.",
    Statistics_Likes_down_action_1: "أعد كتابة cover والسطر الأول من caption.",
    Statistics_Likes_down_action_2: "قم بإجراء اختبار A/B للون/تصميم cover.",
    Statistics_Likes_down_action_3: "انشر Posts بصرية قوية ومرتبطة.",
    Statistics_Likes_down_urgency: "عالي",

    Statistics_Likes_zero_title: "صفر إعجابات 💡إما لا توجد بيانات أو لا يوجد محتوى",
    Statistics_Likes_zero_summary: "إذا كان هناك محتوى ولكن لم تُسجّل إعجابات، تحقق من البيانات؛ وإلا ابدأ بالإنتاج.",
    Statistics_Likes_zero_action_1: "تحقق من صحة تسجيل البيانات.",
    Statistics_Likes_zero_action_2: "إذا لم يكن هناك محتوى، انشر عدة Posts مع covers قوية.",
    Statistics_Likes_zero_action_3: "استخدم الشبكات الشريكة لجمع الملاحظات.",
    Statistics_Likes_zero_urgency: "عالي",

    Statistics_Comments_up_title: "زيادة التعليقات 💡اعتبر الحوار بجدية",
    Statistics_Comments_up_summary: "الناس يتحدثون؛ استخدمهم بالرد وتحويل التعليقات إلى محتوى.",
    Statistics_Comments_up_action1: "رد على التعليقات وحول أفضل 3 أفكار إلى Post.",
    Statistics_Comments_up_action2: "أشر إلى أفضل التعليقات أو اعرضها في Story.",
    Statistics_Comments_up_action3: "ضع سؤالاً في caption يشجع الناس على الإجابة.",
    Statistics_Comments_up_urgency: "متوسط",

    Statistics_Comments_neutral_title: "التعليقات قليلة 💡أضف محفز",
    Statistics_Comments_neutral_summary: "لإجراء حوار، ضع أسئلة بسيطة ومباشرة.",
    Statistics_Comments_neutral_action1: "ضع سؤال مفتوح في نهاية الـ Post.",
    Statistics_Comments_neutral_action2: "رد بسرعة على أول 5 تعليقات لتشجيع الآخرين.",
    Statistics_Comments_neutral_action3: "قم بتحدٍ قصير أو استفتاء.",
    Statistics_Comments_neutral_urgency: "منخفض",

    Statistics_Comments_down_title: "انخفاض التعليقات 💡ضع محفزات واضحة",
    Statistics_Comments_down_summary: "تحتاج إلى CTA ودعوات مباشرة لبدء المحادثة.",
    Statistics_Comments_down_action1: "انشر تحديًا أو اطلب تجارب شخصية.",
    Statistics_Comments_down_action2: "ضع CTA واضح للتعليقات في الـ caption (مثل: 'ما رأيك؟').",
    Statistics_Comments_down_action3: "رد بسرعة على التعليقات الأولى.",
    Statistics_Comments_down_urgency: "مرتفع",

    Statistics_Comments_zero_title: "بدون تعليقات 💡كن جذابًا",
    Statistics_Comments_zero_summary: "المحتوى لا يدفع الناس للتعليق؛ اجعل الصيغ أكثر جذبًا.",
    Statistics_Comments_zero_action1: "صمّم أسئلة بسيطة وجذابة (مثلاً اختيار بين خيارين).",
    Statistics_Comments_zero_action2: "رد بسرعة على أول التعليقات لتشجيع الآخرين.",
    Statistics_Comments_zero_action3: "استخدم CTA مباشرة لدعوة الناس للتعليق.",
    Statistics_Comments_zero_urgency: "مرتفع",

    Statistics_Views_up_title: "عدد المشاهدات ارتفع 💡استغل الحركة",
    Statistics_Views_up_summary: "مشاهدات الفيديو جيدة؛ استخدم نهاية الفيديو لتوجيه الجمهور (الملف الشخصي/الحفظ).",
    Statistics_Views_up_action1: "ضع CTA واضح في نهاية الفيديو (مثلاً: 'احفظ للمزيد').",
    Statistics_Views_up_action2: "ضع رابط المحتوى الإضافي في البايو أو الـ Highlights.",
    Statistics_Views_up_action3: "أنشئ وشارك نسخة أقصر أو تیزر.",
    Statistics_Views_up_urgency: "متوسط",

    Statistics_Views_neutral_title: "عدد المشاهدات ثابت 💡عزز الخطاف والغلاف",
    Statistics_Views_neutral_summary: "اعمل على أول 3 ثوانٍ والغلاف لتحسين معدل المشاهدة.",
    Statistics_Views_neutral_action1: "أعد كتابة خطاف البداية والغلاف.",
    Statistics_Views_neutral_action2: "انشر نسخة أقصر للاختبار.",
    Statistics_Views_neutral_action3: "احصل على ملاحظات بصرية من الجمهور.",
    Statistics_Views_neutral_urgency: "منخفض",

    Statistics_Views_down_title: "انخفاض المشاهدات 💡عزز الخطاف",
    Statistics_Views_down_summary: "بداية الفيديو ضعيفة؛ ابدأ باختبار نسخ قصيرة وجذابة.",
    Statistics_Views_down_action1: "أنشئ 5 فيديوهات مدتها 15 ثانية بخطاف قوي.",
    Statistics_Views_down_action2: "أعد كتابة بداية الفيديو وأجرِ اختبار A/B.",
    Statistics_Views_down_action3: "زد سرعة المونتاج للحفاظ على الانتباه.",
    Statistics_Views_down_urgency: "مرتفع",

    Statistics_Views_zero_title: "صفر مشاهدات؟ 💡انشر المحتوى فورًا",
    Statistics_Views_zero_summary: "ابدأ بإنتاج المحتوى في أقرب فرصة ممكنة.",
    Statistics_Views_zero_action1: "ابدأ بتحليل سير عمل الصفحة فقط.",
    Statistics_Views_zero_action2: "إذا لم يتم نشر فيديو، أنشئ 3 ريلز قصيرة.",
    Statistics_Views_zero_action3: "نفذ منشور تعزيز لتوليد المشاهدات الأولية.",
    Statistics_Views_zero_urgency: "مرتفع",

    Statistics_FollowerViews_up_title: "المتابعون يشاهدون 💡ابنِ التفاعل الداخلي",
    Statistics_FollowerViews_up_summary: "المتابعون نشطون؛ استخدمهم للتفاعل الداخلي (AMA، استطلاعات الرأي).",
    Statistics_FollowerViews_up_action1: "اطرح أسئلة أو قم باستطلاعات في الستوري للمتابعين.",
    Statistics_FollowerViews_up_action2: "انشر محتوى حصري للمتابعين (مثل AMA).",
    Statistics_FollowerViews_up_action3: "تحقق من الصيغ وفق الشخصيات لتناسب اهتماماتهم بدقة أكبر.",
    Statistics_FollowerViews_up_urgency: "متوسط",

    Statistics_FollowerViews_neutral_title: "مشاهدات المتابعين عادية 💡اختبر التوقيت والصيغة",
    Statistics_FollowerViews_neutral_summary: "قد يحتاج وقت النشر أو نوع المحتوى إلى تعديل؛ أجرِ اختبارات بسيطة.",
    Statistics_FollowerViews_neutral_action1: "غيّر أوقات النشر وتتبع التأثير.",
    Statistics_FollowerViews_neutral_action2: "اختبر صيغة جديدة خصيصًا للمتابعين.",
    Statistics_FollowerViews_neutral_action3: "خصص المحتوى بناءً على سلوك الجمهور السابق.",
    Statistics_FollowerViews_neutral_urgency: "منخفض",

    Statistics_FollowerViews_down_title: "انخفاض مشاهدات المتابعين 💡اجمع التعليقات",
    Statistics_FollowerViews_down_summary:
      "قد يكون هناك ابتعاد عن الشخصية المستهدفة؛ اجمع التعليقات ونفّذ 3 تغييرات سريعة.",
    Statistics_FollowerViews_down_action1: "اجمع التعليقات الأخيرة وطبق ثلاث تغييرات سريعة.",
    Statistics_FollowerViews_down_action2: "انشر ستوري محفّزة لإعادة تنشيط الجمهور.",
    Statistics_FollowerViews_down_action3: "اختبر نسخ المحتوى المخصصة.",
    Statistics_FollowerViews_down_urgency: "مرتفع",

    Statistics_FollowerViews_zero_title: "مشاهدات المتابعين صفر 💡تأكد من وجود متابعين نشطين أولاً",
    Statistics_FollowerViews_zero_summary: "قد يكون لديك عدد قليل من المتابعين النشطين؛ قم بتنشيطهم أولاً ثم تفاعل.",
    Statistics_FollowerViews_zero_action1: "انشر عدة ستوري ومنشورات لتنشيط الجمهور.",
    Statistics_FollowerViews_zero_action2: "تفاعل مباشرة مع 10 متابعين نشطين.",
    Statistics_FollowerViews_zero_action3: "قم بإنشاء محتوى بناءً على الاهتمامات السابقة.",
    Statistics_FollowerViews_zero_urgency: "مرتفع",

    Statistics_NonFollowerViews_up_title: "ارتفاع مشاهدات غير المتابعين 💡فرصة جذب جديدة",
    Statistics_NonFollowerViews_up_summary:
      "الأشخاص خارج المتابعين يشاهدون؛ يجب أن يحتوي كل منشور على سبب قوي للمتابعة.",
    Statistics_NonFollowerViews_up_action1:
      "ضع سببًا قويًا للمتابعة في التعليق (مثل المحتوى التسلسلي أو الدروس خطوة بخطوة).",
    Statistics_NonFollowerViews_up_action2: "صمّم ريلز ترندي وجاذب لجذب غير المتابعين للتفاعل.",
    Statistics_NonFollowerViews_up_action3: "استخدم هاشتاغات مستهدفة وتعاونات ذات صلة.",
    Statistics_NonFollowerViews_up_urgency: "متوسط",

    Statistics_NonFollowerViews_neutral_title: "مشاهدات غير المتابعين ثابتة 💡حسّن الهاشتاغ والتوزيع",
    Statistics_NonFollowerViews_neutral_summary:
      "تحسين الهاشتاغات والمحتوى القابل للمشاركة يمكن أن يزيد من دخول غير المتابعين.",
    Statistics_NonFollowerViews_neutral_action1: "حدد الهاشتاغات الفعالة وثبّت بعضًا منها.",
    Statistics_NonFollowerViews_neutral_action2: "انتج محتوى قابل للمشاركة أكثر.",
    Statistics_NonFollowerViews_neutral_action3: "قم بتعاون قصير مع صفحات ذات صلة.",
    Statistics_NonFollowerViews_neutral_urgency: "منخفض",

    Statistics_NonFollowerViews_down_title: "انخفاض مشاهدات غير المتابعين 💡تعاون وإعلان مطلوب",
    Statistics_NonFollowerViews_down_summary:
      "الوصول إلى الاستكشاف انخفض؛ استرجع المرور من خلال التعاون أو إعلان بسيط.",
    Statistics_NonFollowerViews_down_action1: "قم بإعداد تعاون سريع مع صفحة ذات صلة.",
    Statistics_NonFollowerViews_down_action2: "أنشئ المزيد من المنشورات القابلة للمشاركة وانشر منشور تعزيز.",
    Statistics_NonFollowerViews_down_action3: "قم بتشغيل إعلان صغير مستهدف لاستعادة المرور.",
    Statistics_NonFollowerViews_down_urgency: "مرتفع",

    Statistics_NonFollowerViews_zero_title: "مشاهدات غير المتابعين صفر 💡يجب إنشاء إشارات للاستكشاف",
    Statistics_NonFollowerViews_zero_summary: "للحصول على أول حركة مرور، الريلز الترندي والتعاون أفضل بداية.",
    Statistics_NonFollowerViews_zero_action1: "إنتاج 3 ريلز قائمة على الترند.",
    Statistics_NonFollowerViews_zero_action2: "انشر منشور تعزيز لإنتاج المرور الأولي.",
    Statistics_NonFollowerViews_zero_action3: "ابدأ تعاون سريع مع صفحة ذات صلة.",
    Statistics_NonFollowerViews_zero_urgency: "مرتفع",

    Statistics_Shares_up_title: "ارتفاع المشاركة 💡المحتوى الخاص بك يستحق الانتشار",
    Statistics_Shares_up_summary: "الناس يشاركون منشوراتك؛ هذا يعني أن المحتوى ذو قيمة فورية ويمكنه التحويل.",
    Statistics_Shares_up_action1: "حلل ملاحظات المشاركة وحدد الأنماط.",
    Statistics_Shares_up_action2: "ضع سبب واضح للمشاركة في التسمية التوضيحية ('أرسل لصديقك').",
    Statistics_Shares_up_action3: "صمم سلسلة تعليمية قابلة للمشاركة.",
    Statistics_Shares_up_urgency: "متوسط",

    Statistics_Shares_neutral_title: "المشاركة منخفضة أو ثابتة 💡تحتاج فقط محفز بسيط",
    Statistics_Shares_neutral_summary: "أحيانًا مجرد CTA قصيرة كافية لزيادة المشاركة.",
    Statistics_Shares_neutral_action1: "أضف CTA قصير جدًا للمشاركة في نهاية المنشور.",
    Statistics_Shares_neutral_action2: "انتج المزيد من المحتوى القابل للحفظ والمشاركة.",
    Statistics_Shares_neutral_action3: "نفذ قالب تجريبي 'أرسل لصديقك'.",
    Statistics_Shares_neutral_urgency: "منخفض",

    Statistics_Shares_down_title: "انخفاض المشاركة 💡تحتاج محتوى أكثر عملية",
    Statistics_Shares_down_summary: "المحتوى أصبح أقل قابلية للمشاركة؛ أنشئ شيئًا يريده الناس لإرساله للآخرين.",
    Statistics_Shares_down_action1: "صمم قوائم التحقق أو محتوى خطوة بخطوة.",
    Statistics_Shares_down_action2: "انشر دروس قصيرة ومختصرة.",
    Statistics_Shares_down_action3: "أضف CTA واضح للمشاركة.",
    Statistics_Shares_down_urgency: "عالٍ",

    Statistics_Shares_zero_title: "لا توجد مشاركات 💡يجب بناء نقطة بداية",
    Statistics_Shares_zero_summary: "إما لا توجد بيانات أو المحتوى غير قابل للمشاركة؛ صمّم خطة توزيع بسرعة.",
    Statistics_Shares_zero_action1: "قم بإنتاج عدة محتويات من 5 نقاط أو قوائم تحقق.",
    Statistics_Shares_zero_action2: "قم بتعزيز صغير للحصول على الإشارة الأولى.",
    Statistics_Shares_zero_action3: "اكتب سببًا واضحًا للمشاركة في التسمية التوضيحية.",
    Statistics_Shares_zero_urgency: "عالٍ",

    Statistics_Engagement_up_title: "التفاعل في نمو 💡ثبت الصيغة",
    Statistics_Engagement_up_summary: "لقد وجدت نموذجًا ناجحًا؛ حان الوقت لتكراره وتوسيعه.",
    Statistics_Engagement_up_action1: "سجل التنسيقات والأوقات الناجحة بدقة.",
    Statistics_Engagement_up_action2: "أضف تنسيقات تحفيز التفاعل إلى تقويم المحتوى.",
    Statistics_Engagement_up_action3: "اختبر تنسيقًا جديدًا للحفاظ على التفاعل أسبوعيًا.",
    Statistics_Engagement_up_urgency: "متوسط",

    Statistics_Engagement_neutral_title: "التفاعل عادي 💡تحتاج محفز جديد",
    Statistics_Engagement_neutral_summary: "للنمو، أدخل محفزات جديدة مثل الأسئلة أو التحديات أو الدعوة للتعليق.",
    Statistics_Engagement_neutral_action1: "انشر منشورًا أسبوعيًا لدعوة التعليق.",
    Statistics_Engagement_neutral_action2: "وجه التفاعل وقارن النتائج بين التنسيقات المختلفة.",
    Statistics_Engagement_neutral_action3: "صمم بعض القوالب للتفاعل السريع.",
    Statistics_Engagement_neutral_urgency: "منخفض",

    Statistics_Engagement_down_title: "تراجع التفاعل 💡إعادة تصميم عاجلة مطلوبة",
    Statistics_Engagement_down_summary: "يجب تنفيذ اختبارات جديدة فورًا؛ خطة 14 يومًا هي البداية الأفضل.",
    Statistics_Engagement_down_action1: "نفذ خطة 14 يومًا مع 3 تنسيقات مختلفة.",
    Statistics_Engagement_down_action2: "سجل البيانات يوميًا وقم بالتعديل بسرعة.",
    Statistics_Engagement_down_action3: "اسأل جمهورك مباشرة عن المحتوى الذي يجده جذابًا.",
    Statistics_Engagement_down_urgency: "عالي",

    Statistics_Engagement_zero_title: "تفاعل صفر 💡خطة مكثفة 7 أيام مطلوبة",
    Statistics_Engagement_zero_summary: "يجب توليد إشارات التفاعل بسرعة؛ انشر محتوى تفاعلي يوميًا وتابع البيانات.",
    Statistics_Engagement_zero_action1: "انشر استطلاعات، أسئلة مفتوحة وتحديات صغيرة.",
    Statistics_Engagement_zero_action2: "اختبر كل تنسيق لمدة 3 أيام.",
    Statistics_Engagement_zero_action3: "رد بسرعة على التعليقات والرسائل.",
    Statistics_Engagement_zero_urgency: "عالي",

    Statistics_Replies_up_title: "ردود الستوري مرتفعة 💡استخرج منها محتوى",
    Statistics_Replies_up_summary: "جمهورك يكتب؛ هم متعطشون للتفاعل. هذا يعني محتوى قيّم.",
    Statistics_Replies_up_action_1: "اختر 3 من أفضل الردود وحوّلها إلى منشور أو Reel.",
    Statistics_Replies_up_action_2: "أنشئ Q&A أو FAQ مع الإجابات الأكثر تكرارًا.",
    Statistics_Replies_up_action_3: "اعرض بعض الردود في الستوري التالي لتحفيز الآخرين.",
    Statistics_Replies_up_urgency: "متوسط",

    Statistics_Replies_neutral_title: "الردود قليلة 💡أضف محفز",
    Statistics_Replies_neutral_summary: "أحيانًا يكفي سؤال بسيط للحصول على المزيد من الردود.",
    Statistics_Replies_neutral_action_1: "أضف ملصق سؤال، استفتاء أو Quiz.",
    Statistics_Replies_neutral_action_2: "اسأل أسئلة قصيرة وجذابة.",
    Statistics_Replies_neutral_action_3: "تفاعل بسرعة مع الردود لزيادة التفاعل.",
    Statistics_Replies_neutral_urgency: "منخفض",

    Statistics_Replies_down_title: "انخفاض الردود 💡زد من الحميمية",
    Statistics_Replies_down_summary: "يبدو أن الجمهور ابتعد؛ اقترب منهم بمحتوى أكثر شخصية.",
    Statistics_Replies_down_action_1: "انشر بعض الستوريهات الشخصية أو المبنية على الخبرة أو العاطفية.",
    Statistics_Replies_down_action_2: "اطرح أسئلة تتطلب خبرة شخصية للإجابة.",
    Statistics_Replies_down_action_3: "أعطِ أهمية للردود الأولى وتفاعل معها أو رد عليها.",
    Statistics_Replies_down_urgency: "مرتفع",

    Statistics_Replies_zero_title: "صفر ردود 💡بحاجة لدعوة مباشرة",
    Statistics_Replies_zero_summary: "عندما لا يكون هناك أي رد، عليك طرح أسئلة مباشرة وجذابة.",
    Statistics_Replies_zero_action_1: "انشر أسئلة بسيطة وجذابة جدًا (مثل الاختيار بين خيارين).",
    Statistics_Replies_zero_action_2: "أبرز الردود التي تحصل عليها لتشجيع الآخرين.",
    Statistics_Replies_zero_action_3: "قم بعمل ستوري تفاعلي خفيف يوميًا.",
    Statistics_Replies_zero_urgency: "مرتفع",

    Statistics_TotalTime_up_title: "زيادة وقت المشاهدة 💡قدم محتوى أعمق",
    Statistics_TotalTime_up_summary: "الجمهور يقضي وقتًا؛ جاهز لمحتوى طويل ومقسم للفصول.",
    Statistics_TotalTime_up_action_1: "أنشئ مقاطع فيديو أطول مع هيكل مقدمة/وسط/خاتمة.",
    Statistics_TotalTime_up_action_2: "أضف روابط المحتوى الإضافي في البايو أو Highlights.",
    Statistics_TotalTime_up_action_3: "قسّم الفيديو بوضوح لزيادة الاحتفاظ بالمشاهدين.",
    Statistics_TotalTime_up_urgency: "متوسط",

    Statistics_TotalTime_neutral_title: "وقت المشاهدة عادي 💡قوى الهيكل",
    Statistics_TotalTime_neutral_summary: "الجمهور يبقى، لكنه لا يلتزم؛ حسّن الهيكل للاحتفاظ بهم.",
    Statistics_TotalTime_neutral_action_1: "نفّذ هيكل ثلاثي للمقاطع.",
    Statistics_TotalTime_neutral_action_2: "حدد النقاط الرئيسية ليعرف المشاهدون ما سيشاهدونه.",
    Statistics_TotalTime_neutral_action_3: "أنشئ نسخة مختصرة للاختبار والمقارنة.",
    Statistics_TotalTime_neutral_urgency: "منخفض",

    Statistics_TotalTime_down_title: "انخفاض وقت المشاهدة 💡الخطاف الأول ضعيف",
    Statistics_TotalTime_down_summary: "الثلاث ثواني الأولى تحتاج لجذب قوي؛ اجعلها أسرع، أكثر جذبًا وأكثر قوة.",
    Statistics_TotalTime_down_action_1: "أعد كتابة الثلاث ثواني الأولى واختبر عدة نسخ.",
    Statistics_TotalTime_down_action_2: "أنشئ نسخ قصيرة جدًا 15–30 ثانية.",
    Statistics_TotalTime_down_action_3: "حسّن إيقاع التحرير، القص والموسيقى.",
    Statistics_TotalTime_down_urgency: "مرتفع",

    Statistics_TotalTime_zero_title: "وقت المشاهدة صفر 💡لم تنشر شيئًا بعد؟",
    Statistics_TotalTime_zero_summary:
      "إذا كان الفيديو موجودًا لكن لم يتم تسجيل الوقت، تحقق أولاً من المشكلات التقنية.",
    Statistics_TotalTime_zero_action_1: "تأكد من نشر المحتوى بالفعل.",
    Statistics_TotalTime_zero_action_2: "إذا لم يُنشر، انشر 3 ريلز قصيرة متتابعة.",
    Statistics_TotalTime_zero_action_3: "قم بتشغيل تعزيز أو عرض أولي لجمع البيانات.",
    Statistics_TotalTime_zero_urgency: "مرتفع",

    Statistics_ReachMonth_up_title: "الوصول الشهري ارتفع 💡ثبت الأنماط",
    Statistics_ReachMonth_up_summary: "الشهور الناجحة واضحة؛ سجّل الأنماط وخطط للشهر القادم.",
    Statistics_ReachMonth_up_action_1: "حلّل الشهور ذات الأداء العالي وسجّل الأنماط.",
    Statistics_ReachMonth_up_action_2: "حدّث جدول المحتوى بهذه الأنماط.",
    Statistics_ReachMonth_up_action_3: "أعد نشر الصيغ الناجحة للشهر القادم.",
    Statistics_ReachMonth_up_urgency: "متوسط",

    Statistics_ReachMonth_neutral_title: "الوصول الشهري مستقر 💡وقت الاختبار والنمو",
    Statistics_ReachMonth_neutral_summary: "لزيادة الوصول الشهري، قم بحملة قصيرة أو إعلان محدود.",
    Statistics_ReachMonth_neutral_action_1: "أطلق حملة مشتركة أو إعلان محدود.",
    Statistics_ReachMonth_neutral_action_2: "سجّل النتائج، قارنها وقم بالتحسين.",
    Statistics_ReachMonth_neutral_action_3: "قم بتعزيز المشاركات الناجحة السابقة مرة أخرى.",
    Statistics_ReachMonth_neutral_urgency: "منخفض",

    Statistics_ReachMonth_down_title: "الوصول الشهري انخفض 💡أعد إنشاء المحتوى",
    Statistics_ReachMonth_down_summary: "لإعادة الوصول، أعد نشر أو أعد بناء المنشورات الرئيسية.",
    Statistics_ReachMonth_down_action_1: "أعد نشر أو إعادة إنشاء المنشورات الرئيسية.",
    Statistics_ReachMonth_down_action_2: "قم بتنفيذ حملة إنتاج محتوى وإعلان لمدة 14 يومًا.",
    Statistics_ReachMonth_down_action_3: "راجع الهاشتاغات والعلامات مرة أخرى.",
    Statistics_ReachMonth_down_urgency: "عالي",

    Statistics_ReachMonth_zero_title: "الوصول الشهري صفر 💡تحقق من البيانات أولاً",
    Statistics_ReachMonth_zero_summary:
      "البيانات غير موجودة أو ناقصة؛ تحقق من المشكلات الفنية أولاً، ثم نفذ خطة 14 يومًا.",
    Statistics_ReachMonth_zero_action_1: "تحقق من اتصالات البيانات والتسجيلات.",
    Statistics_ReachMonth_zero_action_2: "قم بتنفيذ خطة إنتاج محتوى لمدة 14 يومًا.",
    Statistics_ReachMonth_zero_action_3: "تتبع النتائج اليومية.",
    Statistics_ReachMonth_zero_urgency: "عالي",

    Statistics_MonthEngagement_up_title: "التفاعل الشهري في ارتفاع 💡قم بتوسيعه",
    Statistics_MonthEngagement_up_summary: "سجل الأنماط الإيجابية الشهرية وكررها.",
    Statistics_MonthEngagement_up_action_1: "وثق القوالب والصيغ الناجحة.",
    Statistics_MonthEngagement_up_action_2: "حدد مؤشرات KPI وخطط واضحة للشهر المقبل.",
    Statistics_MonthEngagement_up_action_3: "قم بإجراء اختبارات أسبوعية صغيرة لتحسين التفاعل.",
    Statistics_MonthEngagement_up_urgency: "متوسط",

    Statistics_MonthEngagement_neutral_title: "التفاعل الشهري عادي 💡أضف عنصر تحدي",
    Statistics_MonthEngagement_neutral_summary: "يمكن لتحدي أسبوعي أو سؤال زيادة التفاعل.",
    Statistics_MonthEngagement_neutral_action_1: "انشر محتوى تحدي أو قائم على سؤال أسبوعيًا.",
    Statistics_MonthEngagement_neutral_action_2: "سجل وقارن النتائج.",
    Statistics_MonthEngagement_neutral_action_3: "أنشئ سلسلة أسبوعية للتفاعل.",
    Statistics_MonthEngagement_neutral_urgency: "منخفض",

    Statistics_MonthEngagement_down_title: "التفاعل الشهري منخفض 💡أطلق خطة 14 يومًا",
    Statistics_MonthEngagement_down_summary: "راجع الصيغ ونفذ خطة لمدة 14 يومًا.",
    Statistics_MonthEngagement_down_action_1: "نفذ خطة 14 يومًا مع 3 صيغ مختلفة.",
    Statistics_MonthEngagement_down_action_2: "حلل النتائج يوميًا.",
    Statistics_MonthEngagement_down_action_3: "اجمع التعليقات المباشرة من الجمهور.",
    Statistics_MonthEngagement_down_urgency: "مرتفع",

    Statistics_MonthEngagement_zero_title: "التفاعل الشهري صفر 💡برنامج عاجل 7 أيام",
    Statistics_MonthEngagement_zero_summary: "انشر 7 منشورات تفاعلية سريعة وراقب يوميًا.",
    Statistics_MonthEngagement_zero_action_1: "أنشئ 7 منشورات تفاعلية.",
    Statistics_MonthEngagement_zero_action_2: "راجع النتائج يوميًا.",
    Statistics_MonthEngagement_zero_action_3: "تفاعل مع الجمهور عبر الرسائل والتعليقات.",
    Statistics_MonthEngagement_zero_urgency: "مرتفع",

    Statistics_MonthView_up_title: "الزيارات الشهرية زادت 💡ثبّت الهيكل",
    Statistics_MonthView_up_summary: "استراتيجية الفيديو ناجحة؛ انشر هذه الصيغ بانتظام.",
    Statistics_MonthView_up_action_1: "وثّق استراتيجية الفيديو الخاصة بك.",
    Statistics_MonthView_up_action_2: "حوّل الإنتاج المنتظم إلى صيغة قياسية.",
    Statistics_MonthView_up_action_3: "راجع وسجّل المقاييس الشهرية الرئيسية.",
    Statistics_MonthView_up_urgency: "متوسط",

    Statistics_MonthView_neutral_title: "الزيارات الشهرية مستقرة 💡جرب مزيج الصيغ",
    Statistics_MonthView_neutral_summary: "مزج Reels وStories يمكن أن يخلق قنوات حركة مرور جديدة.",
    Statistics_MonthView_neutral_action_1: "أنشئ محتوى مختلط من Reels + Stories.",
    Statistics_MonthView_neutral_action_2: "سجّل وقارن الأداء.",
    Statistics_MonthView_neutral_action_3: "أضف تسميات توضيحية توجه إلى الفيديو.",
    Statistics_MonthView_neutral_urgency: "منخفض",

    Statistics_MonthView_down_title: "انخفاض المشاهدات الشهرية 💡ركز على Reels",
    Statistics_MonthView_down_summary: "Reels قصيرة مع غلاف جذاب هي أسرع طريقة لاستعادة المشاهدات.",
    Statistics_MonthView_down_action_1: "أنشئ Reels مدتها 15–30 ثانية.",
    Statistics_MonthView_down_action_2: "صمم أغلفة جذابة.",
    Statistics_MonthView_down_action_3: "قم بإجراء اختبارات التوقيت.",
    Statistics_MonthView_down_urgency: "عالي",

    Statistics_MonthView_zero_title: "المشاهدات الشهرية صفر 💡تحقق من المشاكل التقنية أولاً",
    Statistics_MonthView_zero_summary:
      "قد تكون هناك مشاكل في البيانات أو النشر؛ تحقق من التقنية أولاً ثم ابدأ خطة 14 يومًا.",
    Statistics_MonthView_zero_action_1: "تحقق من بيانات الفيديو تقنيًا.",
    Statistics_MonthView_zero_action_2: "نفذ خطة إنتاج محتوى لمدة 14 يومًا.",
    Statistics_MonthView_zero_action_3: "راقب النتائج يوميًا.",
    Statistics_MonthView_zero_urgency: "عالي",
    Statistics_RePosts_up_title: "إعادة النشر في ازدياد 💡 استفد منها",
    Statistics_RePosts_up_summary: "الجمهور يشارك منشوراتك؛ وهذا يعني أن محتواك يستحق الانتشار.",
    Statistics_RePosts_up_action_1: "ضع سببًا واضحًا لإعادة النشر في الوصف («أرسلها لصديقك»).",
    Statistics_RePosts_up_action_2: "صمّم سلسلة تعليمية قابلة للمشاركة.",
    Statistics_RePosts_up_action_3: "حلّل ملاحظات إعادة النشر واعثر على الأنماط.",
    Statistics_RePosts_up_urgency: "متوسط",
    Statistics_RePosts_neutral_title: "إعادة النشر منخفضة أو ثابتة 💡 تحتاج فقط إلى محفّز بسيط",
    Statistics_RePosts_neutral_summary: "أحيانًا يكفي CTA قصير لزيادة إعادة النشر.",
    Statistics_RePosts_neutral_action_1: "أضف CTA قصير جدًا لإعادة النشر في نهاية Post.",
    Statistics_RePosts_neutral_action_2: "أنشئ محتوى أكثر قابلية للحفظ والمشاركة.",
    Statistics_RePosts_neutral_action_3: "نفّذ قالبًا تجريبيًا مثل «أرسلها لصديقك».",
    Statistics_RePosts_neutral_urgency: "منخفض",
    Statistics_RePosts_down_title: "إعادة النشر في تراجع 💡 تحتاج إلى محتوى أكثر فائدة",
    Statistics_RePosts_down_summary: "المحتوى أصبح أقل قابلية للإرسال؛ يجب إنشاء شيء يرغب الناس في مشاركته مع الآخرين.",
    Statistics_RePosts_down_action_1: "صمّم قائمة تحقق أو محتوى مرحلي.",
    Statistics_RePosts_down_action_2: "انشر دروسًا قصيرة ومختصرة.",
    Statistics_RePosts_down_action_3: "أضف CTA واضحًا لإعادة النشر.",
    Statistics_RePosts_down_urgency: "مرتفع",
    Statistics_RePosts_zero_title: "لم يتم تسجيل أي إعادة نشر 💡 تحتاج إلى إنشاء نقطة بداية",
    Statistics_RePosts_zero_summary: "إما لا توجد بيانات أو أن المحتوى غير قابل لإعادة النشر؛ صمّم بسرعة خطة توزيع.",
    Statistics_RePosts_zero_action_1: "أنشئ عدة محتويات من 5 نقاط أو بنمط قائمة تحقق.",
    Statistics_RePosts_zero_action_2: "نفّذ تعزيزًا بسيطًا للحصول على أول إشارة.",
    Statistics_RePosts_zero_action_3: "اكتب سببًا واضحًا لإعادة النشر في الوصف.",
    Statistics_RePosts_zero_urgency: "مرتفع",

    // statistics suggestions box

    // 4️⃣ Page -> tools
    pageTools_hashtags: "الهاشتاجات",
    pageTools_MyList: "قائمة الهاشتاجات",
    pageTools_CreateNewListexplain: "أنشئ قائمة # الخاصة بك واستخدمها لإنشاء المنشورات",
    Analyzer: "(AI) المحلل",
    pageTools_CreateNewList: "إنشاء قائمة جديدة",
    pageTools_CustomFont: "خط مخصص",
    pageTools_CustomFontExplain: "استخدم الخطوط المخصصة لمنشورات إنستغرام الخاصة بك!",
    pageToolspopup_CreateNewListexplain:
      "يتم إنشاء هاشتاغ جديد عند الضغط على <Enter> أو <Space>. انقر على أي هاشتاغ لحذفه.",
    pageToolspopup_Listname: "اسم القائمة",
    pageToolspopup_hashtags: "الهاشتاغات",
    pageToolspopup_typehere: "اكتب هنا",
    pageTools_hashtagList: "قائمة الهاشتاغ",
    pageTools_CreateNewListpic: "محلل صورة جديد",
    pageTools_CreateNewListpicexplain: "إنشاء الهاشتاجات المتعلقة بالصورة",
    pageTools_CreateNewListpage: "محلل صفحة جديد",
    pageTools_CreateNewListpageexplain: "إنشاء الهاشتاجات المتعلقة برابط إنستجرام",
    pageToolspopup_pageURL: "معرف Instagram",
    pageToolspopup_HideLikeandViewCounts: "إخفاء عدد الإعجابات والمشاهدات",
    pageToolspopup_TurnoffCommenting: "إيقاف التعليقات",
    pageToolspopup_TurnoffCommentingExplain: "سيتم تعطيل التعليقات على هذا الـ Post",
    pageToolspopup_TurnoffCommentingexplainforlottery: "سيتم تعطيل التعليقات على هذا الـ Post أثناء إجراء القرعة",

    pageToolspopup_TopHashtag: "أفضل هاشتاج",
    pageToolspopup_TopHashtagexplain: "هذا هو عدد المرات التي استخدمت فيها هذا الهاشتاج على الصفحة.",
    pageToolspopup_allRepliedcomments: "جميع التعليقات التي تم الرد عليها",
    noresult: "لا توجد نتيجة",
    viewreplies: "عرض الردود",
    allRepliedcomments: "جميع التعليقات التي تم الرد عليها",
    Followers: "المتابعين",
    NonFollowers: "غير المتابعين",
    pageToolspopup_ViewersLikes: "المشاهدين والإعجابات",
    supportedformat: "التنسيق المدعوم",
    limitsize: "الحد الأقصى للحجم",
    TagMention: "تاغ و منشن",
    cover: "الغلاف",
    Pleaseselect: "يرجى الاختيار",
    replace: "استبدال",
    Album: "الألبوم",
    SavedHashtagList: "قائمة الهاشتاجات المحفوظة",
    SavedHashtagListexplain: "اختر هاشتاج لإضافته إلى نهاية الوصف",
    FirstComment: "أول تعليق",
    PinFirstComment: "تثبيت أول تعليق",
    areyousure: "هل أنت متأكد؟",
    shouldFollower: "يجب على المستخدم متابعة الصفحة",
    draftexplain: "أنت تحاول حفظ كمسودة",
    deletedraftexplain: "أنت تحاول حذف المسودة",
    deleteorderexplain: "أنت تحاول حذف الطلب",

    Addpeopleexplain: "*بعد وضع علامة على الأشخاص، اضبط العلامة أو انقر مرتين لإزالتها",
    AdvanceSettings: "إعدادات متقدمة",
    sharepreviewtofeed: "مشاركة المعاينة إلى الخلاصة",
    Videocopyrightbypass: "تجاوز حقوق الطبع والنشر للفيديو",
    SetScheduledPost: "جدولة المنشور",
    SetScheduledPostexplain: "سيتم نشر هذا المنشور في الوقت المحدد",
    SetScheduledStoryexplain: "سيتم نشر هذه القصة في الوقت المحدد",
    addtoproduct: "إضافة إلى المنتجات",
    addtoproductexplain: "سيتم إضافة هذا المنشور كمنتج إلى قائمة منتجاتك",
    TurnoffCommentingexplain: "سيتم تعطيل التعليق على هذا المنشور",
    RecommendedDateTime: "التاريخ والوقت الموصى بهما",
    RecommendedDateTimeexplain: "هذه الأوقات مستندة إلى تحليل صفحتك",
    publish: "نشر",
    pageTools_global: "عالمي",
    pageTools_FA_AR: "فارسي / عربي",
    pageTools_Overall: "إجمالي",
    pageTools_year: "سنة",
    pageTools_Month: "شهر",
    pageTools_Week: "أسبوع",
    pageTools_Day: "يوم",
    pageTools_hashtag: "الهاشتاج",
    pageTools_USED: "مستخدم",
    pageTools_SearchedHashtag: "الهاشتاج المُفتش",
    pageTools_TrendHashtags: "الهاشتاجات الرائجة",
    pageTools_AutoInterAction: "التفاعل التلقائي مع المتابعين",
    pageTools_AcceptPendingRequests: "قبول طلبات المتابعة تلقائيًا",
    pageTools_LikeAllNewComments: "إعجاب بالتعليقات الجديدة",
    pageTools_LikeNewFollowersPosts: "إعجاب بآخر منشورات المتابعين الجدد",
    pageTools_RemoveAllFollowings: "إزالة جميع المتابعين",
    pageTools_WinnerPicker: "اليانصيب (اختيار الفائز)",
    pageTools_DayEvents: "أحداث اليوم",
    pageTools_EventDateRange: "نطاق التاريخ",
    pageTools_EventLanguage: "اللغة",
    pageTools_EventSelectDate: "اختر نطاق التاريخ",
    pageTools_EventSearch: "البحث عن الأحداث",
    pageTools_EventEmpty: "لم يتم العثور على أحداث للنطاق المحدد",
    pageTools_EventReligious: "ديني",
    pageTools_EventIdeas: "أفكار الأحداث",
    pageTools_IdeaCreate: "توليد أفكار للأحداث",
    pageTools_IdeaExplain: "احصل على أفكار محتوى مدعومة بالذكاء الاصطناعي بناءً على الأحداث والمناسبات القادمة",
    pageTools_CreateEventIdea: "توليد أفكار للأحداث",
    pageTools_CreateEventIdeaPrompt: "الموضوع / الأمر",
    pageTools_CreateEventIdeaPromptPlaceholder: "مثل: أحذية، لياقة، سفر... (اتركه فارغاً لجميع المواضيع)",
    pageTools_CreateEventIdeaOptional: "اختياري",
    pageTools_CreateEventIdeaSubmit: "توليد",
    pageTools_CreateEventIdeaCancel: "إلغاء",
    pageTools_EventIdeasLanguage: "اللغة",
    pageTools_EventIdeasFetch: "جلب الأفكار",
    pageTools_EventIdeasEmpty: "لم يتم العثور على أفكار للأحداث",
    pageTools_EventIdeasLoadMore: "المزيد",
    pageTools_EventIdeasIdea: "فكرة",
    pageTools_EventIdeasCountry: "البلد",
    pageTools_EventIdeasPrompt: "الموضوع",
    pageTools_EventIdeasCreatedTime: "تاريخ الإنشاء",
    pageTools_CustomEvent: "حدث مخصص",
    pageTools_exportcomments: "يتم تصدير جميع التعليقات كملف Excel ويمكن تنزيله ومشاركته",

    pageTools_Lottery: "إنشاء قرعة بالنقاط",
    pageTools_emptylotteryList: "لم تقم بإنشاء أي قرعة حتى الآن",

    pageTools_LotteryExplain: "استنادًا إلى نقاط المستخدمين في منشور",
    pageTools_fromFollowers: "من المتابعين",
    pageTools_FromFollowersExplain: "عشوائيًا من بين جميع المتابعين",
    pageTools_Result: "النتيجة",
    pageTools_ResultExplain: "حالة اليانصيب السابقة",
    pageTools_popup_detail: "تفاصيل",
    pageTools_popup_history: "تاريخ",
    pageTools_LikeAllNewCommentsExplain: "عندما يترك أحد متابعيك تعليقًا على أي منشور، سيتم إعجابه تلقائيًا.",
    pageTools_AcceptType: "نوع التفعيل",
    pageTools_popup_AlwaysActive: "دائمًا نشط",
    pageTools_popup_JustOnce: "مرة واحدة فقط",
    pageTools_AcceptPendingRequestsexplain: "قبول تلقائي لجميع طلبات الفولو من الأفراد.",
    pageTools_onlyprivate: "*يعمل فقط مع الصفحات الخاصة.",
    pageTools_MaxLike: "عدد المنشورات التي سيتم الإعجاب بها",
    pageTools_Reacceptfollower: "إعادة الفالو بعد الأنفالو",
    pageTools_Reacceptfollowerexplain: "إذا قام شخص بمتابعتك ثم ألغى المتابعة وطلب المتابعة مرة أخرى، سيقبل النظام.",
    waitday: "وقت الانتظار",
    waitdayexplain: "إذا تم متابعة شخص ما بواسطةك أو بواسطة النظام، فسيتم حذفه بعد فترة الانتظار المحددة.",
    waitdayexplain2: "عدد الانتظار هو عدد الأيام. إذا كان هذا الرقم يساوي ٠، فستتم العملية على الفور.",
    pageTools_LikeNewFollowersPostsexplain: "عندما يتابعك شخص جديد، سيتم تلقائيًا الإعجاب بأحدث منشور له.",
    pageTools_RemoveAllFollowingsexplain: "تقوم هذه الخيار تلقائيًا بإزالة جميع متابعيك من الصفحة.",
    pageTools_progress: "قد تستغرق هذه العملية عدة أيام، حسب عدد متابعينك.",
    pageTools_JustUnfollowwho: "فقط قم بإلغاء متابعة من لم يتابعني.",
    pageTools_AllmyFollowings: "جميع متابعيني",
    pageTools_pageanAnalyzer: "محلل الصفحة",
    pageTools_pictureanAnalyzer: "محلل الصورة",
    pageTools_StartAnalysis: "ابدأ التحليل",
    pageLottery_Step: "الخطوة",
    pageLottery_Specifications: "المواصفات",
    pageLottery_SelectaPost: "اختر منشورًا",
    pageLottery_SetDateTime: "ضبط التاريخ والوقت",
    pageLottery_WinnersTasks: "مهام الفائزين",
    pageLottery_WinnersTasksexplain: "المهام التي يجب أن يكملها كل من المشاركين للدخول في السحب.",
    pageLottery_NumberofWinners: "عدد الفائزين",
    pageLottery_SetScoreForLottery: "ذِكر الأشخاص",
    pageLottery_SetScoreForLotteryexplain: "يجب على المستخدمين ذِكر أشخاص آخرين للمشاركة في القرعة",
    pageLottery_MinimumMention: "الحد الأدنى للمنشن",
    pageLottery_MinimumMentionexplain: "عدد الأشخاص الذين يجب ذكرهم",
    pageLottery_FollowedPage: "الصفحة المتابعة",
    pageLottery_FollowedPageexplain: "يجب على الأشخاص فالو صفحتك أو الصفحات التي تختارها لدخول السحب",
    pageLottery_FollowmyPage: "فالو صفحتي",
    pageLottery_FollowalternativePages: "فالو الصفحات البديلة",
    pageLottery_Termsconditions: "الشروط والأحكام",
    pageLottery_publishTermsconditions: "نشر الشروط والأحكام",
    pageLottery_previewTermsconditionsexplain: "سيتم عرض هذه الاستوري كاستوري للمشاركين.",
    pageLottery_Termsconditionsbanner: "بانر الشروط والأحكام",
    pageLottery_Termsconditionsbannerexplain: "اختر بانر للإعلان عن شروط وأحكام السحب لمتابعيك.",
    pageLottery_model: "النموذج",
    pageLottery_Solid: "صلب",
    pageLottery_Radial: "شعاعي",
    pageLottery_Linear: "خطي",
    pageLottery_Background: "الخلفية",
    pageLottery_Color: "اللون",
    pageLottery_Position: "الموقع",
    pageLottery_Degree: "الدرجة",
    pageLottery_TextBox: "مربع النص",
    pageLottery_Opacity: "الشفافية",
    pageLottery_Blur: "التمويه",
    pageLottery_Font: "الخط",
    pageLottery_Winnerannouncement: "إعلان الفائز",
    pageLottery_participants1: "🎉 من ٩٩٩,٩٩٩ مشارك 🎉",
    pageLottery_participants2: "🥳 هؤلاء هم المحظوظون: 🥳",
    pageLottery_participantsexplain:
      "*يقوم النظام بضبط عدد المشاركين وعدد الفائزين تلقائيًا ويعيّن معرفاتهم بعد كل @ حرف.",
    pageLottery_Addtocaption: "أضف إلى التسمية التوضيحية بعد انتهاء القرعة",
    pageLottery_Publishasstory: "انشر قائمة الفائزين كاستوري",
    pageLottery_deleteexplain: "سيتم حذف القرعة بشكل دائم، ولا يمكن التراجع عن ذلك.",
    pageLottery_Winnerpickersstatus: "حالة القرعة",
    pageLottery_scoreLotteryWinners: "الفائزون في القرعة",
    pageLottery_NoWinners: "لا يوجد فائزون",
    pageLottery_RandomFollowersWinners: "الفائزون العشوائيون بالمتابعين",
    pageLottery_specifickeywordexplain: "يجب على المستخدمين كتابة كلمة محددة في کامنت للمشاركة في القرعة",
    pageLottery_FollowmyPageexplain: "يجب على المستخدمين عمل فالو للصفحة للمشاركة في القرعة",

    pageLottery_ShareRemainingTime: "مشاركة الوقت المتبقي",
    ShareTermsAndCondition: "مشاركة الشروط والأحكام",
    pageLottery_LotteryRemainingTime: "الوقت المتبقي للقرعة",
    pageLottery_Winnerpickerisrunning: "القرعة تعمل",
    pageLottery_ViewandEditDetails: "عرض وتحرير التفاصيل",
    pageLottery_ActiveWinnerpickers: "القرعة النشطة",
    pageTools_WinnerPickertooltip24hour: "يمكن إجراء القرعة مرة كل ٢٤ ساعة",
    specifickeywordstooltip: "يكتشف النظام تلقائيًا الرموز التعبيرية والأرقام الفارسية والعربية والإنجليزية",
    pageLottery_FilterKeywords: "يختار النظام عشوائيًا التعليقات التي تحتوي على الكلمة المحددة ويعرضها",
    pageLottery_NumberofWinnersexplain: "حدد عدد الفائزين في القرعة. الحد الأقصى لعدد الفائزين هو ١٠٠",
    pageLottery_permanentlinktooltip: "هذا الرابط دائم، ولكنه سيتم حذفه عند إجراء قرعة جديدة",
    pageLottery_permanentlinkexplain: "يمكنك مشاركة هذا الرابط مع المستخدمين للتحقق من نزاهة وأصالة القرعة",
    pageTools_randomly: "عشوائياً",
    pageTools_BestEngagement: "أفضل تفاعل",
    pageTools_BestEngagementexplain: "اختر من بين الفالورز الذين حصلوا على أكثر عدد من اللايكات والكومنتات",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "أنت تحاول أن",
    message_blockexplain:
      "لن يتمكنوا من العثور على ملفك الشخصي أو منشوراتك أو استورياتك على إنستغرام. إنستغرام لن يعلمهم بأنك قمت بحظرهم.",
    message_deleteexplain: "سيتم حذف الدردشة نهائياً، ولا يمكن التراجع عن ذلك.",
    message_block: "حظر",
    notactivemessage: "تم تعطيل هذه الدردشة مؤقتًا. يرجى إرسال ردك عبر تطبيق Instagram.",
    notactivemessageexplain:
      "يرجى ملاحظة أنه إذا لم يتم إرسال رد خلال ٢٤ ساعة، ستصبح الدردشة غير متاحة. لإعادة التفعيل، يمكنك الرد عبر تطبيق Instagram أو انتظار الطرف الآخر لإرسال رسالة جديدة لك.",
    waitingforconnection: "...في انتظار الاتصال",
    message_unblock: "إلغاء الحظر",
    messagesetting_goodbye: "مع السلامة",
    messagesetting_welcome: "أهلاً وسهلاً",
    messagesetting_welcomingmessage: "رسالة ترحيب",
    messagesetting_Activewelcomemessageexplain:
      "سيتم إرسال هذه الرسالة في دایرکت إنستجرام كـ<رسالة ترحيب> إلى الأشخاص الذين يقومون بمتابعتك.",
    messagesetting_Sentmessages: "الرسائل المرسلة",
    message: "رسالة",
    messagesetting_Activewelcomingmessage: "رسالة ترحيب",
    receivedmessage: "الرسالة المستلمة",
    Messageresponse: "الرد على الرسالة",
    receivedcomment: "التعليق المُستَلم",
    commentresponse: "رد على التعليق",
    Likethereceivedcomment: "إعجاب بالتعليق المُستَلم",
    unreadmessage: "الرسائل غير المقروءة",
    specifickeywords: "الكلمات الرئيسية",
    unreadcomment: "التعليقات غير المقروءة",
    hiddencommenttooltip: "تم إخفاء هذا التعليق عن العرض. يمكن فقط للمسؤولين رؤية التعليقات المخفية.",
    vanishmode: "الوضع المخفي",
    vanishmodeexplain: "في الوضع المخفي، ستظهر الرسائل التي لم يتم الرد عليها ولم يتم تجاهلها أو إخفاؤها.",
    totalcomments: "إجمالي التعليقات",
    unansweredcomments: "التعليقات غير المُجابة",
    totalcommenters: "إجمالي المُعلقين",
    commentmanagement: "مرحبًا بك في إدارة التعليقات",
    ticketmanagement: "مرحبًا بكم في قسم إدارة تذاكر العملاء",
    flowmanagement: "أنشئ فلو واجعل ردود إنستغرام الخاصة بك ذكية وأوتوماتيكية",

    QuickReplyexplain: "يتم الرد تلقائيًا على جميع التعليقات المستلمة.",
    autocommentReply: "الرد التلقائي على التعليقات",
    Sendresponseifthepageisfollowed: "إرسال الرد إذا تم فالو الصفحة",
    Likethereceivedmessage: "إعجاب بالرسالة المستلمة",
    messagesetting_welcometext:
      "مرحباً! 🌟\nأهلاً بك في عالمنا! 🎉 نحن سعداء جداً لانضمامك إلى مجتمع فالورينا. نحن متأكدون أن لحظات رائعة تنتظرنا معاً. 🤗\n\nنأمل أن تجد محتوى هذه الصفحة ممتعاً ومفيداً، وأن تبقى معنا. إذا كان لديك أي أسئلة أو اقتراحات، يسعدنا مساعدتك. 😊\n\nشكراً لاختيارك صفحتنا ولأنك معنا. لا نستطيع الانتظار للترحيب بك في عالمنا المذهل.✨\n\nمع الاحترام والتقدير 💫",
    messagesetting_goodbyetext:
      "مرحباً! 👋\nنأسف لأنك غادرت صفحتنا. 😢 نحن نقدر كل فالور ونعتبر ملاحظاتكم واقتراحاتكم مهمة جداً لنا.\n\nإذا كان هناك سبب معين لهذا القرار، نأمل أن تشاركه معنا. نحن على استعداد للاستماع إلى أفكارك واقتراحاتك لتحسين تجربتنا. 🫡\n\nعلى أي حال، نتمنى لك كل التوفيق ونأمل أن تعود إلينا في المستقبل. 💫",
    messagesetting_ActiveFarewellmessage: "رسالة وداع",
    messagesetting_ActiveFarewellmessageexplain:
      "ستُرسل هذه الرسالة في د Direct على إنستغرام كـ <رسالة وداع> للأشخاص الذين ألغوا متابعتك.",
    messagesetting_businessmessagefilter: "تصفية الرسائل التجارية",
    messagesetting_businessmessagefiltering: "تصفية الرسائل التجارية",
    messagesetting_businessmessagefilteringexplain:
      "سيتم إرسال الدردشة المطلوبة تلقائيًا إلى قسم <الرسائل التجارية> في علامة تبويب الدائركت.",
    messagesetting_specificwords: "الكلمات المخصصة",
    messagesetting_autofiltering: "تصفية تلقائية (AI)",
    messagesetting_selectedwords: "العناصر المحددة",
    messagesetting_specificwordsexplain: "يمكنك إدخال عدة كلمات، افصل كل كلمة باستخدام حرف <Enter>.",
    messagesetting_Createanewsupportticket: "إنشاء تذكرة دعم",
    messagesetting_CreateanewsupportticketExplain:
      "يمكن للمستخدمين استخدام هذا الخيار لإنشاء تذكرة دعم في دایرکت الخاص بهم. يمكنك أيضًا الرد عليها عبر لوحة Brancy أو مباشرة في دایرکت.",
    messagesetting_Changeapplicationlanguage: "تغيير لغة خيارات دایرکت",
    messagesetting_ChangeapplicationlanguageExplain:
      "عند تفعيل هذا الخيار، يمكن للمستخدمين عرض جميع ميزات دایرکت بسبع لغات (الإنجليزية، الفارسية، العربية، الفرنسية، الروسية، التركية، والألمانية). سيقوم النظام بترجمة المحتويات تلقائيًا.",
    messagesetting_ViewStoreandproducts: "عرض المنتجات والمتجر",
    messagesetting_ViewStoreandproductsExplain:
      "باستخدام هذا الخيار، يمكن للمستخدمين عرض كتالوج منتجاتك في شكل قائمة أو ألبوم، مع تفاصيل مثل التوافر والسعر والمواصفات الأخرى.",
    messagesetting_Visityourwebsite: "عرض الموقع الإلكتروني",
    messagesetting_VisityourwebsiteExplain:
      "يمكن للمستخدمين عرض عنوان موقعك الإلكتروني وملخصًا عنه، وزيارته مباشرة إذا لزم الأمر. (ستكون سرعة تحميل الصفحة عالية جدًا.)",
    messagesetting_Viewuserrolesandpermissions: "قوانين ولوائح العمل",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "عند تفعيل هذا الخيار، يمكن للمستخدمين عرض القوانين واللوائح والقيود التي حددتها في إعدادات Brancy.",
    messagesetting_Viewbusinesshourschart: "ساعات عمل الشركة",
    messagesetting_ViewbusinesshourschartExplain:
      "يمكن للمستخدمين استخدام هذا الخيار لعرض ساعات عملك. يساعد هذا الخيار في تقليل الرسائل الواردة خارج أوقات العمل.",
    messagesetting_Viewpricinginformation: "أسعار الخدمات الإعلانية",
    messagesetting_ViewpricinginformationExplain:
      "عند تفعيل هذا الخيار، يمكن للمستخدمين عرض الأسعار المحدثة لكل خدمة إعلانية لديك، مما يقلل من الاستفسارات المتكررة.",
    messagesetting_Searchforproducts: "البحث عن المنتجات",
    messagesetting_SearchforproductsExplain:
      "يمكن للمستخدمين إرسال اسم المنتج أو رقم المنشور أو جزء من التسمية التوضيحية للحصول على تفاصيل المنتج الكاملة وإتمام عملية الشراء مباشرة. هذا الخيار يعزز نمو المبيعات.",
    messagesetting_addautomaticreplysystemsystem: "رد تلقائي موحد لجميع أقسام الصفحة",
    messagesetting_HideRobotReply: "إخفاء الرسائل التلقائية ورسائل البوت",
    messagesetting_HideRobotReplyExplain: "يتم إخفاء رسائل البوت التلقائية، ويتم عرض الرسائل الحقيقية فقط في الدایرکت",
    messagesetting_LikeRobotReply: "إعجاب تلقائي بتعليقات Story",
    messagesetting_HideRobotReplytooltip: "لا يتم حذف الرسائل، وإنما يتم إخفاؤها فقط لتسهيل إدارة الدایرکت",
    messagesetting_LikeRobotReplyExplain: "يتم عمل لايك تلقائيًا على تعليقات Story لزيادة التفاعل بشكل أسرع",
    messagesetting_automaticreplysystem: "التحكم في الردود التلقائية",
    messagesetting_automaticreplysystemforallpost: "تفعيل أو تعطيل الردود التلقائية على التعليقات لجميع Post",
    messagesetting_automaticreplysystemforallposttooltip:
      "إذا قمت بإعداد ردود تلقائية للتعليقات في عدة Post، يمكنك تفعيلها أو تعطيلها جميعًا دفعة واحدة من خلال هذا الخيار. ولتعديل الردود، يجب الدخول إلى صفحة كل Post بشكل منفصل",

    messagesetting_messagePanellanguage: "اللغة الافتراضية للدایرکت",
    messagesetting_messagePanellanguageExplain: "اللغة الافتراضية لروبوت الدایرکت للرد على الرسائل.",
    messagesetting_AutoReplyPerFollow: "قالب متابعة مخصص",
    messagesetting_AutoReplyPerFollowExplain: "يُستخدم هذا القالب عندما يُطلب من المستخدم متابعة الصفحة.",
    messagesetting_AutoReplyPerFollowtooltip:
      "المستخدمون الذين لا follow صفحتك سيتلقون أولاً طلب follow، وبعد المتابعة سيتم إرسال الرسالة التلقائية إليهم",
    messagesetting_AutoReplyPerFollowtitle: "نص الرسالة",
    messagesetting_AutoReplyPerFollowtitlesample: "مثال: للحصول على الرسالة، يرجى follow صفحتنا أولاً",
    messagesetting_AutoReplyPerFollowbtn: "نص الزر",
    messagesetting_AutoReplyPerFollowbtnsample: "مثال: لقد قمت بـ follow، أرسل الرسالة",
    messagesetting_automaticreplysystemexplain:
      "عند استلام أي رسالة أو تعليق في أي قسم من الصفحة (الخلاصة، الاستوري، الريلز، البث المباشر، إلخ)، يرد النظام تلقائيًا بالنص الذي تحدده.",
    messagesetting_KeywordSensitive: "حساس للكلمة",
    messagesetting_KeywordsSensitive: "حساس للكلمات",
    sendreplydirectedsuccessfully: "تم إرسال رسالة تأكيد في الكومنت بعد الدایرکت",

    autoReplyFor: "الرد التلقائي في",
    autocommentReplyExplain: "يقوم النظام بالرد تلقائيًا على التعليقات والرسائل المستلمة.",
    selectnewmessage: "لإرسال رد، يرجى اختيار رسالة.",
    sendreplyticket: "إرسال الردود",
    emptyticketdirect: "لم تتلق أي تذاكر من عملاء دایرکت صفحتك",
    emptysystemticket: "لم تتلق أي تذاكر من عملاء نظام Brancy",
    emptycomment: "لا توجد تعليقات للعرض بعد",
    emptydirect: "لا توجد رسائل دایركت للعرض بعد",

    respondToAllComments: "الرد على جميع التعليقات",
    sensitiveToSpecificKeywords: "حساس للكلمات الرئيسية المحددة",
    sensitiveToSpecificKeywordsExplain: "إذا ظهرت هذه الكلمات في أي جزء من نص التعليق، يقوم النظام بالرد تلقائيًا",
    contain: "يتضمن الكلمة",
    containExplain:
      "عند التفعيل، يتم الرد إذا احتوى التعليق على الكلمة. عند إيقافه، يتم الرد فقط إذا كان التعليق بالكامل مطابقًا للكلمة.",
    replyMethod: "طريقة الرد",
    respondInSameComment: "الرد في نفس التعليق",
    respondDirectly: "الرد عبر الدردشة المباشرة",
    ticketID: "معرف التذكرة",
    noNewAnsweredTickets: "لا توجد لديك تذاكر مُجاب عليها حديثًا",
    noNewPendingTickets: "لا توجد لديك تذاكر قيد المتابعة حديثًا",
    noNewClosedTickets: "لا توجد لديك تذاكر مغلقة",

    Ticketclosedby: "تم إغلاق التذكرة بواسطة",
    waitingforuserresponse: "في انتظار رد المستخدم",
    inactiveticketexpired: "تم إلغاء تنشيط هذه التذكرة بسبب عدم النشاط خلال الـ ٢٤ ساعة الماضية.",
    automaticreply: "رد تلقائي",
    autodirectexplain:
      "عندما يتم استلام كلمة رئيسية معينة في الدردشة المباشرة، سيتم إرسال ردك المحدد مسبقًا تلقائيًا في الدردشة المباشرة",
    adddirectexplain: "إضافة ردود تلقائية في الدردشة المباشرة",
    autocommentexplain: "عند استلام كلمة رئيسية معينة في تعليق، سيتم إرسال ردك المحدد مسبقًا تلقائيًا في نفس التعليق",
    addcommentexplain: "إضافة ردود تلقائية على التعليقات",
    messagesetting_icebreaker: "زر بدء محادثة سريعة",
    messagesetting_addNewButton: "إضافة زر جديد",
    messagesetting_icebreakerexplain:
      "عند دخول المستخدم إلى الدایرکت لأول مرة، تظهر أربعة أزرار، وعند اختيار أي منها، يتم إرسال الرد المقابل.",
    messagesetting_addicebreakerexplain: "أضف ما يصل إلى ٤ أزرار لبدء محادثة سريعة",
    messagesetting_PersistentMenu: "قائمة دائمة للدایرکت",
    messagesetting_PersistentMenuexplain:
      "قائمة متاحة دائمًا تجعل تفاعل العملاء مع علامتك التجارية سريعًا وسهلًا وبدون الحاجة إلى الكتابة.",
    messagesetting_addPersistentMenuexplain: "أضف ما يصل إلى ٣ أزرار قائمة دائمة",
    Welcometodirectmessages: "مرحبًا بك في رسائل Instagram المباشرة!",
    messagesetting_UseSystemButtonsExplain:
      "استخدم أزرار النظام الجاهزة لتقديم معلومات قياسية مثل عرض المتجر، تذكرة الدعم، وتغيير اللغة",
    messagesetting_UseAIPromptsExplain:
      "باستخدام برومبتات الذكاء الاصطناعي، قدّم ردودًا ذكية ومخصصة للمستخدمين بنبرة وأسلوبك الخاص",
    messagesetting_ButtonTitle: "عنوان الزر",
    messagesetting_NoPromptsFound: "لم يتم العثور على أي برومبت. سيتم توجيهك إلى صفحة الإنشاء لإنشاء برومبت جديد.",
    messagesetting_CreateNewPrompt: "إنشاء برومبت جديد",
    messagesetting_SelectYourPrompt: "اختر البرومبت الخاص بك",
    messagesetting_DefineCustomResponseExplain: "قم بتحديد نص الرد المخصص ليتم إرساله تلقائيًا إلى المستخدمين",
    messagesetting_SelectPredefinedFlowExplain: "اختر فلو مُعرّفًا مسبقًا لبدء محادثة ذكية وتلقائية مع المستخدم",
    messagesetting_NoFlowsFound: "لم يتم العثور على أي فلو. سيتم توجيهك إلى صفحة الإنشاء لإنشاء فلو جديد.",
    messagesetting_CreateNewFlow: "إنشاء فلو جديد",
    messagesetting_SelectFlow: "اختر الفلو",
    messagesetting_ViewFlow: "عرض الفلو",
    messagesetting_UseGeneralAIExplain: "استخدام الذكاء الاصطناعي العام للتفاعل الحر وغير المقيّد مع المستخدمين",
    tool_token_usage_guide: "الاستهلاك التقريبي للتوكن عند تشغيل هذه الأداة",
    tool_how_use: "طريقة استخدام الأداة",
    tool_how_work: "طريقة عمل الأداة",
    send_sms_ir_code_description: "إرسال رسالة SMS إلى هاتف المستخدم عبر منصة SMS.ir",
    send_sms_ir_code_completeDescription:
      "تُستخدم هذه الأداة لإرسال رسائل SMS إلى المستخدمين مثل أكواد التحقق والتسجيل والإشعارات. تتيح لك استقبال أرقام الهواتف واستخدامها في خدمة الرسائل النصية.",
    send_sms_ir_code_howUse: `1- احصل على ApiKey من منصة SMS.ir وأدخله.
2- أدخل قالب الرسالة في حقل TemplateId.
3- أينما يظهر {CODE} في القالب سيتم استبداله تلقائيًا برمز OTP.
`,
    send_sms_ir_code_howWork: `1- يرسل المستخدم رقم هاتفه في الدایرکت.
2- يتم إرسال SMS إلى المستخدم، وإذا احتوى على {CODE} يتم استبداله برمز OTP.
3- يرسل المستخدم الرمز إلى الذكاء الاصطناعي.
4- يقوم الذكاء الاصطناعي بالتحقق من الرمز وتأكيد رقم الهاتف.
`,

    send_to_telegram_description: "إرسال رسالة إلى تيليغرام عبر بوت",
    send_to_telegram_completeDescription:
      "تُستخدم هذه الأداة لإرسال رسائل إلى تيليغرام باستخدام بوت. يتم الإرسال عبر Bot Token إلى قناة أو محادثة محددة ويُستخدم للإشعارات والتنبيهات.",
    send_to_telegram_howUse: "1- أدخل Token البوت.\n2- أدخل معرف القناة أو الدردشة.\n3- شغّل الأداة لإرسال الرسالة.",
    send_to_telegram_howWork:
      "1- يقوم المستخدم بإدخال Token وChannel.\n2- النظام يجهز طلب عبر Telegram Bot API.\n3- يتم إرسال الرسالة إلى القناة أو الدردشة.",

    sender_username_description: "استخدام اسم المستخدم المرسل في البرومبت",
    sender_username_completeDescription:
      "تتيح هذه الأداة استخدام اسم المستخدم المرسل داخل برومبتات الذكاء الاصطناعي. عند إضافة {SENDER_USERNAME} يتم استبداله تلقائيًا باسم المستخدم.",
    sender_username_howUse: "1- ضع {SENDER_USERNAME} في البرومبت.\n2- يتم استبداله تلقائيًا باسم المستخدم عند التنفيذ.",
    sender_username_howWork:
      "1- يضع المستخدم {SENDER_USERNAME} في البرومبت.\n2- يتم استبداله باسم المستخدم أثناء المعالجة.\n3- يتم توليد الرد باستخدام اسم المستخدم.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "الأعلى سعراً",
    filter_cheapest: "الأرخص",
    filter_newest: "الأحدث",
    filter_highest_discount: "أعلى خصم",
    filter_all_products: "كل المنتجات",
    filter_only_available: "المنتجات المتوفرة فقط",
    filter_reset: "إعادة ضبط",
    filter_sortby: "ترتيب حسب",
    filter_category: "الفئة",
    filter_price: "السعر",
    Pricerange: "نطاق السعر",
    from: "من",
    to: "إلى",
    filter_rating: "التقييم",
    filter_followers: "المتابعين",
    default: "افتراضي",
    lowtohigh: "من الأقل إلى الأعلى",
    hightolow: "من الأعلى إلى الأقل",
    biolinkHomerating: "التقييم",
    biolinkHomefollower: "فالور",
    biolinkHomepost: "منشور",
    biolinkHomeAllMarkets: "الكل",
    biolinkHomeAdvertise: "المعلن",
    biolinkHomeStore: "متجر",
    biolinkStatisticsAllLinkclicks: "جميع النقرات على الروابط",
    biolinkStatisticsMarketviews: "مشاهدات السوق",
    biolinkStatisticsmostview: "الأكثر مشاهدة",
    biolinkStatisticscouponcodeused: "استخدام رمز القسيمة",
    biolinkStatisticslastupdate: "آخر تحديث",
    biolinkStatisticsAllsearches: "جميع عمليات البحث",
    biolinkStatisticsfeatures: "الميزات",
    biolinkStatisticsVisits: "الزيارات",
    biolinkStatisticsClicksAndInteractions: "النقرات والتفاعلات",
    biolinkStatisticsVisitsConverted: "الزيارات المحولة إلى نقرات",
    biolinkStatisticsQuickUserExitAfterEntry: "خروج سريع للمستخدمين بعد الدخول",
    biolinkStatisticsNoInteractionExit: "الخروج دون تفاعل",
    biolinkStatisticsMaxClicksPerVisit: "أكبر عدد نقرات لمستخدم واحد في زيارة واحدة",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "متوسط النقرات والتفاعلات لكل زائر",
    biolinkStatisticsTotalVisitTime: "إجمالي وقت الزيارة",
    biolinkStatisticsAvgVisitTime: "متوسط مدة بقاء الزائر",
    biolinkStatisticsVideoPlatformsComparison: "مقارنة منصات الفيديو",
    biolinkStatisticsYoutube: "يوتيوب",
    biolinkStatisticsAparat: "أبـارات",
    biolinkStatisticsTwitch: "تويتش",
    biolinkStatisticsPlatformEntry: "الدخول إلى المنصة",
    biolinkStatisticsRedirectEvent: "حدث التحويل",
    biolinkStatisticsPlayVideo: "تشغيل الفيديو",
    biolinkStatisticsPlayEvent: "حدث التشغيل",
    biolinkStatisticsUniqueVisit: "زيارة فريدة",
    biolinkStatisticsDedicatedLinkVisits: "زيارات الرابط المخصص",
    biolinkStatisticsCombinedLinkVisits: "مخطط الزيارات المدمجة للروابط",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "الميزات",
    biolinkPropertiesProfileInfoBanner: "معلومات الملف الشخصي والبنر",
    biolinkPropertiesFeaturebox: "صندوق الميزات",
    biolinkPropertiesTermsAndActiveTime: "الشروط وساعات العمل",
    biolinkPropertiesFeatureboxexplain: "من خلال تفعيل كل ميزة، يمكنك عرض معلومات مهمة لزوار صفحة الرابط الخاصة بك",
    biolinkPropertiesBanner: "الراية",
    biolinkPropertiesFeaturesBox: "صندوق الميزات",
    biolinkPropertiesReviews: "المراجعات",
    biolinkPropertiesAnnouncements: "الإعلانات",
    biolinkPropertiesAnnouncementsexplain:
      "يمكنك كتابة بعض التوضيحات في هذا القسم لإبلاغ زوار صفحة رابطك بالمعلومات المهمة",

    biolinkPropertiesOnlineStream: "البث المباشر",
    biolinkPropertiesOnlineStreamexplain:
      "عند تفعيل هذا الخيار، سيتم عرض أي بث مباشر تبدأه على قناتك تلقائيًا في رابطك المخصص",

    biolinkPropertiesLastVideo: "آخر فيديو",
    biolinkPropertiesLastVideoexplain:
      "عند تفعيل هذا الخيار، سيتم عرض أحدث فيديو تنشره على قناتك تلقائيًا في رابطك المخصص وسيتم تحديثه دائمًا",

    biolinkPropertiesProducts: "المنتجات",
    biolinkPropertiesProduct: "المنتج",
    biolinkProperties_showLast10Products: "عرض آخر 10 منتجات",
    biolinkProperties_showBestSellingProducts: "عرض المنتجات الأكثر مبيعًا",
    biolinkPropertiesAdsTimeline: "الجدول الزمني للإعلانات",
    biolinkPropertiesQandABox: "صندوق الأسئلة والأجوبة",
    biolinkPropertiesLinkShortcut: "الاختصار الرابط",
    biolinkPropertiesContactAndMap: "الاتصال والخريطة",
    biolinkPropertieslinks: "روابط",
    clickonstreamvideo: "اضغط على الفيديو لمشاهدة البث المباشر",
    livestarted: "البث المباشر جارٍ الآن",
    live: "مباشر",
    biolinkPropertiesaddnew: "إضافة رابط جديد",
    biolinkProperties_DomainManager: "إدارة النطاق",
    biolinkProperties_DomainManagerexplain: "موقعك الإلكتروني المخصص",
    biolinkProperties_DomainManagerexplain2: "يمكنك وضع هذا الرابط في Bio إنستغرام أو مشاركته مع المستخدمين الآخرين",

    biolinkProperties_explain: "عند تغيير اسم المستخدم في إنستغرام، سيتم تحديث هذا الرابط تلقائيًا.",
    biolinkProperties_rejected: "تم رفض النطاق الخاص بك (يرجى الاتصال بنا)",
    customDomain_inactive_title: "النطاق المخصص غير نشط",
    customDomain_inactive_desc: "نطاقك غير نشط حالياً. يرجى إرسال تذكرة دعم لتفعيله.",
    customDomain_noPackage_title: "لم يتم العثور على حزمة النطاق المخصص",
    customDomain_noPackage_desc: "حزمتك الحالية لا تدعم النطاق المخصص. يرجى ترقية حزمتك لاستخدام هذه الميزة.",
    customDomain_rule_validChars: "يُسمح فقط بالأحرف والأرقام",
    customDomain_rule_noUnderscore: "الرمزان (_) و (-) غير مسموح بهما",
    customDomain_rule_noSubdomain: "النطاقات الفرعية (Subdomain) غير مسموح بها",
    biolinkProperties_Request: "طلب",
    biolinkProperties_Requested: "تم الطلب",
    biolinkProperties_Checking: "جارٍ التحقق",
    biolinkProperties_yourstore: "المتجر (رابط متجرك)",
    biolinkProperties_yourads: "رابط طلب الإعلان",
    biolinkProperties_yourlottery: "السحوبات التي أجريتها",
    biolinkProperties_yourtariff: "التعريفة (جدول أسعارك)",
    biolinkProperties_yourBusinesshours: "ساعات عملك النشطة",
    biolinkProperties_yourBusinessTerms: "شروط عملك",
    biolinkProperties_defaultAddress: "عنوان النطاق الافتراضي ",
    biolinkProperties_CustomAddress: "عنوان النطاق المخصص لك",
    biolinkPropertiespopup_GeneralCustom: "عام",
    biolinkPropertiespopup_socialmedia: "وسائل التواصل الاجتماعي",
    biolinkPropertiespopup_mediastream: "الإعلام والبث",
    biolinkPropertiespopup_clouddrivecontent: "محتوى السحابة",
    biolinkPropertiespopup_Finance: "التمويل",
    biolinkProperties_followersrate: "عدد المتابعين",
    biolinkProperties_followersrateExplain: "يعرض عدد متابعي صفحتك على إنستغرام",
    biolinkProperties_successRating: "معدل النجاح",
    biolinkProperties_successRatingExplain: "يعرض درجة نجاحك في تنفيذ الطلبات",
    biolinkProperties_bussinessHours: "ساعات العمل النشطة",
    biolinkProperties_bussinessHoursExplain: "يعرض ساعات عمل نشاطك التجاري",
    biolinkProperties_Enamadverified: "توثيق إينماد",
    biolinkProperties_EnamadverifiedExplain: "يعرض حالة التحقق من علامة الثقة إينماد الخاصة بك",
    biolinkProperties_BusinessTerms: "شروط العمل",
    biolinkProperties_BusinessTermsExplain: "يعرض شروط وأحكام عملك",
    biolinkProperties_tariff: "التعرفة",
    biolinkProperties_TariffExplain: "يعرض أسعار خدماتك",
    biolinkProperties_StartADS: "بدء طلب الإعلان",
    biolinkProperties_StartADSExplain: "يمكن للمستخدم بدء الإعلان وفقًا لأسعارك",
    biolinkProperties_StartSALES: "بدء طلب الشراء",
    biolinkProperties_StartSALESExplain: "يمكن للمستخدم بدء الشراء بناءً على منتجاتك",
    biolinkProperties_NameServers: "خوادم أسماء النطاق",
    biolinkProperties_NameServersExplain: "قم بتسجيل خوادم أسماء النطاق في لوحة تحكم مزود النطاق الخاص بك",
    customDomain_dnsError: "لم يتم تسجيل خوادم أسماء النطاق لدى مزود النطاق الخاص بك حتى الآن. يرجى المحاولة مرة أخرى",
    customDomain_active_desc: "لتغيير هذا النطاق أو حذفه، أرسل طلبك من قسم تذكرة الدعم في الإعدادات",
    biolinkProperties_NameServerstooltip:
      "قد يستغرق طلبك ما يصل إلى 12 ساعة حتى يتم نشر خوادم الأسماء عبر الإنترنت ويصبح نطاقك نشطًا.",
    linkURL: "رابط URL",
    searchID: "إضافة قناة",
    searchIDexplain: "اكتب معرف الشخص أو اسم القناة المطلوبة",

    Browse: "تصفح",
    biolinkPropertiespopup_yourcustomIcon: "الأيقونة المخصصة لك",
    Boldit: "اجذب الانتباه!",

    Scheduletime: "الجدولة لإزالة تلقائية",
    biolinkPropertiespopup_ProfileInfo: "معلومات الملف الشخصي",
    biolinkPropertiespopup_Banner: "بانر",
    biolinkPropertiespopup_Personal: "شخصي",
    biolinkPropertiespopup_SameasInstagramProfile: "نفس ملف إنستغرام الشخصي",
    marketpropertise_aboutus: "تم إنشاء هذا الموقع باستخدام منصة برنسی",
    marketpropertise_copyright: "جميع حقوق هذا الموقع محفوظة لـ",
    marketpropertise_aboutusslogan: "برنسی هو الخيار الأفضل لإنشاء Biolink ذكي وإدارة صفحة Instagram الخاصة بك",
    marketpropertise_madeby: "صُنع بحب 🤍 بواسطة",

    custom: "مخصص",
    advertiseProperties_biography: "السيرة الذاتية",
    uploadbannerexplain: "قد يؤثر تحميل عدة صور على سرعة التحميل.",
    Embed: "تضمين الفيديو",
    Embedexplain:
      "عند تفعيل هذا الخيار، سيتم عرض وتشغيل الفيديو مباشرة في رابطك المخصص، ويمكن للمستخدم مشاهدته دون مغادرة الصفحة أو الانتقال إلى منصة أخرى",

    notfound: "لم يتم العثور عليه",
    showsavecontactbutton: "إظهار زر حفظ الاتصال",
    Map: "خريطة",
    Contact: "اتصال",
    Showmap: "إظهار الخريطة",
    location: "الموقع",
    phone: "الهاتف",
    invalidphone: "هاتف غير صالح",
    email: "البريد الإلكتروني",
    invalidemail: "بريد إلكتروني غير صالح",
    Address: "العنوان",
    // #endregion Market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "تفاصيل الإعلان",
    content: "المحتوى",
    advertise_orderdate: "تاريخ الطلب",
    advertise_duration: "المدة",
    Remaining: "المتبقي",
    ago: "منذ",
    // advertise -> calendar
    advertisecalendar_calendar: "التقويم",
    advertisecalendar_nextday: "الإعلانات القادمة لهذا اليوم",
    advertisecalendar_TODAY: "اليوم",
    advertisecalendar_BookaTime: "احجز وقت",
    advertisecalendar_TIMELINEZOOM: "تكبير الخط الزمني",
    advertisecalendar_Timeline: "الجدول الزمني",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "الشهرين الماضيين",
    advertisestatistics_lastmonth: "الشهر الماضي",
    advertisestatistics_thismonth: "هذا الشهر",
    advertisestatistics_ads: "إعلان",
    advertisestatistics_fromlast: "% من الشهر الماضي",
    advertisestatistics_totalADSstatistics: "إجمالي إحصائيات الإعلانات",
    advertisestatistics_TotalAds: "إجمالي الإعلانات",
    advertisestatistics_TotalIncome: "إجمالي الدخل",
    advertisestatistics_totaladsreport: "تقرير إجمالي الإعلانات",
    advertisestatistics_adno: "رقم الإعلان",
    advertisestatistics_advertiser: "المعلن",
    advertisestatistics_type: "النوع",
    advertisestatistics_status: "الحالة",
    advertisestatistics_price: "السعر",
    advertisestatistics_date: "التاريخ",
    advertisestatistics_share: "المشاركة",
    // advertise -> adlist
    advertiseadlist_activeAd: "الإعلانات المنشورة",
    advertiseadlist_AwaitingApproval: "الإعلانات قيد الانتظار",
    advertiseadlist_AwaitingPublication: "الإعلانات المجدولة",
    advertiseadlist_rejectedlist: "قائمة الإعلانات المرفوضة",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "الإعلانات المتزامنة",
    advertiseProperties_Concurrentadsexplain: "عدد الإعلانات النشطة في وقت محدد",
    advertiseProperties_numberofads: "عدد صفحات الإعلانات",
    advertiseProperties_numberofadsexplain: "عدد الإعلانات النشطة طوال اليوم",
    advertiseProperties_campaign: "حملة",
    advertiseProperties_campaignexplain: "إمكانية المشاركة في الحملات الإعلانية من خلال برنسی",
    advertiseProperties_adsoptions: "خيارات الإعلانات",
    advertiseProperties_rejectreasonheader1: "السبب ١ (محتوى غير ذي صلة)",
    advertiseProperties_rejectreasonheader2: "السبب ٢ (محتوى غير صحي)",
    advertiseProperties_rejectreasonheader3: "السبب ٣ (انتهاك السياسة)",
    advertiseProperties_rejectreasonheader4: "السبب ٤ (تغذية راجعة سلبية)",
    advertiseProperties_rejectreason1:
      "للأسف، المحتوى المقدم لا يتوافق مع قيم وأهداف صفحتنا، أو غير ملائم لجمهورنا العام، أو يفتقر إلى المعلومات الضرورية، لذلك لا يمكننا قبول هذا الإعلان.",
    advertiseProperties_rejectreason2:
      "للأسف، المحتوى المقدم قد يكون غير صحي أو مضلل أو يحتوي على معلومات معقدة لمتابعينا، ويحتاج إلى تغييرات واسعة النطاق، لذلك لا يمكننا قبول هذا الإعلان.",
    advertiseProperties_rejectreason3:
      "للأسف، المحتوى المقدم لا يتوافق مع قوانيننا أو إرشادات إنستغرام وقد يُعتبر غير معقول، مسيء، مثير للجدل، أو مجرم. لذلك لا يمكننا قبول هذا الإعلان.",
    advertiseProperties_rejectreason4:
      "للأسف، بسبب الحجم الكبير للإعلانات المماثلة، تضارب الجدول الزمني، ردود الفعل السلبية من المستخدمين في التجارب السابقة، أو انخفاض جودة المحتوى المقدم، لا يمكننا قبول هذا الإعلان.",
    advertiseProperties_AdvertisingTerms: "شروط الإعلان",
    advertiseProperties_AdvertisingTermsexplain: "يجب على المعلنين قبول هذه القواعد للإعلان على صفحتك.",
    advertiseProperties_AdvertisingTerm1: "شرط الصفحة ١",
    advertiseProperties_AdvertisingTerm2: "شرط الصفحة ٢",
    advertiseProperties_AdvertisingTerm3: "شرط الصفحة ٣",
    advertiseProperties_AdvertisingTerm4: "شرط الصفحة ٤",
    advertiseProperties_AdvertisingTermsave: "حفظ",
    advertiseProperties_businesshours: "ساعات العمل النشطة ادمین",
    advertiseProperties_24hours: "نشط على مدار ٢٤ ساعة",
    advertiseProperties_close: "غير نشط على مدار ٢٤ ساعة",
    advertiseProperties_notifications: "إشعارات",
    advertiseProperties_notificationsSMS: "رسالة نصية",
    advertiseProperties_notificationsEmail: "البريد الإلكتروني",
    advertiseProperties_notificationssystem: "إشعار النظام",
    advertiseProperties_notificationsinstagramdirect: "الرسائل المباشرة في إنستغرام",
    advertiseProperties_notificationssystemticket: "تذكرة",
    advertiseProperties_advertisetariff: "تعريفة الإعلان",
    advertiseProperties_onlyToday: "فقط لليوم",
    advertiseProperties_onlyTodayexplain: "تعريفة سعر الإعلان فقط لليوم",
    advertiseProperties_tariff12hours: "ساعة ۱۲",
    advertiseProperties_tariff24hours: "۲۴ ساعة",
    advertiseProperties_otherdays: "أساسي (أيام أخرى)",
    advertiseProperties_otherdaysexplain: "تعريفة سعر الإعلان للأيام الأخرى",
    advertiseProperties_Campaign: "حملة",
    advertiseProperties_Campaignexplain: "تعريفة سعر الإعلان للحملة",
    advertiseProperties_lastModified: "آخر تعديل",
    advertiseProperties_userreport: "تقرير المستخدم",
    advertiseProperties_userID: "معرّف المستخدم",
    advertiseProperties_reportexplain: "سيتم إرسال تقريرك إلى دعم برنسي.",
    advertiseProperties_reportsubmit: "إرسال",
    Apply: "تطبيق",
    signinyouradvertise: "تفعيل الإعلانات",
    signinyouradvertiseExplain: "قم بتفعيل إعلاناتك ببضع نقرات فقط",

    // #endregion advertise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "تفعيل المتجر",
    signinyourstore: "إنشاء متجرك",
    signinyourstoreExplain: "أنشئ متجرك ببضع نقرات فقط",
    Storeproduct_needyourID: "تأكيد الهوية",
    Storeproduct_needyourIDExplain: "قم بتحميل بطاقة الهوية",
    Storeproduct_successyourID: "تم تأكيد هويتك بنجاح",
    Storeproduct_NationalCardexplain: "يجب أن تكون هذه البطاقة تابعة للشخص الذي سجّل برقم هاتفه في برنسی.",
    Storeproduct_addcreditnumber: "المعلومات المالية",
    Storeproduct_addcreditnumberExplain: "أدخل بطاقتك البنكية",
    Storeproduct_successnumber: "تم تأكيد معلوماتك البنكية بنجاح",
    Storeproduct_shippingmethod: "طريقة الشحن",
    Storeproduct_shippingmethodExplain: "اختر طريقة الشحن المفضلة لديك",
    Storeproduct_shippingmethodsuccess: "تم تسجيل طريقة الشحن المختارة بنجاح",
    Storeproduct_shippingmethodtooltip:
      "تم اختيار الطرق المقترحة بناءً على موقعك. يمكنك تعديلها وتغييرها لاحقًا في إعدادات المتجر.",
    Storeproduct_uploadimagefirst: "يرجى أولاً تحميل صورة بطاقة الهوية الوطنية الخاصة بك",
    Storeproduct_creditcardsameidcard: "يجب أن يكون رقم البطاقة البنكية خاصًا بصاحب بطاقة الهوية الوطنية",
    Storeproduct_postalcode: "عنوان النشاط التجاري",
    Storeproduct_postalcodeExplain: "أدخل الرمز البريدي",
    Storeproduct_postalcodesuccess: "تم تسجيل العنوان والموقع بنجاح",
    Storeproduct_postalcodeinputExplain: "تُحسب تكلفة الشحن بناءً على هذا العنوان، الرجاء إدخال الرمز البريدي بدقة.",
    Storeproduct_TermsAndCondition: "الشروط والأحكام",
    Storeproduct_TermsAndConditionExplain: "اقرأ الشروط وقم بالموافقة عليها",
    Storeproduct_TermsAndConditionesuccess: "تم تسجيل قبول الشروط والأحكام بنجاح",
    Storeproduct_AcceptTermsAndCondition: "لقد قرأت جميع القوانين والأنظمة المتعلقة بإنشاء متجر في برنسی وأوافق عليها",
    Storeproduct_notyet: "لم تقم بإضافة أي منتج بعد!",
    Storeproduct_addnow: "أضف المنتجات الآن",
    Storeproduct_addexplain: "سيتم إضافتها تلقائيًا من صفحتك على إنستاجرام.",
    Storeproduct_productlist: "قائمة المنتجات",
    Storeproduct_search: "'PID' بحث عن 'اسم المنتج' أو ",
    Storeproduct_importproduct: "استيراد منتج",
    Storeproduct_importfrominsta: "استيراد من انستجرام الخاص بك",
    Storeproduct_newproduct: "منتج جديد",
    Storeproduct_addnewproduct: "إضافة منتج جديد",
    Storeproduct_name: "الاسم المنتج",
    Storeproduct_weight: "الوزن",
    Storeproduct_size: "الحجم",
    Storeproduct_color: "اللون",
    Storeproduct_stock: "المخزون",
    Storeproduct_price: "السعر",
    Storeproduct_active: "نشط",
    Storeproduct_gram: "جرام",
    bulkProduct: {
      title: "إدارة المنتجات المحددة",
      selectedCount: "{{count}} منتجات محددة",
      priceChange: "تغيير السعر",
      valueType: "نوع القيمة",
      amount: "المبلغ",
      increase: "زيادة",
      decrease: "تخفيض",
      applyAll: "تطبيق نفس التغيير على الجميع",
      applyIndividual: "تعيين كل منتج على حدة",
      allProducts: "تطبيق على {{count}} منتجات",
      discountAllHint: "حدد نسبة أو مبلغ خصم ثابت لجميع المنتجات المحددة.",
      priceAllHint: "قم بزيادة أو خفض أسعار جميع المنتجات بنسبة أو مبلغ ثابت.",
      currentDiscount: "الخصم الحالي",
      saving: "جارٍ الحفظ...",
    },
    loadingmoreproducts: "تحميل المزيد من المنتجات",
    noMoreProducts: "لا توجد منتجات أخرى",
    storestatistics_lasttwomonth: "آخر شهرين",
    storestatistics_lastmonth: "الشهر الماضي",
    storestatistics_thismonth: "هذا الشهر",
    storestatistics_sales: "المبيعات",
    storestatistics_fromlast: "٪ مقارنة بالشهر الماضي",
    storestatistics_totalSalesstatistics: "إحصائيات إجمالي المبيعات",
    storestatistics_TotalSales: "إجمالي المبيعات",
    storestatistics_TotalIncome: "إجمالي الإيرادات",
    storestatistics_totalsalesreport: "أفضل المشترين",
    storestatistics_buyer: "معلومات المشتري",
    storestatistics_totalPurchases: "إجمالي عدد المشتريات",
    storestatistics_totalAmount: "إجمالي قيمة المشتريات",
    storestatistics_lastPurchase: "آخر عملية شراء",
    storestatistics_saleno: "رقم البيع",
    storestatistics_seller: "البائع",
    storestatistics_type: "النوع",
    storestatistics_status: "الحالة",
    storestatistics_price: "السعر",
    storestatistics_date: "التاريخ",
    storestatistics_share: "مشاركة",
    storestatistics_couponTitle: "الخصومات",
    storestatistics_addCoupon: "إضافة رمز خصم",
    storestatistics_noCoupons: "لم يتم إنشاء رموز خصم بعد.",
    storestatistics_couponCode: "رمز الخصم",
    storestatistics_discountPercent: "نسبة الخصم",
    storestatistics_maxUses: "الحد الأقصى للاستخدام",
    storestatistics_phoneNumber: "رقم الهاتف",
    storestatistics_maxDiscountOptional: "الحد الأقصى للخصم (اختياري)",
    storestatistics_couponExpiry: "وقت الانتهاء (يجب أن يكون بعد ساعة واحدة على الأقل من الآن)",
    storestatistics_showInBio: "إظهار في النبذة",
    storestatistics_couponDeleted: "محذوف",
    storestatistics_couponExpired: "منتهي الصلاحية",
    storestatistics_couponExhausted: "مستنفد",
    storestatistics_couponActive: "نشط",
    storestatistics_unlimited: "غير محدود",
    storestatistics_couponUsage: "تم استخدام {{used}} من {{max}}",
    storestatistics_discountValue: "خصم {{discount}}٪",
    storestatistics_maxDiscountValue: "الحد الأقصى: {{value}}",
    storestatistics_expiryValue: "ينتهي في: {{date}}",
    storestatistics_private: "خاص",
    storestatistics_public: "عام",
    // Store -> order
    incartcount: "في السلة",
    addtocart: "إضافة إلى السلة",
    AllProducts: "جميع المنتجات",
    Storeproduct_inQueue: "في انتظار الموافقة",
    Storeproduct_inprogress: "جاري التنفيذ",
    Storeproduct_pickingup: "التقاط",
    Storeproduct_sent: "أُرسل",
    Storeproduct_delivered: "تم التسليم",
    Storeproduct_failed: "فشل",
    Storeproduct_canceledbyuser: "تم الإلغاء من قبل المشتري",
    Storeproduct_canceledbyadmin: "تم الإلغاء من قبل المسؤول",

    Storeproduct_returned: "تمت الإعادة",
    Storeproduct_yourcartisempty: "سلة التسوق فارغة",
    Storeproduct_noitemfounded: "لم يتم العثور على عناصر",
    Storeproduct_incart: "في عربة التسوق",
    ShowUnprocessedItemsOnly: "العناصر غير المعالجة",
    pageStatistics_fromstore: "من المتجر",
    order_addressSubject: "المنزل، مكان العمل",
    order_addressReceiver: "اسم المستلم في هذا العنوان",
    order_addressNote: "ملاحظة العنوان",

    ordernumber: "رقم الطلب",
    Storeorder_all: "الكل",
    Storeorder_ORDERID: "رقم الطلب",
    Storeorder_CUSTOMER: "العميل",
    Storeorder_ITEMS: "العناصر",
    Storeorder_ITEM: "عنصر",
    Storeorder_PRICE: "السعر",
    Storeorder_OrderDATE: "تاريخ الطلب",
    copytrackingcode: "نسخ رمز التتبع",
    Storeorder_SentDATE: "تاريخ الإرسال",
    Storeorder_deliverdate: "تاريخ التسليم",
    Storeorder_DELIVERY: "أرسل عبر",
    Storeorder_bymyself: "مرسل من قبلي",
    Storeorder_Envelope: "مغلف",
    Storeorder_Invoice: "فاتورة",

    Storeorder_DeliveryAmount: "تكلفة التوصيل",
    Storeorder_InsuranceAmount: "تكلفة التأمين",
    Storeorder_Coupon: "رمز الخصم",
    Storeorder_RemoveCoupon: "إزالة الرمز",
    Storeorder_Productsinyourshoppingcart: "المنتجات في سلة التسوق الخاصة بك",
    Storeorder_SendtotheAddress: "الإرسال إلى العنوان",
    Storeorder_changeofaddress: "تغيير العنوان",

    Storeorder_postparselbox: "صندوق بريدي",
    Storeorder_pocketenveloptitle: "عدد المنتجات في كل مغلف",
    Storeorder_pocketenveloptitleExplain:
      "يرجى تحديد عدد الوحدات من هذا المنتج التي يمكن وضعها في مغلف عادي (أو تغليفك القياسي).  يساعدنا هذا الرقم في إجراء حسابات دقيقة للتخزين والتغليف والشحن.",
    Storeorder_Destination: "الوجهة",
    Storeorder_STATUS: "الحالة",
    Storeorder_DETAILS: "التفاصيل",
    Storeorder_PickupRequest: "طلب الالتقاط",
    Storeorder_PrintWaybill: "طباعة بوليصة الشحن",
    Storeorder_Waybill: "بوليصة الشحن",
    Storeorder_WaybillExplain:
      "يرجى طباعة بوليصة الشحن وتثبيتها بوضوح وبشكل مسطح ومتين على الطرد قبل تقديم طلب الاستلام.",
    Storeorder_noneSendExplain:
      "نظرًا لعدم إمكانية إرسال هذه الحزمة عبر نظام إرسال برنسی وقمت بإرسالها شخصيًا وعلى مسؤوليتك الخاصة، يجب تأكيد هذه الخطوة.  عند التأكيد، سيتم إبلاغ المشتري بأن الحزمة قد تم إرسالها إليه.",
    Storeorder_ManualTrackingExplain:
      "نظرًا لتسليم الحزمة مباشرة إلى شركة الشحن من قبلك، يرجى إدخال رمز التتبع في الحقل المناسب بعد استلامه وتأكيد هذه الخطوة.  وبذلك، ستقوم برنسی تلقائيًا بإبلاغ المشتري برمز التتبع ومعلومات الشحن.",
    Storeorder_SendExplain: "سيتم تحديث معلومات هذا القسم تلقائيًا",

    Storeorder_requestedpickup: "في انتظار الاستلام",
    Storeorder_TrackingCode: "رمز التتبع",
    Storeorder_PostMan: "ساعي البريد",
    Storeorder_from: "إرسال من",
    Storeorder_currentLocation: "الموقع الحالي",
    Storeorder_lastUpdateTime: "آخر تحديث",
    Storeorder_sender: "المرسل",

    Storeorder_IssuingTrackingCode: "إصدار رمز التتبع",
    Storeorder_orderDetailsStep: "معلومات الطلب",
    Storeorder_orderconfirmStep: "حجم الطرد وبوليصة الشحن",
    Storeorder_orderlist: "قائمة الطلبات",
    Storeorder_singleorder: "طلب",
    Storeorder_quantityorder: "الكمية",
    Showmore: "عرض المزيد",
    totalprice: "السعر الإجمالي",
    note: "ملاحظة",
    navbar_PaymentNumber: "رمز تتبع الدفع",
    Storeorder_receiver: "المستلم",
    Storeorder_AcceptthisOrder: "تأكيد هذا الطلب",
    Storeorder_ParselisConfirmed: "أؤكد أن التفاصيل المدخلة صحيحة",
    Storeorder_ParselisConfirmedExplain: "إدخال حجم أو وزن غير صحيح قد يؤدي إلى غرامات وإرجاع الطرد",
    Storeorder_CancelOrder: "إلغاء الطلب",
    Storeorder_nextWaybill: "متابعة (استلام بوليصة الشحن)",
    Storeorder_Pickedup: "تم الالتقاط",
    SelectProduct: "اختر المنتج",
    SelectedPosts: "المنشورات المحددة:",
    product_BasicDetail: "تفاصيل أساسية",
    BacktoProductList: "العودة إلى قائمة المنتجات",
    Backtocart: "العودة إلى عربة التسوق",
    product_ProductID: "معرف المنتج",
    product_Producttitle: "عنوان المنتج",
    product_Product: "منتجات",
    product_Categories: "الفئات",
    product_MainCategory: "الفئة الرئيسية",
    product_Subcategory: "الفئة الفرعية",
    product_Subset: "مجموعة فرعية",
    product_Group: "المجموعة",
    product_Branch: "الفرع",
    product_Subbranch: "الفرع الفرعي",
    product_Dependency: "التبعیة",
    product_Brand: "العلامة التجارية",
    product_instagramcaption: "عنوان Instagram",
    product_productDescription: "وصف المنتج",
    product_Informationplaceholder:
      "يمكنك في هذا القسم كتابة وصف المنتج الخاص بك.\n\n يمكن أن يتضمن هذا الوصف معلومات كاملة وجذابة مثل\n الميزات، الفوائد، التفاصيل الرئيسية حول المنتج، أو كيفية استخدامه، والمكونات\n معبّرة بشكل مختصر وفعّال.\n\n سيتعرف العملاء على ميزات المنتج بشكل أفضل، وستزداد فرص بيع المنتج.",
    product_General: "عام",
    product_Specifications: "المواصفات",
    product_Information: "المعلومات",
    product_addNewTable: "إضافة جدول جديد",
    product_EditTable: "تعديل الجدول",
    product_PreviewTable: "جدول",
    product_addtable: "إنشاء جدول",
    product_tabletitle: "عنوان الجدول (اختياري)",
    product_tabletitleExplain: "مثال: جدول المقاسات",
    product_tableheaderoption: "الصف الأول كعنوان",
    product_AddColumn: "إضافة عمود بجانب هذا العمود",
    product_DeleteColumn: "حذف هذا العمود",
    product_AddRow: "إضافة صف تحت هذا الصف",
    product_DeleteRow: "حذف هذا الصف",
    rowheader: "عنوان",
    cell: "خلية",
    product_Media: "الوسائط",
    Nodescriptionavailable: "لا توجد معلومات متاحة",
    NoSpecificationsavailable: "لا توجد مواصفات متاحة",
    product_Properties: "الخصائص",
    product_Setting: "الإعدادات",
    product_productdeleted: "تم حذف المنتج بنجاح",
    product_SetProperties: "تعيين الخصائص",
    product_SetPropertiesexplain: "يمكنك اختيار ١-٣ خصائص ويمكن أن يكون أحدها مخصصًا",
    product_AddNewproperty: "إضافة خاصية جديدة",
    product_Nopropertyisset: "لم يتم تعيين أي خاصية",
    product_Variation: "تنوع",
    product_Discount: "خصم",
    product_PricewithDiscount: "السعر مع الخصم",
    product_AddNewVariation: "إضافة تنوع جديد",
    product_Definenew: "تعريف جديد (مخصص)",
    product_systemlist: "قائمة افتراضية ذكية",
    product_itemlist: "قائمة العناصر",
    product_Available: "متوفر",
    product_supplying: "قيد التوريد",
    product_OutOfStock: "غير متوفر",
    product_Stoppedsale: "توقف البيع",
    product_draft: "مسودة",
    product_Amount: "الكمية",
    product_NUMBEROFUSES: "عدد مرات الاستخدام",
    product_UNLIMITED: "غير محدود",
    product_LIMITED: "محدود",
    product_USINGTIMES: "مدة الاستخدام",
    product_UNLIMITEDTIME: "وقت غير محدود",
    permanent: "دائم",
    product_LIMITEDTIME: "وقت محدود",
    product_mediatitle: "إدارة صور وفيديوهات المنتج",
    product_clicktoupload: "انقر للتحميل",
    product_SuggestedImages: "الصور المقترحة",
    product_SuggestedImagesExplain:
      "قم بتحسين معرض المنتج الخاص بك باستخدام الصور المقترحة أو قم بتحميل الصور التي تريدها",
    product_ordragdrop: "أو اسحب وأفلت",
    product_productspecifications: "مواصفات المنتج",
    product_choosesystemlist: "اختر من قائمة الأنظمة",
    product_choosesystemlistexplain: "ابحث واختر أي مواصفات تحتاجها",
    product_Definenewexplain: "إذا لم تتمكن من العثور على مواصفات، أنشئ ذلك",
    product_importbatch: "استيراد دفعة",
    product_importbatchexplain: "أضف جميع المواصفات من المنتج السابق",
    Value: "القيمة",
    Undefined: "غير محدد",
    product_original: "أصلي",
    product_HighCopy: "نسخة عالية",
    product_notoriginal: "غير أصلي",
    product_Corporate: "مؤسسي",
    product_Miscellaneous: "متنوع",
    product_fake: "مزيف",
    tomorrow: "غدًا",
    NotSet: "غير مضبوط",
    Yes: "نعم",
    No: "لا",
    "Video generation request sent.": "تم إرسال طلب إنشاء الفيديو.",
    "Image generation request sent.": "تم إرسال طلب إنشاء الصورة.",
    ", Image generation failed.": "، فشل إنشاء الصورة.",
    "Create and manage AI-generated images and videos.": "أنشئ الصور ومقاطع الفيديو المولدة بالذكاء الاصطناعي وأدرها.",
    Storeproduct_OutOfStandardSize: "خارج عن الحجم القياسي",
    product_box: "حجم الصندوق",
    Product_Availablity: "التوفر",
    Product_maxincart: "الحد الأقصى في السلة",
    Product_originality: "الأصالة",
    Product_preperingforship: "التجهيز للشحن",
    Product_Evat: "ضريبة القيمة المضافة",
    Product_Evatcount: "قيمة الضريبة",
    Product_Guarantee: "الضمان",
    Product_Guaranteelength: "مدة الضمان",
    Product_packageshipping: "التغليف والشحن",
    Product_packageshippingexplain: "بتعطيل هذا الخيار، ستكون مسؤولًا عن شحن المنتج والخدمات المرتبطة الأخرى",
    Product_titleExplain:
      "يتم تقديم العناوين المقترحة بناءً على ميزات منتجك ومتوسط العناوين المشابهة في السوق لزيادة ظهوره في عمليات البحث والمنتجات المشابهة.\n (قد تحتوي هذه العناوين على أخطاء)",
    Product_Breakable: "قابل للكسر",
    Product_Luquid: "سائل",
    Product_sack: "كيس / حقيبة",
    Product_sackExplain:
      "إذا كان يتم إرسال منتجك في كيس، حقيبة، أو أي تغليف ناعم ومرن، فاختر هذا الخيار. هذا يساعدنا على تحسين ترتيب المنتجات والنقل والتغليف.",
    Product_Productweights: "أوزان المنتج",
    Product_Productweightsexplian: "الوزن الصافي للمنتج بدون التغليف",
    Product_packaging: "التغليف",
    Product_packagingexplian:
      "وزن تغليف المنتج بدون المحتويات الداخلية، بما في ذلك الكرتون اللازم للتغليف، الشريط اللاصق، وبطاقة الشحن التي يتم احتسابها من قبل النظام",
    Product_shippingSize: "حجم الشحن ",
    product_SuggestedPrice: "تحليل سعر هذا المنتج في السوق بأكملها",
    product_MinimumPrice: "أقل سعر",
    product_AveragePrice: "متوسط السعر",
    product_MaximumPrice: "أعلى سعر",
    length: "الطول",
    width: "عرض",
    height: "ارتفاع",
    Weight: "الوزن ",
    finalWeight: "الوزن النهائي",
    product_deleteproductexplain: "أنت تحاول حذف هذا المنتج.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "نظام",
    SettingGeneralSystemlanguage: "اللغة",
    SettingGeneralSystemcalendar: "التقويم",
    SettingGeneralSystemGregorian: "ميلادي",
    SettingGeneralSystemshamsi: "شمسي",
    SettingGeneralSystemHijri: "هجري",
    SettingGeneralSystemHindi: "هندي",
    SettingGeneralSystemStartWeek: "بداية الأسبوع",
    SettingGeneralSystemsaturday: "السبت",
    SettingGeneralSystemmonday: "الاثنين",
    SettingGeneralSystemtuesday: "الثلاثاء",
    SettingGeneralSystemwednesday: "الأربعاء",
    SettingGeneralSystemthursday: " الخميس",
    SettingGeneralSystemfriday: " الجمعة",
    SettingGeneralSystemsunday: "الأحد",
    SettingGeneralSystemtheme: "الموضوع",
    SettingGeneralSystemDarkmode: "الوضع الداكن",
    SettingGeneralSystemlightmode: "الوضع الفاتح",
    SettingGeneralSystemPrice: "نموذج السعر",
    SettingGeneralSystemDollar: "دولار",
    SettingGeneralSystemeuro: "يورو",
    SettingGeneralSystempound: "جنيه",
    SettingGeneralSystemrial: "ريال",
    SettingGeneralSystemtoman: "تومان",
    SettingGeneralAiModelsTitle: "نماذج الذكاء الاصطناعي",
    SettingGeneralAiModelsTextModels: "نماذج النص",
    SettingGeneralAiModelsVoiceModels: "نماذج تحويل الصوت إلى نص",
    SettingGeneralAiModelsDirectVoiceSupport: "دعم الصوت المباشر",
    // Setting -> General -> Profile
    SettingGeneralProfileTitle: "ملف شخصي",
    SettingGeneral_activedevice: "الأجهزة النشطة",
    SettingGeneral_leatestentery: "سجل نشاط المستخدم",
    SettingGeneral_cantdeletesession: "لا يمكن حذف الجلسات التي لم يمضِ على إنشائها ٢٤ ساعة.",
    SettingGeneral_deletesession: "أنت تحاول حذف هذه الجلسة.",
    SettingGeneral_addSubAdmin: "إضافة مشرف مساعد",
    SettingGeneral_addSubAdminExplain: "إضافة مشرف مساعد بصلاحيات محدودة",
    SettingGeneral_addSubAdminExplain2: "دعوة أدمن بصلاحيات محدودة وآمنة، دون الحاجة لتسجيل الدخول إلى إنستغرام.",

    SettingGeneral_addSubAdmintitleExplain: "أدخل رقم المشرف الجديد لإرسال الدعوة، وسيتم تفعيل الوصول بعد التأكيد.",
    SettingGeneral_accesslevel: "مستوى الوصول",
    SettingGeneral_access: "الوصول",
    SettingGeneral_partnertitle: "عنوان الأدمن المتعاون",
    SettingGeneral_partnernumberexplain:
      "سيتم إرسال دعوة إلى هذا الرقم، ويجب على الأدمن المتعاون تأكيدها في لوحته (يجب أن يسجل الأدمن في برنسی ليتمكن من قبول الدعوة).",
    SettingGeneral_contentTooltip: "المنشورات والقصص وReels وIGTV والمنشورات المتعددة.",
    SettingGeneral_publishTooltip: "إنشاء المنشورات والقصص وإنشاء المحتوى. يتطلب ذلك صلاحية المحتوى.",
    SettingGeneral_automaticsTooltip: "الذكاء الاصطناعي والتدفقات والعمليات والمهام الآلية. يتطلب ذلك صلاحية المحتوى.",
    SettingGeneral_messageTooltip: "الرسائل المباشرة في Instagram والرسائل الداخلية والأدوات المرتبطة.",
    SettingGeneral_commentTooltip: "التعليقات والردود والأدوات المرتبطة.",
    SettingGeneral_transactionTooltip: "إدارة حساب الدفع والمعاملات والمحفظة والأدوات المرتبطة.",
    SettingGeneral_adsTooltip: "إدارة التقويم والمعلنين وقبول الإعلانات والتسعير والأدوات المرتبطة.",
    SettingGeneral_ordersTooltip: "المنتجات والأسعار ومخزون المستودع والطلبات ووثائق الشحن والأدوات المرتبطة.",
    SettingGeneral_bioTooltip: "محتوى السيرة وترتيبه والروابط واختصارات محتوى الجهات الخارجية.",
    SettingGeneral_ticketTooltip: "إدارة علاقات العملاء وتذاكر النظام والدعم.",
    SettingGeneral_productsTooltip: "أدوات إدارة المنتجات.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "الدعم العام",
    SettingGeneral_Customerservices: "خدمات العملاء",
    SettingGeneral_ReportBug: "الإبلاغ عن خطأ",
    SettingGeneral_Advertise: "الإعلان",
    SettingGeneral_Store: "المتجر",
    SettingGeneral_biolink: "رابط البايو",
    SettingGeneral_Walletandfinance: "المحفظة والمالية",
    SettingGeneral_MessageingandComment: "الرسائل والتعليقات",
    SettingGeneral_Support: "الدعم",
    SettingGeneral_Department: "القسم",
    SettingGeneral_Title: "العنوان",
    SettingGeneral_Description: "الوصف",
    SettingGeneral_Send: "إرسال",
    // #endregion Setting Section
    userpanel_market: "السوق",
    userpanel_order: "الطلب",
    userpanel_Messages: "الرسائل",
    userpanel_Settings: "الإعدادات",
    userpanel_PersonalInfo: "معلومات شخصية",
    userpanel_UploadNewPicture: "تحميل صورة جديدة",
    userpanel_Instagramid: "معرف إنستغرام",
    userpanel_Nameandfamily: "الاسم والعائلة",
    userpanel_NationalCode: "الرقم الوطني",
    userpanel_BirthDay: "تاريخ الميلاد",
    userpanel_MobileNumber: "رقم الجوال",
    userpanel_Email: "البريد الإلكتروني",
    userpanel_CreditNumber: "رقم البطاقة الائتمانية",
    userpanel_Addresses: "العناوين",
    userpanel_AddNewAddress: "إضافة عنوان جديد",
    userpanel_ZipCode: "الرمز البريدي",
    userpanel_Address: "العنوان",
    userpanel_EditAddress: "تعديل العنوان",
    userpanel_AddNewAddressexplain: "سيتم تسليم الطرد إلى هذا العنوان والشخص",
    startbusiness: "بدء عمل تجاري",
    AI: "ذكاء اصطناعي",
    ExtraTokens: "رموز إضافية",
    TokenUsage: "استخدام التوكن",
    AdvancedAnalytics: "تحليل متقدم",
    AIResponse: "رد ذكي لإنستغرام",
    CustomSupport: "دعم مخصص",
    CustomDomain: "نطاق مخصص",
    WinnerPicker: "اختيار الفائز",
    WinnerPickerReserve: "سحب احتياطي",

    dataTable1_feature1: "إدارة الـ Post والإحصاءات الاحترافية",
    dataTable1_tooltip1:
      "جدولة سهلة لنشر الـ Post. رسوم بيانية وإحصاءات دقيقة لكل Post تشمل: (لایک، مشاركة، Comment، حفظ، معدل التفاعل، Reach، Impression، عدد التشغيل، الاحتفاظ، Follow/Unfollow، نشاط الملف الشخصي، الهاشتاغات المستخدمة)، والمزيد...",

    dataTable1_feature2: "إنشاء Post جديد",
    dataTable1_tooltip2:
      "اقتراح أفضل وقت وتاريخ حسب صفحتك. جدولة الـ Post. حفظ الهاشتاغات للاستخدام المتكرر. الرد التلقائي على الـ Comments. حفظ الـ Post كمسودة، وغير ذلك.",

    dataTable1_feature3: "إدارة الـ Story والإحصاءات الدقيقة",
    dataTable1_tooltip3:
      "جدولة الـ Story. إحصاءات ورسوم بيانية كاملة لكل Story: (لایک، مشاركة، Comment، حفظ، معدل التفاعل، Reach، Impression، عدد التشغيل، الاحتفاظ، Follow/Unfollow، نشاط الملف الشخصي، Direct، لقطة شاشة)، وغير ذلك...",

    dataTable1_feature4: "إنشاء Story جديد",
    dataTable1_tooltip4:
      "اقتراح أفضل وقت وتاريخ حسب صفحتك. جدولة الـ Story. الرد التلقائي على الـ Comments. حفظ الـ Story كمسودة، وغير ذلك.",

    dataTable1_feature5: "إحصائيات عامة للصفحة",
    dataTable1_tooltip5:
      "عدد الـ Posts والـ Stories. الترتيب حسب الأعلى والأدنى في الـ Views، الـ Comments، والـ Likes. التعرف على أفضل وأسوأ وقت للنشر (مع رسوم بيانية). تاريخ الـ Likes، Follow/Unfollow، Views، Comments، الزوار الأشباح. تحديد أفضل الـ Followers. مقارنة بالإحصاءات السابقة، وغير ذلك...",

    dataTable1_feature6: "إدارة الهاشتاغات",
    dataTable1_tooltip6:
      "إنشاء قوائم غير محدودة من الهاشتاغات. توليد ذكي لهاشتاغات عبر تحليل الصور (الذكاء الاصطناعي). توليد ذكي عبر تحليل الصفحة. عرض الهاشتاغات المستخدمة. قائمة الهاشتاغات الشائعة (حسب اليوم، الأسبوع، الشهر واللغة: إنجليزي، فارسي، عربي...).",

    dataTable1_feature7: "إعجاب تلقائي بـ Comments الجديدة",
    dataTable1_tooltip7:
      "إعجاب تلقائي بـ Comments الجديدة من الـ Followers على كل Post. عرض التاريخ كرسوم بيانية وقوائم.",

    dataTable1_feature8: "قرعة عشوائية بين الـ Followers",
    dataTable1_tooltip8:
      "اختيار أفضل Follower بناءً على الـ Likes و الـ Comments. اختيار فائز عشوائي. تحديد عدد الفائزين. إنشاء ونشر Story للإعلان التلقائي عن النتائج. تتبع تاريخ القرعة برمز مخصص، والمزيد...",

    dataTable1_feature9: "قرعة بالنقاط بين الـ Followers",
    dataTable1_tooltip9:
      "تحديد المهام للمشاركة في القرعة (لایک، Comment، Mention، Follow). تحديد عدد الفائزين. إنشاء ونشر Story لشروط القرعة تلقائياً. تذكير تلقائي. نشر Story النتائج تلقائياً. تتبع التاريخ برمز خاص، والمزيد...",
    WithStrongCallToAction: "مع دعوة قوية لاتخاذ إجراء",
    WithProsAndCons: "مع الإيجابيات والسلبيات",
    ForComparison: "للمقارنة",
    WithKeyPoints: "مع النقاط الرئيسية",
    ForPromotionalPost: "مخصص لمنشور ترويجي",
    WithDetailedExplanation: "مع شرح كامل",
    PersuasiveStyle: "بأسلوب إقناعي",
    ForProductIntroduction: "لتقديم المنتج",
    LongText: "كنص طويل",
    Aipromptexplain: "برانسي يحلل محتوى صفحتك للتعرف على أسلوبك ونبرة كتابتك؛ لا حاجة لشرح إضافي!",
    ImagineSomething: "تخيل شيئًا... ✦",
    Generating: "جاري الإنشاء...",
    AccessAndManageComments: "الوصول وإدارة التعليقات",
    AccessAndManageMessages: "الوصول وإدارة الرسائل",
    AccessAndPublishContent: "الوصول ونشر المحتوى",
    AccessAndManageInsights: "الوصول وإدارة الإحصاءات والتقارير",
    AccessAndManageCommentsExplain: "لإدارة تعليقات إنستجرام، انقر على «تفعيل الإذن» ووافق عليه في الصفحة المفتوحة.",
    AccessAndManageMessagesExplain: "لإدارة رسائل إنستجرام، انقر على «تفعيل الإذن» ووافق عليه في الصفحة المفتوحة.",
    AccessAndPublishContentExplain: "لعرض ونشر محتوى إنستجرام، انقر على «تفعيل الإذن» ووافق عليه في الصفحة المفتوحة.",
    AccessAndManageInsightsExplain: "لإدارة إحصاءات إنستجرام، انقر على «تفعيل الإذن» ووافق عليه في الصفحة المفتوحة.",
    EnablePermission: "تفعيل الإذن",
    instagramTutorialTitle: "دليل الاتصال بإنستجرام",
    instagramTutorialStep1Title: "الخطوة 1: تسجيل دخول آمن",
    instagramTutorialStep1Text:
      "انقر على «ربط حساب إنستجرام» للانتقال إلى instagram.com وقم بتسجيل الدخول. هذا يضمن أمان بياناتك واتصالًا موثوقًا.",
    instagramTutorialStep2Title: "الخطوة 2: تأكيد الأذونات",
    instagramTutorialStep2Text:
      "بعد تسجيل الدخول، سيطلب إنستجرام أذونات للوصول إلى معلوماتك العامة. وافق عليها جميعًا لضمان عمل النظام بشكل صحيح.",
    instagramremoveStep1Title: "الخطوة 3: فحص الأذونات",
    instagramremoveStep1text: "انتقل إلى الإعدادات لعرض جميع الأذونات النشطة لحسابك.",
    instagramremoveStep2Title: "الخطوة 4: إدارة وحذف الأذونات غير الضرورية",
    instagramremoveStep2text:
      "برنسی شريك رسمي لإنستجرام، لذلك لا حاجة لخدمات أخرى. لأمان أكبر، احذف الأذونات غير اللازمة.",

    understood: "فهمت",
    previous: "السابق",
    connectTutorial: "دليل الاتصال",
    invalidcode: "رمز غير صالح",
    wearesorry: "نعتذر!",
    PaymentFailed: "فشل الدفع!",
    thankyou: "شكراً لك!",
    Paymentsuccess: "تم الدفع بنجاح!",

    TransactionNumber: "رقم العملية:",
    TransactiontrackingNumber: "رقم تتبع العملية:",
    InvoiceNumber: "رقم الفاتورة:",

    mainSubscriptionPlan: "الاشتراك الرئيسي",
    Tokens: "توکن",
    tokenExplain: "التوكن هو وحدة استهلاك خدمات الذكاء الاصطناعي؛ في المتوسط، معالجة 100 طلب تتطلب حوالي 1000 توكن.",
    ReserveToken: "رمز احتياطي",
    packageTokenExplain:
      "الرموز المجانية التي تُفعّل مع الباقة ويمكن استخدامها حتى انتهاء صلاحية الباقة؛ وبعدها تنتهي صلاحيتها.",
    ReserveTokenExplain: "الرموز الاحتياطية المشتراة التي لا تنتهي صلاحيتها مع مرور الوقت.",

    pageTools_Months: "أشهر",
    subscriptionExpired: "انتهى اشتراكك، قم بالتجديد",
    subscriptionExpireSoon: "سينتهي اشتراكك قريباً",
    subscriptionManagement: "إدارة الاشتراك",
    subscription: "اشتراك",
    AIAssisment: "المساعد الذكي",
    timeperiod: "الفترة المتبقية",
    domain: "النطاق",
    winnerpickerexpired: "لم يعد بإمكانك إجراء قرعة،  يرجى إعادة الشحن",
    winnerpickerexpiresoon: "محاولات القرعة الخاصة بك توشك على الانتهاء",
    Aiexpired: "لم يعد بإمكانك استخدام الذكاء الاصطناعي، يرجى إعادة الشحن.",
    Aiexpiresoon: "رموز الذكاء الاصطناعي الخاصة بك على وشك النفاد.",

    followercount: "عدد الفالور",
    yourCurrentSubscription: "اشتراكك الحالي",
    noItemsAvailableContactSupport: "هذا القسم غير متاح حالياً. يرجى التواصل مع دعم برنسی عن طريق إرسال تذكرة.",

    // #region AIFlow Section
    AIAssismentexplain:
      "باستخدام مساعد برنسی للذكاء الاصطناعي، يمكنك إنشاء تدفقات محادثة ذكية للرد التلقائي على رسائل وتعليقات إنستغرام",
    livetest: "اختبار مباشر",
    testlab: "مختبر الاختبار",
    promptmode: "وضع البرومبت",
    promptanalysis: "تحليل البرومبت",
    promptanalysisExplain: "أدخل مطالبتك بالتفصيل؛ سيحللها برنسی بناءً على شخصيتك ونبرة صوتك وأسلوب تفاعلك.",
    promptanalysisplaceholder: "أدخل 20 حرفًا على الأقل لتحليل البرومبت",
    reanalyze: "إعادة التحليل",
    shouldFollowerexplain: "يتم إرسال الرد فقط إلى المستخدمين الذين قاموا بمتابعتك",
    RenewForThread: "تجديد تدفق المحادثة",
    RenewForThreadexplain: "في كل محادثة، إذا أرسل المستخدم رسالة جديدة، يبدأ تدفق المحادثة من البداية",
    prompt: "برومبت",
    promptanalysisexplain: "يقوم برنسی بتحليل البرومبت الخاص بك ويقترح أفضل الإعدادات للردود الذكية",

    autosave: "حفظ تلقائي",
    Restrictorzoom: "تقييد التكبير",
    snapGrid: "محاذاة إلى الشبكة",
    PanningBoundary: "حدود التحريك",
    Flow: "التدفق",
    flowtitle: "عنوان التدفق",
    AIFlow_input: "إدخال",
    AIFlow_input_message_block: "رسالة إدخال المستخدم",
    AIFlow_output: "إخراج",
    AIFlow_output_title: "عنوان الإخراج",
    AIFlow_text: "نص",
    AIFlow_item_text: "عنصر",
    AIFlow_block_title_required: "يرجى إدخال عنوان الكتلة (إلزامي)",
    AIFlow_item_title: "عنوان العنصر:",
    AIFlow_show_graph: "عرض مخطط التدفق",
    AIFlow_connect_post: "ربط بمنشور",
    AIFlow_connect_post_access: "يلزم إذن التعليقات والرسائل وصلاحية الوصول إلى الأتمتة والتعليقات.",
    AIFlow_connect_post_save_first: "احفظ هذا التدفق قبل ربطه بمنشور.",
    AIFlow_connect_post_confirm:
      "سيحل هذا التدفق محل الرد التلقائي الحالي للمنشور ويتم تفعيله. تبقى الكلمات المفتاحية وإعدادات المطابقة الحالية؛ ومن دون كلمات مفتاحية، يرد التدفق على جميع التعليقات.",
    AIFlow_connect_post_resume: "تم حفظ ربط التدفق، لكن التفعيل فشل. حاول تفعيله مرة أخرى.",
    AIFlow_connect_post_incompatible: "هذا التدفق غير متوافق مع الردود الخاصة على التعليقات. عدله واحفظه قبل الربط.",
    AIFlow_retry: "حاول مرة أخرى",
    AIPrompt_connect_post_access: "يلزم إذن تعليقات Instagram وصلاحية الوصول إلى الأتمتة والتعليقات.",
    AIPrompt_connect_post_confirm:
      "سيحل هذا الذكاء الاصطناعي محل الرد التلقائي الحالي للمنشور ويتم تفعيله. تبقى الكلمات المفتاحية وإعدادات المطابقة؛ ومن دون كلمات مفتاحية، تتم الإجابة على جميع التعليقات. يبقى الإرسال الخاص فقط عند توفر إذن الرسائل؛ وإلا ترسل الردود كتعليقات.",
    AIPrompt_connect_post_resume: "تم حفظ ربط الذكاء الاصطناعي، لكن التفعيل فشل. حاول تفعيله مرة أخرى.",
    messagesetting_PhoneNumbers: "أرقام الهاتف",
    messagesetting_PhoneNumbersExplain: "أرقام الهاتف التي تم جمعها من عملائك عبر التدفقات",
    messagesetting_PhoneNumbersEmpty: "لم يتم جمع أي أرقام هاتف بعد",
    AIFlow_item_subtitle: "العنوان الفرعي للعنصر:",
    AIFlow_option_title: "عنوان الخيار",
    AIFlow_option_default: "خيار",
    AIFlow_quick_reply: "رد سريع",
    AIFlow_quick_reply_validation_error: "يجب ملء جميع حقول الرد السريع!",
    AIFlow_quick_reply_block_title_empty: "الكتلة {label}\n لا يوجد عنوان",
    AIFlow_quick_reply_option_title_empty: "الكتلة {label}\n الخيار {index} بلا عنوان",
    AIFlow_delete_image: "🗑️ حذف الصورة",
    AIFlow_delete_image_button_text: "🗑️ حذف الصورة",
    AIFlow_delete_all_block: "🗑️ حذف الكتلة",
    AIFlow_delete_all_blocks: "حذف كامل التدفق",
    AIFlow_save_all_blocks: "حفظ كامل التدفق",
    AIFlow_delete: "🗑️ حذف",
    AIFlow_upload_image: "📷 رفع صورة",
    AIFlow_image_uploaded: "✓ تم رفع الصورة",
    AIFlow_add_image: "📷 إضافة صورة",
    AIFlow_voice_recorded: "🎵 صوت مسجل",
    AIFlow_record_voice: "🎤 تسجيل صوت",
    AIFlow_record_voice_confirm: "هل أنت جاهز للتسجيل؟ (3 ثواني على الأقل)",
    AIFlow_play_voice: "▶️ تشغيل الصوت",
    AIFlow_add_output: "إضافة إخراج جديد",
    AIFlow_add_subtitle: "➕ إضافة عنوان فرعي",
    AIFlow_subtitle_input: "يرجى إدخال العنوان الفرعي:",
    AIFlow_link: "رابط:",
    AIFlow_general_block: "كتلة عامة",
    AIFlow_text_block: "كتلة نص",
    AIFlow_image_block: "كتلة صورة",
    AIFlow_voice_block: "كتلة صوت",
    AIFlow_quick_reply_block: "كتلة الرد السريع",
    AIFlow_weblink_block: "كتلة رابط ويب",
    AIFlow_add_text_block: " إضافة كتلة نص",
    AIFlow_add_image_block: " إضافة كتلة صورة",
    AIFlow_add_voice_block: " إضافة كتلة صوت",
    AIFlow_add_quick_reply_block: " إضافة رد سريع",
    AIFlow_add_general_block: " إضافة كتلة عامة",
    AIFlow_add_weblink_block: " إضافة رابط ويب",
    AIFlow_generic_block: "كتلة فرعية عامة",
    AutoLayout_block: "تخطيط تلقائي للطبقات",
    AIFlow_live_test_block: "اختبار التدفق المباشر",
    AIFlow_Deleteallblocks_alert: "هل أنت متأكد أنك تريد حذف التدفق بالكامل؟",
    AIFlow_add_output_error_alert: "خطأ في إضافة المخرج: {error}",
    AIFlow_unknown_block_type_alert: "نوع الكتلة غير معروف:",
    AIFlow_multiple_flow_for_private_reply_alert: "تم العثور على عدة تدفقات للرد الخاص",
    AIFlow_empty_title_for_flow_alert: "عنوان التدفق فارغ",
    AIFlow_weblink_has_hyphen_alert: "الكتلة {label}\n الرابط يجب ألا يحتوي على '-'",
    AIFlow_min_output_required: "يجب أن يبقى على الأقل مخرج واحد",
    AIFlow_max_quick_reply_outputs: "الحد الأقصى 15 مخرجًا مسموح به",
    AIFlow_max_generic_outputs: "الحد الأقصى 10 مخرجات مسموح بها",
    AIFlow_generic_item_connection_only: "هذه الكتلة تتصل فقط بالكتل العامة",
    AIFlow_weblink_generic_item_only: "هذه الكتلة تتصل فقط بالفروع العامة",
    AIFlow_voice_record_failed: "❌ فشل تسجيل الصوت (لم يتم تسجيل أي صوت)",
    AIFlow_voice_upload_failed: "✅ تم التسجيل بنجاح ولكن فشل التحميل",
    AIFlow_voice_record_empty: "❌ التسجيل الصوتي فارغ",
    AIFlow_voice_record_start: "🎙️ بدأ التسجيل...",
    AIFlow_session_invalid: "جلسة المستخدم غير صالحة، يرجى تسجيل الدخول مرة أخرى",
    AIFlow_no_on_message_node: "لم يتم العثور على عقدة رسالة البدء!",
    AIFlow_validation_warning: "⚠️ تحذير التحقق",
    AIFlow_generic_item_validation_error: "يرجى استكمال جميع حقول الكتلة العامة",
    AIFlow_weblink_validation_error_alert: "يجب ملء جميع حقول الرابط",
    AIFlow_generic_item_title_empty_alert: "العنصر {label}\n العنوان فارغ",
    AIFlow_generic_item_output_title_empty_alert: "العنصر {label}\n المخرج {index} بدون عنوان",
    AIFlow_weblink_empty_alert: "الكتلة {label}\n الرابط فارغ",

    AIFlow_weblink_incomplete_alert: "الكتلة {label}\n الرابط غير مكتمل (تم إدخال البروتوكول فقط)",
    AIFlow_weblink_invalid_format_alert: "الكتلة {label}\n تنسيق الرابط غير صالح",
    AIFlow_weblink_non_english_alert: "الكتلة {label}\n يجب أن يكون الرابط باللغة الإنجليزية",
    AIFlow_editor_init_error: "❌ خطأ في تهيئة المحرر",
    AIFlow_unexpected_error: "⚠️ حدث خطأ غير متوقع",
    AIFlow_server_error: "❌ خطأ في الخادم",
    AIFlow_connection_error: "⚠️ مشكلة في الاتصال",
    AIFlow_generic_connection_error: "خطأ في اتصال الكتلة العامة بالفرع",
    AIFlow_weblink_connection_error: "خطأ في اتصال العقدة",
    AIFlow_voice_fetch_error: "خطأ في جلب ملف الصوت",
    AIFlow_voice_record_error: "خطأ في تسجيل الصوت",
    AIFlow_voice_play_error: "خطأ في تشغيل الصوت",
    AIFlow_media_recorder_error: "خطأ في جهاز تسجيل الوسائط",
    AIFlow_upload_error: "❌ خطأ في التحميل",
    AIFlow_add_output_error: "❌ خطأ في إضافة المخرج",
    AIFlow_json_parse_error: "خطأ في معالجة JSON",
    AIFlow_position_error: "خطأ في معالجة موقع رسالة البداية",
    AIFlow_node_remove_error: "خطأ في إزالة العقدة",
    AIFlow_node_connection_warning: "لا يمكن إنشاء الاتصال:",
    AIFlow_unknown_value_type: "نوع القيمة غير معروف في الزر",
    AIFlow_success: "✅ تمت العملية بنجاح",
    AIFlow_subtitle_success: "✓ تمت إضافة العنوان الفرعي بنجاح",
    AI_live_test: "اختبر أوامر الذكاء الاصطناعي الخاصة بك في الوقت الفعلي",

    New_Flow_input_message_block: "رسالة إدخال المستخدم",
    New_Flow_general_block: "الكتلة العامة",
    New_Flow_text_block: "كتلة النص",
    New_Flow_voice_block: "كتلة الصوت",
    New_Flow_imageorvideo_block: "كتلة الصورة / الفيديو",
    New_Flow_quick_reply_block: "كتلة الرد السريع",
    New_Flow_weblink_block: "كتلة الرابط",
    New_Flow_phonenumbergrabber_block: "جمع رقم الهاتف",
    New_Flow_ai_block: "الذكاء الاصطناعي",
    New_Flow_ai_select: "اختر ذكاءً اصطناعيًا",
    New_Flow_ai_livetest: "يتم تنفيذ كتلة الذكاء الاصطناعي الخاصة بك هنا",
    New_Flow_masterflow_block: "تدفق فرعي",
    New_Flow_masterflow_select: "اختر تدفقًا",
    New_Flow_masterflow_livetest: "يستمر التدفق الفرعي المحدد من هنا",
    New_Flow_Tutorials_buttongroup_title: "كتلة مجموعة الأزرار",
    New_Flow_Tutorials_buttongroup_description:
      "ترسل هذه الكتلة رسالة مع ثلاثة أزرار كحد أقصى؛ لكل زر مخرج مستقل، وللكتلة أيضًا مخرج عادي يواصل التدفق.",
    New_Flow_Tutorials_buttongroup_usageType:
      "مناسبة لعرض عدة خيارات واضحة وقوائم وتنقّل سريع وتوجيه المستخدم إلى رابط أو خطوة تالية.",
    New_Flow_Tutorials_buttongroup_feature_1: "نص رسالة يصل إلى 640 حرفًا",
    New_Flow_Tutorials_buttongroup_feature_2: "حتى 3 أزرار، لكل منها مخرج مستقل",
    New_Flow_Tutorials_buttongroup_feature_3: "مخرج عادي يواصل التدفق دون انتظار النقر على زر",
    New_Flow_Tutorials_buttongroup_tip_1: "اكتب نص الرسالة وعناوين الأزرار بوضوح وإيجاز",
    New_Flow_Tutorials_buttongroup_tip_2: "صل كل زر بالكتلة التي يجب أن تلي اختياره",
    New_Flow_Tutorials_buttongroup_tip_3: "يمكن وصل مخارج الأزرار فقط بكتلة رابط الويب",
    New_Flow_Tutorials_buttongroup_limitation_1: "الحد الأقصى 3 أزرار",
    New_Flow_Tutorials_buttongroup_limitation_2: "نص الرسالة: 640 حرفًا كحد أقصى",
    New_Flow_Tutorials_buttongroup_limitation_3: "عنوان الزر: 20 حرفًا كحد أقصى",
    New_Flow_Tutorials_buttongroup_limitation_4: "حذف آخر زر يزيل الكتلة",
    New_Flow_Tutorials_ai_title: "كتلة الذكاء الاصطناعي",
    New_Flow_Tutorials_ai_description:
      "تسلّم هذه الكتلة المحادثة إلى أحد أنظمة الذكاء الاصطناعي التي أنشأتها؛ اختر النظام من القائمة داخل الكتلة.",
    New_Flow_Tutorials_ai_usageType:
      "مناسبة للرد التلقائي على أسئلة العملاء المفتوحة والدعم والاستشارات ومحادثات المبيعات.",
    New_Flow_Tutorials_ai_feature_1: "تعرض جميع أنظمة الذكاء الاصطناعي التي أنشأتها لتختار منها",
    New_Flow_Tutorials_ai_feature_2: "يتولى الذكاء الاصطناعي المختار المحادثة من هذه النقطة في التدفق",
    New_Flow_Tutorials_ai_tip_1: "أنشئ الذكاء الاصطناعي واضبطه أولًا ليظهر في القائمة",
    New_Flow_Tutorials_ai_tip_2: "ضعها بعد كتلة رسالة تمهّد للمحادثة",
    New_Flow_Tutorials_ai_limitation_1: "لها مدخل فقط وبلا مخرج، لذلك تنهي التدفق",
    New_Flow_Tutorials_ai_limitation_2: "يمكن اختيار ذكاء اصطناعي واحد فقط لكل كتلة",
    New_Flow_Tutorials_ai_limitation_3: "لا يمكن أن تكون أول كتلة في التدفق",
    New_Flow_Tutorials_masterflow_title: "كتلة التدفق الفرعي",
    New_Flow_Tutorials_masterflow_description: "تنقل المحادثة إلى تدفق آخر أنشأته مسبقًا عندما ينقر المستخدم على زر.",
    New_Flow_Tutorials_masterflow_usageType: "إعادة استخدام تدفق موجود كاستمرار لزر",
    New_Flow_Tutorials_masterflow_feature_1: "تعرض جميع التدفقات التي أنشأتها لتختار واحدًا منها",
    New_Flow_Tutorials_masterflow_feature_2: "يواصل التدفق المحدد المحادثة من هذه النقطة",
    New_Flow_Tutorials_masterflow_tip_1: "أنشئ التدفق الهدف واحفظه أولاً ليظهر في القائمة",
    New_Flow_Tutorials_masterflow_tip_2: "استخدمها لمشاركة المسارات المشتركة (مثل الدعم أو الأسعار) بين التدفقات",
    New_Flow_Tutorials_masterflow_limitation_1: "لها مدخل فقط بدون مخرج، لذا تنهي هذا التدفق",
    New_Flow_Tutorials_masterflow_limitation_2: "يمكن ربطها بالأزرار فقط، وليس بالمخرجات العادية",
    New_Flow_Tutorials_masterflow_limitation_3: "لا يمكن اختيار التدفق الذي تقوم بتحريره",
    New_Flow_Tutorials_masterflow_connection_1: "أزرار كتلة الرد السريع",
    New_Flow_Tutorials_masterflow_connection_2: "أزرار كتلة مجموعة الأزرار",
    New_Flow_Tutorials_masterflow_connection_3: "أزرار الكتلة الفرعية للمعرض",
    New_Flow_generic_block: "كتلة المعرض (كاروسيل)",
    New_Flow_add_general_block: "إضافة كتلة للمعرض",
    New_Flow_add_text_block: "إضافة كتلة نص",
    New_Flow_add_image_block: "إضافة كتلة صورة",
    New_Flow_add_voice_block: "إضافة كتلة صوت",
    New_Flow_add_quick_reply_block: "إضافة رد سريع",
    New_Flow_add_weblink_block: "إضافة رابط",
    New_Flow_upload_imageorvideo: "رفع صورة أو فيديو",
    New_Flow_upload_image: "رفع صورة",
    New_Flow_upload_unsupported_media: "صيغة الوسائط غير مدعومة",
    New_Flow_uploadmaxsizeexceeded: "يجب ألا يتجاوز حجم الملف 50MB",
    New_Flow_uploadfilefailed: "فشل رفع الملف، يرجى المحاولة مرة أخرى",
    New_Flow_unsupportedbrowser: "متصفحك لا يدعم تشغيل الفيديو",
    New_Flow_micphoneaccessdenied: "قم بتمكين الوصول إلى الميكروفون",
    New_Flow_upload_audio: "رفع ملف صوتي",
    New_Flow_record_voice: "تسجيل الصوت",
    New_Flow_stop_record_voice: "إيقاف التسجيل",
    New_Flow_areyoureadytorecord: "هل أنت مستعد للتسجيل؟",
    New_Flow_voice_recording_started: "جاري تسجيل الصوت...",
    New_Flow_add_generic_sub_block: "إضافة كتلة فرعية",
    New_Flow_generic_sub: "كتلة فرعية",
    New_Flow_add_button: "إضافة زر",
    New_Flow_quick_reply_title_placeholder: "عنوان خيار الرد السريع",
    New_Flow_buttongroup_block: "كتلة مجموعة الأزرار",
    New_Flow_add_buttongroup_block: "إضافة مجموعة أزرار",
    New_Flow_buttongroup_title_placeholder: "نص رسالة مجموعة الأزرار",
    New_Flow_imagegallery_block: "كتلة معرض الصور",
    New_Flow_add_imagegallery_block: "إضافة معرض صور",
    New_Flow_imagegallery_max_reached: "يمكنك إضافة ما يصل إلى {{max}} صور في هذه الكتلة",
    New_Flow_Tutorials_imagegallery_title: "كتلة معرض الصور",
    New_Flow_Tutorials_imagegallery_description:
      "تُستخدم هذه الكتلة لرفع وإرسال عدة صور (حتى {{max}} صور) إلى المستخدمين عبر الرسائل المباشرة.",
    New_Flow_Tutorials_imagegallery_usageType: "مناسبة لعرض عدة منتجات وألبومات الصور وصور قبل وبعد ومجموعات الصور.",
    New_Flow_Tutorials_imagegallery_feature_1: "تقبل حتى {{max}} صور في كتلة واحدة",
    New_Flow_Tutorials_imagegallery_limitation_1: "حد أقصى {{max}} صور لكل كتلة (قد يزداد هذا الحد مستقبلاً)",
    New_Flow_message_title: "عنوان الرسالة",
    New_Flow_message_description: "وصف الرسالة",
    New_Flow_live_test_block: "اختبار التدفق المباشر",
    New_Flow_delete_all_blocks: "حذف التدفق بالكامل",
    New_Flow_shortcuts_explain: "اختصارات لوحة المفاتيح لزيادة السرعة والتحكم في إدارة سير العمل.",
    New_Flow_Tutorials_Not_Available: "لا يوجد دليل متاح",
    New_Flow_Tutorials_Not_Available_Description: "لا يتوفر دليل لهذا العقد.",
    New_Flow_Tutorials_Usage_Type: "نوع الاستخدام",
    New_Flow_Tutorials_Features: "الميزات",
    New_Flow_Tutorials_Tips: "نصائح عملية",
    New_Flow_Tutorials_Limitations: "القيود",
    New_Flow_Tutorials_Connections: "الاتصالات",
    New_Flow_unsavedChanges: "لديك تعديلات غير محفوظة",
    New_Flow_addedNodes: "العُقد المُضافة",
    New_Flow_removedNodes: "العُقد المُزالة",
    New_Flow_modifiedNodes: "العُقد المُعدّلة",
    New_Flow_invalidFlow_explain: "الفلو غير صالح. يرجى فحص العُقد بحثًا عن أي أخطاء قبل الحفظ",
    sendsms: "إرسال رسالة SMS إلى المستخدم",
    sendtotelegram: "توجيه المستخدم إلى تيليغرام",
    senderusername: "مناداة اسم المستخدم",
    addtools: "إضافة أداة",
    generatebyai: "توليد بواسطة الذكاء الاصطناعي",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "نقطة بداية الفلو الخاص بك",
    New_Flow_Tutorials_onmessage_description:
      "هذه الكتلة هي نقطة بداية الفلو الخاص بك. عند إرسال المستخدم رسالة إلى دایرکت إنستغرام الخاص بك، يتم تفعيل هذه الكتلة ويبدأ الفلو. إنها دائمًا الكتلة الأولى في أي أتمتة ولا يمكن حذفها.",
    New_Flow_Tutorials_onmessage_feature_1: "مخرج واحد للاتصال بالكتلة التالية",
    New_Flow_Tutorials_onmessage_tip_1:
      "قم بتوصيل مخرج هذه الكتلة بأي كتلة أخرى، يبدأ الفلو عندما يرسل المستخدم أي نوع من الرسائل (نص، صورة، فيديو، صوت، إلخ)",
    New_Flow_Tutorials_onmessage_connection_1: "قابل للاتصال بالكتل التالية:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ كتلة رابط ويب",
    New_Flow_Tutorials_onmessage_connection_3: "✅ كتلة رسالة صوتية",
    New_Flow_Tutorials_onmessage_connection_4: "✅ كتلة رسالة نصية",
    New_Flow_Tutorials_onmessage_connection_5: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_onmessage_connection_6: "✅ كتلة صورة وفيديو",
    New_Flow_Tutorials_onmessage_connection_7: "✅ كتلة معرض",

    New_Flow_Tutorials_text_title: "كتلة الرسائل النصية",
    New_Flow_Tutorials_text_description: "تُستخدم هذه الكتلة لإرسال الرسائل النصية إلى المستخدمين.",
    New_Flow_Tutorials_text_usageType:
      "مناسبة للرسائل الترحيبية، شرح المنتجات، الأسئلة المتكررة، الإشعارات، وإرشاد المستخدمين.",
    New_Flow_Tutorials_text_feature_1: "دعم جميع اللغات",
    New_Flow_Tutorials_text_feature_2: "إمكانية استخدام الرموز التعبيرية والحروف الخاصة",
    New_Flow_Tutorials_text_tip_1: "اكتب الرسائل قصيرة وواضحة",
    New_Flow_Tutorials_text_tip_2: "استخدم الرموز التعبيرية باعتدال",
    New_Flow_Tutorials_text_tip_3: "قسّم النصوص الطويلة إلى عدة أقسام",
    New_Flow_Tutorials_text_tip_4: "احرص على نبرة ودية وقريبة من المستخدم",
    New_Flow_Tutorials_text_tip_5: "استخدم تنسيق الفقرات بشكل مناسب",
    New_Flow_Tutorials_text_limitation_1: "حد أقصى 2200 حرف",
    New_Flow_Tutorials_text_limitation_2: "نص فقط (بدون ملفات أو وسائط)",
    New_Flow_Tutorials_text_limitation_3: "لا يمكن تنسيق النص (Bold, Italic)",
    New_Flow_Tutorials_text_connection_1: "✅ كتلة إدخال الرسائل",
    New_Flow_Tutorials_text_connection_2: "❌ كتلة رابط ويب",
    New_Flow_Tutorials_text_connection_3: "✅ كتلة رسالة صوتية",
    New_Flow_Tutorials_text_connection_4: "✅ كتلة رسالة نصية",
    New_Flow_Tutorials_text_connection_5: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_text_connection_6: "✅ كتلة صورة وفيديو",
    New_Flow_Tutorials_text_connection_7: "❌ كتلة معرض",
    New_Flow_Tutorials_text_connection_8: "✅ كتلة فرعية للمعرض",

    New_Flow_Tutorials_image_title: "كتلة الصورة والفيديو",
    New_Flow_Tutorials_image_description:
      "تُستخدم هذه الكتلة لتحميل وإرسال الصور والفيديوهات للمستخدمين عبر الرسائل المباشرة",
    New_Flow_Tutorials_image_usageType:
      "مناسبة لعرض المنتجات، معارض الصور، الشعارات، البنرات الترويجية، الفيديوهات التعليمية والتقديمية.",
    New_Flow_Tutorials_image_feature_1: "دعم الصور: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "دعم الفيديو: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "كشف نوع الملف تلقائيًا",
    New_Flow_Tutorials_image_tip_1: "استخدم صور عالية الجودة",
    New_Flow_Tutorials_image_tip_2: "اضغط الملفات الكبيرة قبل التحميل",
    New_Flow_Tutorials_image_tip_3: "الأبعاد القياسية: 1080×1080 أو 1080×1350",
    New_Flow_Tutorials_image_tip_4: "اجعل الفيديوهات أقل من 30 ثانية",
    New_Flow_Tutorials_image_tip_5: "JPEG للصور العادية، PNG للخلفيات الشفافة",
    New_Flow_Tutorials_image_limitation_1: "أقصى حجم: 50 ميغابايت",
    New_Flow_Tutorials_image_limitation_2: "ملف واحد لكل كتلة",
    New_Flow_Tutorials_image_limitation_3: "قد لا تدعم الصيغ غير المعتادة",
    New_Flow_Tutorials_image_connection_1: "✅ كتلة إدخال الرسائل",
    New_Flow_Tutorials_image_connection_2: "❌ كتلة رابط ويب",
    New_Flow_Tutorials_image_connection_3: "✅ كتلة الرسائل الصوتية",
    New_Flow_Tutorials_image_connection_4: "✅ كتلة الرسائل النصية",
    New_Flow_Tutorials_image_connection_5: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_image_connection_6: "✅ كتلة الصورة والفيديو",
    New_Flow_Tutorials_image_connection_7: "❌ كتلة المعرض",
    New_Flow_Tutorials_image_connection_8: "✅ كتلة فرعية للمعرض",
    invalidFlowDetected: "تدفق غير صالح! بعض الكتل لا تحتوي على مدخلات أو كتلة الرسالة منفصلة.",

    New_Flow_Tutorials_voice_title: "كتلة الرسائل الصوتية",
    New_Flow_Tutorials_voice_description:
      "تُستخدم هذه الكتلة لتحميل وإرسال الملفات الصوتية أو التسجيلات الحية للمستخدمين",
    New_Flow_Tutorials_voice_usageType:
      "مناسبة للرسائل الصوتية الشخصية، الدروس المسموعة، البودكاست القصيرة والإرشادات الصوتية.",
    New_Flow_Tutorials_voice_feature_1: "دعم الصيغ: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "تسجيل مباشر من الميكروفون",
    New_Flow_Tutorials_voice_feature_3: "رفع الملفات الصوتية الجاهزة",
    New_Flow_Tutorials_voice_tip_1: "سجل في بيئة هادئة",
    New_Flow_Tutorials_voice_tip_2: "الرسائل القصيرة (أقل من دقيقة) أفضل",
    New_Flow_Tutorials_voice_tip_3: "تحقق من جودة الصوت قبل الإرسال",
    New_Flow_Tutorials_voice_tip_4: "حضّر نصك قبل التسجيل",
    New_Flow_Tutorials_voice_limitation_1: "أقصى حجم: 50 ميغابايت",
    New_Flow_Tutorials_voice_limitation_2: "يتطلب الوصول إلى الميكروفون للتسجيل",
    New_Flow_Tutorials_voice_limitation_3: "ملف واحد لكل كتلة",
    New_Flow_Tutorials_voice_connection_1: "✅ كتلة إدخال الرسائل",
    New_Flow_Tutorials_voice_connection_2: "❌ كتلة رابط ويب",
    New_Flow_Tutorials_voice_connection_3: "✅ كتلة الرسائل الصوتية",
    New_Flow_Tutorials_voice_connection_4: "✅ كتلة الرسائل النصية",
    New_Flow_Tutorials_voice_connection_5: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_voice_connection_6: "✅ كتلة الصورة والفيديو",
    New_Flow_Tutorials_voice_connection_7: "❌ كتلة المعرض",
    New_Flow_Tutorials_voice_connection_8: "✅ كتلة فرعية للمعرض",

    New_Flow_Tutorials_quickreply_title: "كتلة الرد السريع",
    New_Flow_Tutorials_quickreply_description:
      "تُستخدم هذه الكتلة لإنشاء أزرار Quick Reply اختيارية لمرة واحدة للمستخدمين، حيث يوجه كل زر المستخدم عبر مسار معين في التدفق.",
    New_Flow_Tutorials_quickreply_usageType:
      "مناسب للقوائم الاختيارية، فئات المنتجات، الأسئلة متعددة الخيارات، الاستطلاعات، ومرشحات البحث.",
    New_Flow_Tutorials_quickreply_feature_1: "حتى 10 أزرار لكل كتلة",
    New_Flow_Tutorials_quickreply_feature_2: "كل زر له مخرج مستقل",
    New_Flow_Tutorials_quickreply_feature_3: "إمكانية حذف وتحرير الأزرار",
    New_Flow_Tutorials_quickreply_tip_1: "اكتب نص الأزرار بوضوح وفعالية",
    New_Flow_Tutorials_quickreply_tip_2: "3 إلى 5 أزرار لتجربة أفضل",
    New_Flow_Tutorials_quickreply_tip_3: "اجعل العلامات قصيرة (أقل من 20 حرفًا)",
    New_Flow_Tutorials_quickreply_tip_4: "استخدم حقل العنوان للإرشاد",
    New_Flow_Tutorials_quickreply_tip_5: "قم بترتيب أولوية الأزرار حسب الأهمية",
    New_Flow_Tutorials_quickreply_limitation_1: "الحد الأقصى 10 أزرار",
    New_Flow_Tutorials_quickreply_limitation_2: "عنوان الزر: 40 حرف كحد أقصى",
    New_Flow_Tutorials_quickreply_limitation_3: "الوصف: 140 حرف كحد أقصى",
    New_Flow_Tutorials_quickreply_limitation_4: "الحد الأدنى زر واحد مطلوب",
    New_Flow_Tutorials_quickreply_connection_1: "✅ كتلة إدخال الرسائل",
    New_Flow_Tutorials_quickreply_connection_2: "❌ كتلة رابط الويب",
    New_Flow_Tutorials_quickreply_connection_3: "✅ كتلة الرسائل الصوتية",
    New_Flow_Tutorials_quickreply_connection_4: "✅ كتلة الرسائل النصية",
    New_Flow_Tutorials_quickreply_connection_5: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_quickreply_connection_6: "✅ كتلة الصور والفيديو",
    New_Flow_Tutorials_quickreply_connection_7: "❌ كتلة المعرض",
    New_Flow_Tutorials_quickreply_connection_8: "✅ كتلة فرعية للمعرض",

    New_Flow_Tutorials_generic_title: "كتلة المعرض (كاروسيل)",
    New_Flow_Tutorials_generic_description: "إنشاء معرض قابل للتمرير أفقيًا (كاروسيل) من العناصر",
    New_Flow_Tutorials_generic_usageType:
      "مناسب لعرض المنتجات، قوائم الخدمات، الفئات، تقديم الفريق، المحفظة، ومقارنة الخيارات.",
    New_Flow_Tutorials_generic_tip_1: "استخدم صور بأبعاد متساوية (مثل 1:1)",
    New_Flow_Tutorials_generic_tip_2: "حافظ على عدد العناصر بين 3 و5",
    New_Flow_Tutorials_generic_tip_3: "اكتب عناوين قصيرة وواضحة",
    New_Flow_Tutorials_generic_tip_4: "مناسب للمنتجات المماثلة أو للمقارنات",
    New_Flow_Tutorials_generic_limitation_1: "الحد الأقصى 10 عناصر لكل كاروسيل",
    New_Flow_Tutorials_generic_connection_1: "✅ كتلة إدخال الرسائل",
    New_Flow_Tutorials_generic_connection_2: "✅ كتلة فرعية للمعرض",
    New_Flow_Tutorials_generic_connection_3: "❌ كتلة رابط الويب",
    New_Flow_Tutorials_generic_connection_4: "❌ كتلة الرسائل الصوتية",
    New_Flow_Tutorials_generic_connection_5: "❌ كتلة الرسائل النصية",
    New_Flow_Tutorials_generic_connection_6: "❌ كتلة الرد السريع",
    New_Flow_Tutorials_generic_connection_7: "❌ كتلة الصور والفيديو",

    New_Flow_Tutorials_genericitem_title: "عنصر كاروسيل",
    New_Flow_Tutorials_genericitem_description: "عنصر داخل كاروسيل يشمل صورة، عنوان، وصف، رابط وحتى ٣ أزرار",
    New_Flow_Tutorials_genericitem_usageType:
      "مناسب لعرض تفاصيل المنتجات، تقديم الخدمات، عرض الفريق، المحافظ، وحزم التسعير.",
    New_Flow_Tutorials_genericitem_feature_1: "رابط ويب اختياري",
    New_Flow_Tutorials_genericitem_feature_2: "صورة اختياري: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "فيديو: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "حتى ٣ أزرار بمخرجات مستقلة",
    New_Flow_Tutorials_genericitem_tip_1: "أضف صورة جذابة لكل عنصر",
    New_Flow_Tutorials_genericitem_tip_2: "العنوان للرسالة الرئيسية، الوصف للتفاصيل",
    New_Flow_Tutorials_genericitem_tip_3: "اختبر الروابط قبل الإرسال",
    New_Flow_Tutorials_genericitem_tip_4: "اجعل نص الأزرار قصير وواضح",
    New_Flow_Tutorials_genericitem_tip_5: "يفضل استخدام الروابط المختصرة",
    New_Flow_Tutorials_genericitem_limitation_1: "العنوان: حد أقصى ١٤٠ حرف",
    New_Flow_Tutorials_genericitem_limitation_2: "الوصف: حد أقصى ١٤٠ حرف",
    New_Flow_Tutorials_genericitem_limitation_3: "حد أقصى ٣ أزرار",
    New_Flow_Tutorials_genericitem_limitation_4: "عنوان الزر: حد أقصى ٤٠ حرف",
    New_Flow_Tutorials_genericitem_limitation_5: "حجم الملف: حد أقصى ٥٠ ميغابايت",
    New_Flow_Tutorials_genericitem_limitation_6: "مطلوب زر واحد على الأقل",
    New_Flow_Tutorials_genericitem_connection_1: "❌ كتلة إدخال الرسائل",
    New_Flow_Tutorials_genericitem_connection_2: "✅ كتلة المعرض",
    New_Flow_Tutorials_genericitem_connection_3: "✅ كتلة رابط ويب",
    New_Flow_Tutorials_genericitem_connection_4: "✅ كتلة الرسائل الصوتية",
    New_Flow_Tutorials_genericitem_connection_5: "✅ كتلة الرسائل النصية",
    New_Flow_Tutorials_genericitem_connection_6: "✅ كتلة الرد السريع",
    New_Flow_Tutorials_genericitem_connection_7: "✅ كتلة الصور والفيديو",

    New_Flow_Tutorials_weblink_title: "كتلة رابط ويب",
    New_Flow_Tutorials_phonenumbergrabber_title: "كتلة جمع رقم الهاتف",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "تنتظر هذه الكتلة استلام رقم هاتف، وعند استلامه تسجله كرقم صالح.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "مناسب لجمع أرقام هواتف العملاء والتسجيل ومتابعة الطلبات والاستشارات والتواصل مع قسم المبيعات.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "ينتظر رد المستخدم حتى يتم استلام رقم الهاتف",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "التحقق من الرقم المستلم وتسجيله تلقائيًا",
    New_Flow_Tutorials_phonenumbergrabber_tip_1: "قبل هذه الكتلة، اطلب من المستخدم رقم هاتفه بكتلة نصية",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "أخبر المستخدم بالصيغة المتوقعة للرقم (مثلاً مع رمز الدولة)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "بعد هذه الكتلة، أرسل رسالة تأكيد أو شكر",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "لا يمكن أن تكون الكتلة الأولى في التدفق",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "لها مدخل واحد ومخرج واحد فقط",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "يتم تسجيل الأرقام الصالحة فقط",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ كتلة الفرع الفرعي للمعرض",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ كتلة الرد السريع",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ كتلة إدخال الرسالة (لا يمكن أن تكون الكتلة الأولى)",
    New_Flow_Tutorials_weblink_description: "إرسال رابط ويب قابل للنقر يفتح في متصفح المستخدم",
    New_Flow_Tutorials_weblink_usageType:
      "مناسب للتوجيه إلى مواقع الويب، صفحات المنتجات، المتاجر، نماذج التسجيل، صفحات الهبوط والمقالات.",
    New_Flow_Tutorials_weblink_feature_1: "التحقق التلقائي من URL",
    New_Flow_Tutorials_weblink_feature_2: "دعم الروابط مع/بدون WWW",
    New_Flow_Tutorials_weblink_tip_1: "يفضل استخدام رابط مختصر",
    New_Flow_Tutorials_weblink_tip_2: "اختبر الروابط قبل الإرسال",
    New_Flow_Tutorials_weblink_tip_3: "يجب أن تكون الروابط صديقة للجوال",
    New_Flow_Tutorials_weblink_tip_4: "تجنب إعادة التوجيه الكثير",
    New_Flow_Tutorials_weblink_tip_5: "يفضل HTTPS",
    New_Flow_Tutorials_weblink_limitation_1: "فقط http:// أو https:// صالح",
    New_Flow_Tutorials_weblink_limitation_2: "لا يمكن إضافة وصف",
    New_Flow_Tutorials_weblink_limitation_3: "الروابط الداخلية (file://) غير مدعومة",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ إدخال من: كتلة معرض فرعي",
    New_Flow_Tutorials_weblink_connection_2: "❌ لا يوجد إخراج (نقطة نهاية التدفق)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "تمت العملية بنجاح",
    Notify_InternalException: "حدث خطأ في النظام",
    Notify_CannotSendSmsNow: "لا يمكن إرسال الرسائل القصيرة حالياً",
    Notify_InvalidPhoneNumber: "رقم الهاتف المدخل غير صالح",
    Notify_InvalidCountryCode: "رمز الدولة المدخل غير صالح",
    Notify_PhoneNumberNotAvailableInThisCountry: "لا يمكن استخدام هذا الرقم في الدولة المحددة",
    Notify_InstagramerIdNotExist: "لم يتم العثور على مستخدم إنستغرام",
    Notify_EmptyProductList: "قائمة المنتجات فارغة",
    Notify_InvalidVerificationCode: "رمز التحقق المدخل غير صحيح",
    Notify_LowQuality: "جودة المحتوى منخفضة",
    Notify_CannotEmptyChildren: "لا يمكن حذف العناصر الفرعية",
    Notify_InvalidAspectRatio: "نسبة الأبعاد المدخلة غير صالحة",
    Notify_InvalidMediaCodec: "ترميز الوسائط غير مدعوم",
    Notify_InvalidMediaType: "نوع الوسائط غير مدعوم",
    Notify_MediaUrlNotAccessible: "عنوان الوسائط غير متاح",
    Notify_CannotCreatePrePostNow: "لا يمكن إنشاء المسودة حالياً",
    Notify_InvalidMediaContent: "محتوى الوسائط غير صالح",
    Notify_Unexpected: "حدث خطأ غير متوقع",
    Notify_TooManyRequestForImageHashtagGenerator: "عدد الطلبات لتوليد هاشتاج الصور تجاوز الحد المسموح",
    Notify_LoginFailed: "فشل تسجيل الدخول، يرجى المحاولة مرة أخرى",
    Notify_NullUserId: "معرّف المستخدم غير مدخل",
    Notify_RealtimeSocketNotExist: "الاتصال بالخادم غير موجود",
    Notify_PushSocketNotExist: "الاتصال غير موجود",
    Notify_InstaApiNotFoundForConnect: "الاتصال بخوادم إنستغرام غير موجود",
    Notify_EmptyHashtagList: "قائمة الهاشتاج فارغة",
    Notify_InvalidHashtagListId: "معرّف قائمة الهاشتاج غير صالح",
    Notify_DeleteHashtagFail: "فشل حذف الهاشتاج",
    Notify_InvalidBase64Content: "محتوى Base64 غير صالح",
    Notify_InvalidTermsAndConditionSvgType: "الشروط والأحكام غير صالحة",
    Notify_InvalidLotteryAnnouncementBannerId: "معرّف لافتة إعلان السحب غير صالح",
    Notify_InvalidLotteryAnnouncementBannerStr: "نص لافتة إعلان السحب غير صالح",
    Notify_InvalidPostId: "معرّف البوست غير صالح",
    Notify_TooSoonLotteryInfo: "تم إرسال معلومات السحب مبكرًا جدًا",
    Notify_InvalidDirectParams: "معلمات الدایرکت غير صالحة",
    Notify_NoInstagramerExists: "لم يتم العثور على أي حساب إنستغرام",
    Notify_PropertyNotFoundOrNull: "العنصر غير موجود أو فارغ",
    Notify_ReachNumberOfPinDirect: "تم الوصول إلى الحد الأقصى للرسائل المثبتة",
    Notify_InvalidStoryId: "معرّف الاستوري غير صالح",
    Notify_MaxPrePostReach: "تم الوصول إلى الحد الأقصى لعدد البوستات المسبقة",
    Notify_InvalidDraftId: "معرّف المسودة غير صالح",
    Notify_InvalidPrePostId: "معرّف البوست المسبق غير صالح",
    Notify_ReachHashtagListLimit: "تم الوصول إلى الحد الأقصى لقوائم الهاشتاج",
    Notify_EmptyUsername: "اسم المستخدم غير مدخل",
    Notify_TooManyRequestForPageHashtagAnalysis: "عدد الطلبات لتحليل هاشتاج الصفحة تجاوز الحد المسموح",
    Notify_PasswordRequired: "كلمة المرور مطلوبة",
    Notify_PackageRequiredInThisTime: "تحتاج إلى حزمة نشطة",
    Notify_FeatureRequiredInThisTime: "هذه الميزة تحتاج إلى التفعيل",
    Notify_NoShopperExist: "لم يتم العثور على أي بائع",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "السحب العشوائي للفالوور بدون تسجيل الدخول غير مسموح للحسابات الخاصة أو المؤكدة",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "سحب التفاعل للفالوور بدون تسجيل الدخول غير مسموح للحسابات الخاصة",
    Notify_InvalidLinkId: "معرّف الرابط غير صالح",
    Notify_ReachMaxBioLink: "تم الوصول إلى الحد الأقصى لروابط البايو",
    Notify_OnlyBusinessAccountHasThisAccess: "هذا الوصول متاح فقط للحسابات التجارية",
    Notify_NoYoutubeChannelFound: "لم يتم العثور على قناة يوتيوب",
    Notify_CannotGetYoutubeRightNow: "لا يمكن الحصول على معلومات يوتيوب الآن",
    Notify_AparatUsernameNotFound: "اسم مستخدم آپارات غير موجود",
    Notify_AparatChannelHasNotAnyVideo: "قناة آپارات لا تحتوي على أي فيديو",
    Notify_InvalidYoutubeChannelId: "معرّف قناة يوتيوب غير صالح",
    Notify_NoAparatChannelFound: "لم يتم العثور على أي قناة آپارات",
    Notify_CannotGetAparatRightNow: "لا يمكن الحصول على معلومات آپارات الآن",
    Notify_NotSettedCustomDomain: "النطاق المخصص غير مضبوط",
    Notify_CannotStoryWithoutWinnerBanner: "لا يمكن إنشاء استوري بدون لافتة الفائز",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "عدد لافتات الفائزين في الاستوري تجاوز الحد المسموح",
    Notify_LotteryOnProcessingOrEnded: "السحب جاري معالجته أو انتهى",
    Notify_CannotAbortLotteryOneHourBefore: "لا يمكن إلغاء السحب قبل أقل من ساعة من التنفيذ",
    Notify_CannotAbortFollowerLottery: "لا يمكن إلغاء سحب الفالوور",
    Notify_InvalidImageOrExceedMaxSize: "الصورة غير صالحة أو حجمها أكبر من الحد المسموح",
    Notify_ExceedLoginAttempt: "تجاوز عدد محاولات تسجيل الدخول الحد المسموح",
    Notify_NotExistComment: "لم يتم العثور على كامنت",
    Notify_UserNotFound: "المستخدم غير موجود",
    Notify_ExistInstagramerBefore: "تم تسجيل هذا الحساب على إنستغرام سابقاً",
    Notify_CannotChangeBusinessAccountType: "لا يمكن تغيير نوع الحساب التجاري، يرجى التواصل مع الدعم عبر تذكرة",
    Notify_InvalidProductId: "معرّف المنتج المدخل غير صالح",
    Notify_InvalidTrendHashtagPeriod: "الفترة المختارة لهاشتاغ الترند غير صالحة",
    Notify_InvalidLanguageId: "معرّف اللغة غير صالح",
    Notify_CannotStoryWithoutTermsBanner: "لا يمكن إنشاء Story بدون لافتة الشروط",
    Notify_ExceedMaxStoryTermsLotteryBanner: "عدد لافتات شروط قرعة Story تجاوز الحد المسموح",
    Notify_LotteryTermsIsNull: "شروط القرعة لم تُسجل",
    Notify_CanShareTermsBefore6HoursOfStartLottery: "يمكن مشاركة الشروط فقط حتى ٦ ساعات قبل بدء القرعة",
    Notify_CanShareTermForOnlyDefinedStatusLotteries: "مشاركة الشروط مفعلة فقط للقرعات في الحالة المعرفة",
    Notify_SharedRemainingTimeBefore: "تم مشاركة الوقت المتبقي سابقاً",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery: "مشاركة الوقت المتبقي مفعلة فقط لقرعات النقاط",
    Notify_CanShareTermsBefore1HoursOfStartLottery: "يمكن مشاركة الشروط فقط حتى ١ ساعة قبل بدء القرعة",
    Notify_InvalidSubProductIds: "معرّفات المنتجات الفرعية غير صالحة",
    Notify_ReachMaxProductMedia: "تم الوصول إلى الحد الأقصى لوسائط المنتج",
    Notify_InvalidMediaProductId: "معرّف وسائط المنتج غير صالح",
    Notify_AccountNotABusiness: "هذا الحساب ليس حساب تجاري",
    Notify_NotFoundProductWithThisTempId: "لم يتم العثور على منتج بهذا المعرف المؤقت",
    Notify_InvalidAvailabilityStatus: "حالة التوفر المدخلة غير صالحة",
    Notify_InvalidIbanNumber: "رقم IBAN المدخل غير صالح",
    Notify_ExistedIbanNumber: "هذا الرقم IBAN مسجل مسبقاً",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "طريقة IBAN غير متاحة للمستخدمين بعملة غير تومان",
    Notify_SearchQueryIsEmpty: "عبارة البحث فارغة",
    Notify_ExceedMaxInEachCard: "عدد العناصر في كل بطاقة تجاوز الحد المسموح",
    Notify_ProductNotAlbumPost: "هذا المنتج غير مسجل كـ Post ألبوم",
    Notify_InvalidChildrenId: "معرّف الطفل غير صالح",
    Notify_NotAvailableProduct: "المنتج غير متاح حالياً",
    Notify_ExceedStockCount: "الكمية المحددة تتجاوز المخزون",
    Notify_CannotUnloadAnInstanceProduct: "لا يمكن تفريغ نسخة من المنتج",
    Notify_InvalidCategoryId: "معرّف الفئة غير صالح",
    Notify_NotFoundAnyProductOnThisCategory: "لم يتم العثور على أي منتج في هذه الفئة",
    Notify_NotFoundAnyNextProduct: "لم يتم العثور على المنتج التالي",
    Notify_NotFoundAnyPreviousProduct: "لم يتم العثور على المنتج السابق",
    Notify_InvalidItemId: "معرّف العنصر غير صالح",
    Notify_IpInvalid: "IP المدخل غير صالح",
    Notify_InstagramRedirectInTenSeconds: "سيتم تحويلك تلقائيًا إلى Instagram خلال 10 ثوانٍ",
    Notify_InstagramRedirect: "جارٍ التحويل إلى Instagram",
    Notify_InstagramRedirectExplain: "تأكد من تفعيل VPN، لأن عنوان IP الخاص بك غير صالح",
    Notify_ThisInstagramAccountAddedBefore: "تمت إضافة هذا الحساب على إنستغرام سابقاً",
    Notify_InvalidTicketId: "معرّف التذكرة غير صالح",
    Notify_ExpiredSignature: "التوقيع منتهي الصلاحية",
    Notify_Forbidden: "وصول غير مصرح به",
    Notify_ConnectedInstagramPageNotFound: "لم يتم العثور على صفحة إنستغرام المتصلة",
    Notify_AllInstagramAccountConnectedAddedBefore: "تمت إضافة جميع حسابات Instagram المتصلة سابقاً",
    Notify_SelectInstagramPageToConnect: "يرجى اختيار صفحة Instagram للاتصال",
    Notify_InstagramRedirectRoleNotFound: "دور إعادة توجيه Instagram غير موجود",
    Notify_FacebookLoginNotFound: "تسجيل الدخول إلى فيسبوك غير موجود",
    Notify_SelectedPageNotFound: "الصفحة المختارة غير موجودة",
    Notify_ShouldConnectInstaPageAgain: "يجب إعادة توصيل صفحة Instagram",
    Notify_InvalidProductSuggestionId: "معرّف اقتراح المنتج غير صالح",
    Notify_NotSavedSuggestions: "لم يتم حفظ الاقتراحات",
    Notify_ExistedSuggestedMedia: "تم تسجيل هذه الوسائط المقترحة مسبقاً",
    Notify_InvalidUploadMediaUrl: "رابط تحميل الوسائط غير صالح",
    Notify_SuggestedPostAutoReplyKeyNotExist: "مفتاح الرد التلقائي على Post المقترح غير موجود",
    Notify_UploadingTimeIsSoSoon: "وقت التحميل مبكر جداً",
    Notify_InvalidPreStoryId: "معرّف Pre-Story غير صالح",
    Notify_NotProvidedInstagramerId: "لم يتم تقديم معرف Instagramer",
    Notify_InvalidInstagramerId: "معرّف Instagramer غير صالح",
    Notify_InvalidThreadId: "معرّف الخيط غير صالح",
    Notify_InvalidLiveMediaId: "معرّف الوسائط الحية غير صالح",
    Notify_NotCreatedExportComment: "لم يتم إنشاء تصدير التعليقات",
    Notify_CreateExportAvailableWith24HourPeriod: "يمكن إنشاء التصدير مرة كل 24 ساعة",
    Notify_NotSetted: "لم يتم الإعداد",
    Notify_ExceedGeneralAutoReplyCount: "عدد الردود التلقائية العامة تجاوز الحد المسموح",
    Notify_InvalidTransactionId: "معرّف المعاملة غير صالح",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "لا يمكن تجديد حزمة شهرية في الوقت الحالي",
    Notify_CannotDeleteCurrentSession: "لا يمكن حذف الجلسة الحالية",
    Notify_InvalidSessionId: "معرّف الجلسة غير صالح",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day: "لا يمكن حذف الجلسة الحالية لإنشاء جلسة جديدة لمدة يوم واحد",
    Notify_UpgradedBefore: "تم ترقية هذا الحساب مسبقاً",
    Notify_PermissionNotExist: "الصلاحية غير موجودة",
    Notify_NotExistUser: "المستخدم غير موجود",
    Notify_UserAlreadyAsPartner: "المستخدم مسجل مسبقاً كشريك مسؤول",
    Notify_ReachMaxPartnerCount: "تم الوصول إلى الحد الأقصى لعدد شركاء المسؤول",
    Notify_InvalidPartnerRoleProvided: "الدور المقدم لشريك المسؤول غير صالح",
    Notify_PartnerRolesLengthIsZero: "لم يتم تعريف أي دور لشريك المسؤول",
    Notify_PartnerNotExist: "شريك المسؤول غير موجود",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf: "لا يمكنك اختيار نفسك كمسؤول شريك لنفسك",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "وقت انتهاء صلاحية المسؤول الشريك يجب أن يكون على الأقل ساعة واحدة من الآن",
    Notify_PartnerNameCannotExceed100: "اسم المسؤول الشريك لا يمكن أن يتجاوز 100 حرف",
    Notify_ProductIsMultiSubproducted: "هذا المنتج يحتوي على عدة منتجات فرعية",
    Notify_InvalidSubProductId: "معرف المنتج الفرعي غير صالح",
    Notify_ProductIdOutOfStock: "المنتج المطلوب غير متوفر في المخزون",
    Notify_SubProductIdRequired: "معرف المنتج الفرعي مطلوب",
    Notify_CardIsEmpty: "البطاقة فارغة",
    Notify_InvalidAddressId: "معرف العنوان غير صالح",
    Notify_ExceedTotalCreateAddress: "تم تجاوز الحد الأقصى لإنشاء العناوين",
    Notify_NotSupportedCountry: "الدولة المختارة غير مدعومة",
    Notify_CannotFetchAddressInThisEndpoint: "لا يمكن جلب العنوان في هذه النقطة النهائية",
    Notify_InvalidPostalCode: "الرمز البريدي غير صالح",
    Notify_NeedCompleteAddress: "يجب إدخال العنوان بالكامل",
    Notify_CannotBuyFromYourSelf: "لا يمكنك الشراء من نفسك",
    Notify_AllReadyIsBusiness: "هذا الحساب مسجل مسبقًا كحساب تجاري",
    Notify_InvalidBusinessType: "نوع الحساب التجاري غير صالح",
    Notify_UserAlreadyAuthorized: "تمت الموافقة على المستخدم مسبقًا",
    Notify_InstagramerNotInfluencer: "الإنستاجرامر غير مؤثر",
    Notify_InstagramerNotShopper: "الإنستاجرامر ليس بائعًا",
    Notify_AuthorizedInstagramerBefore: "تمت الموافقة على الإنستاجرامر مسبقًا",
    Notify_UserNotAuthorizedYet: "المستخدم لم يتم الموافقة عليه بعد",
    Notify_InstagramerNotAuthorized: "الإنستاجرامر غير مصرح له",
    Notify_InvalidBankCardNumber: "رقم البطاقة المصرفية غير صالح",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber: "مالك رقم الهاتف لا يطابق الرقم الوطني",
    Notify_CouponCodeAlreadyExists: "رمز القسيمة موجود مسبقًا",
    Notify_InvalidCouponId: "معرف القسيمة غير صالح",
    Notify_CannotChangeShowPrivateCouponInBio: "لا يمكن تغيير عرض القسيمة الخاصة في البايو",
    Notify_InvalidCouponCode: "رمز القسيمة غير صالح",
    Notify_CouponForAnotherPerson: "القسيمة تخص شخصًا آخر",
    Notify_CouponExpired: "القسيمة منتهية الصلاحية",
    Notify_CouponDeleted: "تم حذف القسيمة",
    Notify_CouponUsedUp: "تم استخدام القسيمة بالكامل",
    Notify_InvalidUsernameSearchQuery: "استعلام اسم المستخدم غير صالح",
    Notify_PreviouslyAddedShopAddress: "تم إضافة عنوان المتجر من قبل",
    Notify_NotSettedShopperAddress: "عنوان البائع غير مضبوط",
    Notify_NotExistAnyLogesticInYourCountry: "لا يوجد نظام لوجستي في بلدك",
    Notify_InvalidLogesticIds: "معرّفات اللوجستيك غير صالحة",
    Notify_LogsticsNotSetted: "اللوجستيات غير مضبوطة",
    Notify_NotCommpletedAllBusinessVerification: "لم تكتمل جميع التحقق التجاري",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic: "هذه الطرد غير مدعوم من أي لوجستيات متاحة محددة",
    Notify_NotSupportedLogestic: "اللوجستيك المختار غير مدعوم",
    Notify_ExceedLogesticHeight: "ارتفاع الطرد يتجاوز الحد المسموح للوجستيات",
    Notify_ExceedLogesticWidth: "عرض الطرد يتجاوز الحد المسموح للوجستيات",
    Notify_ExceedLogesticLength: "طول الطرد يتجاوز الحد المسموح للوجستيات",
    Notify_ExceedLogesticTotalLength: "إجمالي طول الطرد يتجاوز الحد المسموح للوجستيات",
    Notify_ExceedLogesticWeight: "وزن الطرد يتجاوز الحد المسموح للوجستيات",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress: "عناوين المستخدم فارغة أو لم يتم تعيين العنوان الافتراضي",
    Notify_NotSupportedBoxByThisDimensions: "الصندوق بهذا الأبعاد غير مدعوم",
    Notify_CannotAvailableOutOfStackProduct: "لا يمكن توفير المنتج خارج المخزون",
    Notify_YouAreDeadInCivilRegistration: "تم تسجيلك متوفياً في السجل المدني",
    Notify_InstagramerAlreadyAuthorized: "تم تفويض Instagramer بالفعل",
    Notify_ThreadShouldBeActiveForSendMessage: "يجب أن يكون الدردشة نشطة لإرسال رسالة",
    Notify_PreviouslyClosedTicket: "تم إغلاق التذكرة من قبل",
    Notify_NotMatchedCart: "عربة التسوق لا تطابق",
    Notify_PhoneNumberNotBlongsNationalNumber: "رقم الهاتف لا يتطابق مع الرقم الوطني",
    Notify_NotMatchedCardNumberAndIdentity: "رقم البطاقة ومعلومات الهوية لا تتطابقان",
    Notify_SuspendedShop: "تم تعليق هذا المتجر، يرجى الاتصال بالدعم",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "لم يتم تحديد معرف اللوجستيك للطرد البريدي",
    Notify_LogesticNotInAvailableLogestics: "اللوجستيك المختار غير موجود في قائمة اللوجستيات المتاحة",
    Notify_ExceedProductReportForLast24Hour: "عدد تقارير المنتج خلال ٢٤ ساعة الماضية تجاوز الحد المسموح",
    Notify_PreviouslyReportedThisProduct: "لقد قمت بالإبلاغ عن هذا المنتج من قبل",
    Notify_InvalidOrderId: "معرّف الطلب غير صالح",
    Notify_NotPendingPayRequest: "طلب الدفع ليس معلقاً",
    Notify_NotExistShopAddress: "لم يتم العثور على عنوان المتجر",
    Notify_InvalidOrderStatus: "حالة الطلب غير صالحة",
    Notify_CancelInvoiceFailed: "فشل إلغاء الفاتورة",
    Notify_PaymentSystemNotSupportedThisPriceType: "نظام الدفع لا يدعم هذا النوع من الأسعار",
    Notify_InvalidSentOrderType: "نوع الطلب المرسل غير صالح",
    Notify_InvalidParcelId: "معرّف الطرد غير صالح",
    Notify_AddedParcelIdBefore: "تمت إضافة معرف الطرد من قبل",
    Notify_InvoiceNotOnPaid: "لم يتم دفع الفاتورة بعد",
    Notify_CreatedSystemTicketOnOrderBefore: "تم إنشاء تذكرة النظام لهذا الطلب مسبقاً",
    Notify_PaymentServiceNotResponding: "خدمة الدفع لا تستجيب حالياً",
    Notify_YouAreNotAdmin: "أنت لست مسؤولاً",
    Notify_YouAreNotASubAdmin: "أنت لست مسؤولاً فرعياً",
    Notify_InvalidFbId: "معرّف فيسبوك غير صالح",
    Notify_InvalidFeatureId: "معرّف الميزة غير صالح",
    Notify_InActiveFeature: "هذه الميزة غير نشطة",
    Notify_FeaturePaused: "تم إيقاف هذه الميزة",
    Notify_InvalidPromptInput: "إدخال المطالبة غير صالح",
    Notify_PromptNotGenerated: "لم يتم إنشاء المطالبة",
    Notify_AIGeneratorFailed: "واجه مُنشئ الذكاء الاصطناعي خطأ",
    Notify_NotExecutedPromptForCommentYet: "لم يتم تنفيذ المطالبة للکامنت بعد",
    Notify_InstagramPermissionNotExist: "إذن إنستغرام غير موجود",
    Notify_InvalidTimeZone: "المنطقة الزمنية غير صالحة",
    Notify_PromptCaptionExampleNotGenerated: "مثال عنوان المطالبة لم يتم إنشاؤه",
    Notify_InvalidMasterFlowId: "معرف التدفق الرئيسي غير صالح",
    Notify_InvalidFlowId: "معرف التدفق غير صالح",
    Notify_EmptySubFlows: "التدفقات الفرعية فارغة",
    Notify_InvalidFlowObject: "التدفق غير صالح",
    Notify_InvalidMasterFlowTitle: "عنوان التدفق الرئيسي غير صالح",
    Notify_InvalidPromptId: "معرف المطالبة غير صالح",
    Notify_ExceedThreadTokenLimit: "تم تجاوز حد الرموز المميزة لهذه المحادثة",
    Notify_InvalidMediaId: "معرف الوسائط غير صالح",
    Notify_InvalidLotteryId: "معرف اليانصيب غير صالح",
    Notify_CannotAbortNonUpcomingLottery: "لا يمكن إلغاء اليانصيب غير القادم حالياً",
    Notify_CommentCountExceedFreeExport: "عدد التعليقات يتجاوز الحد المسموح لليانصيب المجاني",
    Notify_InvalidReserveFeatureId: "معرف الميزة المحجوزة غير صالح",
    Notify_CannotRenewalThisFeatureNow: "لا يمكن تجديد هذه الميزة حالياً",
    Notify_InvalidLotteryStatus: "حالة اليانصيب غير صالحة للتغيير",
    Notify_PublishedLotteryBannerBefore: "تم نشر بانر اليانصيب من قبل",
    Notify_LotteryWinnerBannerIsNull: "بانر الفائز في اليانصيب غير موجود",
    Notify_InvalidCustomPromptSigniture: "توقيع المطالبة المخصصة غير صالح",
    Notify_ServiceTemporarilyUnavailable: "الخدمة غير متاحة مؤقتاً",
    Notify_PageSummaryNotGenerated: "يحتاج برنسي إلى مزيد من البيانات لتحليل صفحتك.\nيُرجى التحلي بالصبر.",
    Notify_GenerateAIFail: "فشل توليد الذكاء الاصطناعي",
    Notify_InvalidPageAnalysis: "تحليل الصفحة غير صالح",
    Notify_InvalidCustomPrompt: "الموجه المخصص غير صالح",
    Notify_AIModelNotSupportImage: "نموذج الذكاء الاصطناعي لا يدعم الصور",
    Notify_PromptNotSupportImage: "الموجه لا يدعم الصور",
    Notify_AIModelNotSupportAudio: "نموذج الذكاء الاصطناعي لا يدعم الصوت",
    Notify_PromptNotSupportVoice: "الموجه لا يدعم الصوت",
    Notify_AIModelNotSupportVideo: "نموذج الذكاء الاصطناعي لا يدعم الفيديو",
    Notify_InvalidPrompt: "الموجه غير صالح",
    Notify_InvalidImageGeneratorInput: "مدخل مولد الصور غير صالح",
    Notify_InSuffcientNumberOfImage: "عدد الصور غير كافٍ",
    Notify_CreateImageExceedLimit: "تجاوز إنشاء الصور الحد المسموح",
    Notify_InvalidPromptType: "نوع الموجه غير صالح",
    Notify_UnSupportedAIInputType: "نوع مدخل الذكاء الاصطناعي غير مدعوم",
    Notify_UnSupportedOrientationType: "نوع الاتجاه غير مدعوم",
    Notify_SoraFailedAiCall: "فشل استدعاء Sora AI",
    Notify_AIVideoSecondNotSupported: "مدة الفيديو للذكاء الاصطناعي غير مدعومة",
    Notify_FailedToTraslateDescription: "فشل في ترجمة الوصف",
    Notify_FailedToGenerateEmbedVector: "فشل في إنشاء متجه التضمين",
    Notify_NotGeneratedSummaryYet: "لم يتم إنشاء الملخص بعد",
    Notify_NoEventsFoundForTheGivenTimeRange: "لم يتم العثور على أحداث في النطاق الزمني المحدد",
    Notify_NoEventsFoundForThisPrompt: "لم يتم العثور على أحداث لهذا الموجه",
    Notify_PageAnalysisNotExist: "تحليل الصفحة غير موجود",
    Notify_NoEventIdeaGenerated: "لم يتم إنشاء أي فكرة للحدث",
    Notify_PhoneNumberAddedBefore: "تمت إضافة رقم الهاتف هذا من قبل",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "تم إرسال رمز واتساب من قبل، يرجى الانتظار يوماً واحداً",
    Notify_WhatsAppCodeNotRequested: "لم يتم طلب رمز تحقق واتساب",
    Notify_WhatsAppCodeMaxInvalidCountReach: "تم بلوغ الحد الأقصى لمحاولات رمز واتساب غير الصحيحة",
    Notify_UserWithThisPhoneNumberAlreadyExist: "يوجد مستخدم بهذا الرقم بالفعل",
    Notify_InvalidAIToolId: "معرف أداة الذكاء الاصطناعي غير صالح",
    Notify_AIToolParameterRequired: "معامل أداة الذكاء الاصطناعي مطلوب",
    Notify_AIToolParameterNotRequired: "أداة الذكاء الاصطناعي هذه لا تقبل معاملاً",
    Notify_ExceedDailyLimit: "تم تجاوز الحد اليومي",
    Notify_CannotGetTwitchRightNow: "لا يمكن جلب بيانات تويتش الآن",
    Notify_InvalidTwitchChannelId: "معرف قناة تويتش غير صالح",
    Notify_PhoneNumberRequired: "رقم الهاتف مطلوب",
    Notify_NotVerifiedHost: "المضيف غير موثق",
    Notify_NotBusinesser: "هذا المستخدم ليس صاحب عمل",
    Notify_NotFoundAnySuggestedCategory: "لم يتم العثور على أي فئة مقترحة",
    Notify_NoInvoiceExist: "لا توجد فاتورة",
    Notify_InvalidMediaAiCreatorKey: "نموذج الذكاء الاصطناعي غير صالح",
    Notify_InvalidMediaAiVersionKey: "إصدار الذكاء الاصطناعي غير صالح",
    Notify_InvalidMediaAiRequestModel: "نموذج طلب وسائط الذكاء الاصطناعي غير صالح",
    Notify_MediaAIError: "حدث خطأ أثناء إنشاء وسائط الذكاء الاصطناعي",
    Notify_TwitchChannelDoestHaveAnyVideo: "لا تحتوي قناة تويتش هذه على أي فيديو",
    Notify_CouponAlreadyDeleted: "تم حذف هذا الكوبون بالفعل",
    Notify_CouponNotDeleted: "هذا الكوبون غير محذوف",
    Notify_ExceedSubFlowCount: "تم تجاوز الحد الأقصى لعدد التدفقات الفرعية",
    Notify_ExceedFlowDepth: "تم تجاوز الحد الأقصى لعمق التدفق",
    Notify_ExceedFlowItemCount: "تم تجاوز الحد الأقصى لعدد عناصر التدفق",
    Notify_ExceedFlowMediaAudioCount: "تم تجاوز الحد الأقصى لعدد الوسائط والملفات الصوتية في التدفق",
    Notify_OneFlowButtonHasEmptyItem: "أحد الأزرار بدون تدفق",
    InternalNotify_Ok: "تمت العملية بنجاح",
    InternalNotify_RepetitiveHashtagInput: "الهاشتاغ المدخل مكرر",
    InternalNotify_NotFoundDevice: "لم يتم العثور على الجهاز",
    InternalNotify_EmptyHashtagList: "لا يمكن إنشاء قائمة فارغة",
    InternalNotify_CannotCreatePrePostNow: "لا يمكنك إنشاء منشور مسبق حالياً",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "لا يمكن اختيار حساب خاص للتحليل",
    InternalNotify_InstagramLoginRequired: "هذا الخيار يتطلب تسجيل الدخول إلى Instagram",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "هذا الخيار يتطلب تسجيل الدخول إلى Instagram للحسابات الموثقة",
    InternalNotify_PrivateOrVerifiedSponsor: "لا يمكن اختيار حساب خاص أو موثق كراعٍ",
    InternalNotify_StartUploadingPost: "المنشور يتم تحميله",
    InternalNotify_UploadingPostError: "حدث خطأ أثناء تحميل المنشور",
    InternalNotify_PostUploaded: "تم تحميل المنشور، قم بتحديث الصفحة لعرضه",
    InternalNotify_ExceededMedia: "عدد الوسائط تجاوز الحد المسموح",
    InternalNotify_More4IceBreaker: "لا يمكنك إجراء أكثر من 4 محادثات سريعة",
    InternalNotify_CopyLink: "تم نسخ الرابط الخاص بك",
    InternalNotify_copy: "تم نسخ المعلومات بنجاح",
    InternalNotify_CopyTrackingpost: "تم نسخ رمز تتبع الطرد الخاص بك",
    InternalNotify_Network: "خطأ في اتصال الشبكة",
    InternalNotify_TimeExpire: "لا يمكن التسجيل، انتهت المهلة",
    InternalNotify_ExceedPermittedHashtagNumber: "عدد الهاشتاغات تجاوز الحد المسموح",
    InternalNotify_UnexpectedError: "حدث خطأ غير متوقع",
    InternalNotify_CopyToClipboard: "تم نسخ معلوماتك مسبقاً إلى الحافظة",
    InternalNotify_ExceedPermittedUploadMedia: "عدد الوسائط يتجاوز الحد المسموح به",
    InternalNotify_FillRedBorderFields: "يرجى ملء الحقول ذات الإطار الأحمر",
    InternalNotify_RepeatedVariation: "على الأقل عنصران مكرر",
    InternalNotify_NeedOneProduct: "مطلوب منتج واحد على الأقل",
    InternalNotify_UploadMedia: "هناك مشكلة في تحميل الوسائط",
    InternalNotify_TurnOnProxy: "يجب استخدام IP صالح",
    InternalNotify_ExceedPermittedLiveTime: "وقت البث المباشر تجاوز الحد المسموح",
    InternalNotify_CommentDisabled: "لا يمكنك القيام بالإجراءات عندما تكون التعليقات معطلة",
    InternalNotify_ExceedSelectedCollaboratorPage: "عدد صفحات المتعاونين المحددة تجاوز الحد المسموح",
    InternalNotify_RepetitiveCollaboratorPage: "تم اختيار اسم المستخدم هذا مسبقاً",
    InternalNotify_ExceedPermittedSizeOfImage: "حجم الصورة تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "نسبة أبعاد فيديو الألبوم تجاوزت الحد المسموح",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "حجم فيديو الألبوم تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "مدة فيديو الألبوم تجاوزت الحد المسموح",
    InternalNotify_ExceedPermittedAspectRatioReels: "نسبة أبعاد الريلز تجاوزت الحد المسموح",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "حجم الريلز تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "مدة الريلز تجاوزت الحد المسموح",
    InternalNotify_NotPermittedMediaType: "نوع الوسائط غير مسموح",
    InternalNotify_InvalidMetaData: "البيانات الوصفية غير صالحة",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "عدد الأشخاص الموسومين تجاوز الحد المسموح",
    InternalNotify_ExceedSelectedMaxHashtags: "عدد الهاشتاغات المحددة تجاوز الحد المسموح",
    InternalNotify_ExistedInCollaborate:
      "اسم المستخدم هذا موجود مسبقاً في المتعاونين ولا يمكن أن يكون في الشريحة الأولى",
    InternalNotify_ExceedPermittedAspectRatioStory: "نسبة أبعاد الاستوري تجاوزت الحد المسموح",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "حجم فيديو الاستوري تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedWidthOfVideo: "عرض الفيديو تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "مدة فيديو الاستوري تجاوزت الحد المسموح",
    InternalNotify_BelowMinimumDurationOfVideoStory: "يجب أن تكون مدة فيديو القصة 3 ثوانٍ على الأقل",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply: "عدد الكلمات الخاصة بالرد التلقائي تجاوز الحد المسموح",
    InternalNotify_ExceedPermittedAspectRatioImage: "نسبة أبعاد الصورة تجاوزت الحد المسموح",
    InternalNotify_Success: "تمت العملية بنجاح",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "يمكن إنشاء تصدير بفترة 24 ساعة",
    InternalNotify_SaveIceBreaker: "تمت الإضافة بنجاح",
    InternalNotify_deleteIceBreaker: "تم الحذف بنجاح",
    InternalNotify_SavePersistenceMenu: "تمت إضافة قائمة الاستمرارية بنجاح",
    InternalNotify_SelectLanguage: "تم تغيير اللغة بنجاح",
    InternalNotify_SaveFollowTemplate: "تم حفظ قالب الفالو بنجاح",
    InternalNotify_AutoReplyOn: "تم تفعيل الرد التلقائي بنجاح",
    InternalNotify_AutoReplyOff: "تم إيقاف الرد التلقائي بنجاح",
    InternalNotify_AutoGeneralOn: "تم تفعيل الرد التلقائي العام بنجاح",
    InternalNotify_AutoGeneralOff: "تم إيقاف الرد التلقائي العام بنجاح",
    InternalNotify_MaxInEachCard: "الحد الأقصى في كل بطاقة",
    InternalNotify_ExceedStockCard: "الكمية المطلوبة تجاوزت مخزون البطاقة",
    InternalNotify_DefaultAddress: "لا يمكنك حذف العنوان الافتراضي",
    InternalNotify_FetchingYourData: "جارٍ جلب معلوماتك، يرجى الانتظار...",
    InternalNotify_EmptyTitleInQuickReply: "عنوان الرد السريع فارغ",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "عناوين المخرجات في الرد السريع فارغة",
    InternalNotify_EmptyTitleForFlow: "عنوان التدفق فارغ",
    InternalNotify_MultipleFlowForPrivateReply: "لا يمكنك وجود تدفقات متعددة للرد الخاص",
    InternalNotify_NotPermittedForDownload: "لا يُسمح لك بتنزيل هذا المحتوى",
    InternalNotify_NotFeature: "هذه الميزة غير متاحة لحسابك",
    InternalNotify_ExceedBasefeatureTime: "وقت استخدام الميزة الأساسية تجاوز الحد المسموح",
    InternalNotify_ChannelIdNotStartedWithUC: "يجب أن يبدأ معرف القناة بـ 'UC'",
    InternalNotify_PageAnalysisNotCompleted: "للأسف، لم يتم تحليل صفحتك بواسطة الذكاء الاصطناعي بعد",
    JustCreated: "تم تسجيل التذكرة",
    AdminReplied: "قام الدعم بالرد",
    UserReplied: "قام المستخدم بالرد",
    AdminClosed: "تم إغلاق التذكرة من قبل الدعم",
    UserClosed: "تم إغلاق التذكرة من قبل المستخدم",
    TimerClosed: "تم إغلاق التذكرة تلقائيًا",
    closethisticket: "إغلاق هذه التذكرة",

    Create: "إنشاء",
    image: "صورة",
    video: "فيديو",
    Images: "الصور",
    Videos: "الفيديوهات",
    "Generated artwork and visuals": "أعمال ومرئيات مولدة",
    "AI motion and clips": "حركة ومقاطع بالذكاء الاصطناعي",
    "Media type": "نوع الوسائط",

    "Generated AI video preview": "معاينة فيديو مولد بالذكاء الاصطناعي",

    Close: "إغلاق",
    Prompt: "الوصف",
    Metadata: "البيانات الوصفية",
    Creator: "المنشئ",
    Version: "الإصدار",
    Status: "الحالة",
    "Image ID": "معرف الصورة",
    "Video ID": "معرف الفيديو",
    "Job ID": "معرف المهمة",
    "Download image": "تنزيل الصورة",
    "Download video": "تنزيل الفيديو",
    "Your browser does not support video playback.": "متصفحك لا يدعم تشغيل الفيديو.",

    Uploading: "جارٍ الرفع ",
    "Add video": "إضافة فيديو",
    "Add audio": "إضافة صوت",
    "Add reference image": "إضافة صورة مرجعية",
    model: "نموذج",
    models: "نماذج",
    "resize aspect ratio": "تغيير نسبة الأبعاد",
    "Video models": "نماذج الفيديو",
    "Image models": "نماذج الصور",
    "Cost level {level}": "مستوى التكلفة {level}",
    "Calculating...": "جارٍ الحساب...",
    "Search from People or Keyword": "البحث عن أشخاص أو كلمة مفتاحية",
    "Create new Flow": "إنشاء تدفق جديد",
    "Welcome illustration": "رسم توضيحي ترحيبي",
    "Untitled generation": "إنشاء بلا عنوان",
    "No images yet": "لا توجد صور بعد",
    "No videos yet": "لا توجد فيديوهات بعد",
    "Your successful image generations will appear here.": "ستظهر صورك المولدة بنجاح هنا.",
    "Your successful video generations will appear here.": "ستظهر فيديوهاتك المولدة بنجاح هنا.",
    "Create your first image": "أنشئ صورتك الأولى",
    "Create your first video": "أنشئ فيديوك الأول",
    "Generating image": "جارٍ إنشاء الصورة",
    "Generating video": "جارٍ إنشاء الفيديو",
    "In progress": "قيد التنفيذ",
    "Just now": "الآن",
    "Waiting for the result": "في انتظار النتيجة",

    "Try again": "حاول مرة أخرى",

    "AI provider": "مزود الذكاء الاصطناعي",

    "Choose a model": "اختر نموذجًا",

    "Describe the subject, setting, light, composition, and style...":
      "صف الموضوع والمشهد والإضاءة والتكوين والأسلوب...",
    "Use at least {count} characters.": "استخدم {count} أحرف على الأقل.",
    "Video creator is unavailable": "منشئ الفيديو غير متاح",
    "Image creator is unavailable": "منشئ الصور غير متاح",
    "No video models found": "لم يتم العثور على نماذج فيديو",
    "No image models found": "لم يتم العثور على نماذج صور",
    "There are no video generation models available for this account.": "لا تتوفر نماذج لإنشاء الفيديو لهذا الحساب.",
    "There are no image generation models available for this account.": "لا تتوفر نماذج لإنشاء الصور لهذا الحساب.",
    "Not available": "غير متاح",
    // #endregion Notification Section
    how: "كيفية",
    SharedRemainingTimeBefore: "يجب الانتظار 24 ساعة قبل إعادة المشاركة مرة أخرى.",
    ConnectProduct: "ربط مباشر بالمنتج",
    messagesetting_ConnectProductResponseExplain: "اربط منتجك بـ Story أو Live.",
    biolinkProperties_Connect: "اتصال",
    economy: "اقتصادي",
    messagesetting_SpecifyProductResponseExplain: "حدّد منتجًا ليتم إرساله تلقائيًا إلى المستخدمين",
    messagesetting_ProductResponseExplain: "اربط المنتج الحالي بالمستخدم",

    // #region wallet
    createdtime: "وقت الإنشاء",
    BankCards: "البطاقات المصرفية",
    Transactions: "المعاملات",
    Settlements: "التسويات",
    AddNewBankCard: "إضافة بطاقة مصرفية جديدة",
    RegisterANewCard: "تسجيل بطاقة جديدة",
    CardBankNumber: "رقم البطاقة المصرفية",
    CardNumberExplain: "أدخل رقم بطاقتك. يجب أن تكون البطاقة المصرفية مسجلة باسم الشخص الذي قام بالتسجيل.",
    RegisterBankCard: "تسجيل البطاقة المصرفية",
    CardNumber: "رقم البطاقة",
    DefaultBankCard: "البطاقة المصرفية الافتراضية",
    SetAsDefaultBankCard: "تعيين كبطاقة مصرفية افتراضية",
    Type: "النوع",
    Suspended: "معلّق",
    Amount: "المبلغ",
    Time: "الوقت",
    Order: "الطلب",
    User: "المستخدم",
    NotAvailable: "غير متاح",
    Unsettled: "غير مسوّى",
    AwaitingSettled: "في انتظار التسوية",
    Settled: "تمت التسوية",
    SettlementFailed: "فشلت التسوية",
    SettleRequest: "طلب التسوية",
    emptyInvoice: "لم يتم تسجيل أي فاتورة بعد.",
    InvoiceID: "معرّف الفاتورة",
    InvoiceType: "نوع الفاتورة",
    InvoiceHistory: "سجل الفواتير",
    OrderDetails: "تفاصيل الطلب",
    InvoiceDetails: "تفاصيل الفاتورة",
    Paid: "مدفوع",
    Success: "ناجح",
    RefundRequest: "طلب استرداد",
    Refunding: "جارٍ الاسترداد",
    Refunded: "تم الاسترداد",
    RefundFailed: "فشل الاسترداد",
    Failed: "فشل",
    Package: "الباقة",
    Product: "المنتج",
    Feature: "الميزة",
    Custom: "مخصص",
    Invoice: "الفاتورة",
    UnknownStatus: "حالة غير معروفة",
    NoSettlementsRegisteredYet: "لم يتم تسجيل أي تسويات بعد.",
    LogesticPayment: "دفعة لوجستية",
    ProductIncome: "دخل المنتج",
    BrancyFeatureIncome: "دخل ميزات برنسی",
    BrancyLogesticPayment: "دفعة لوجستية من برنسی",
    BrancyPackageIncome: "دخل باقات برنسی",
    BrancyProductIncome: "دخل منتجات برنسی",
    BrancyTransferPayment: "رسوم التحويل من برنسی",
    WalletBalance: "رصيد المحفظة",
    TotalWithdrawn: "إجمالي المبالغ المسحوبة",
    FailedTransactions: "المعاملات الفاشلة",
    PendingSettlement: "في انتظار التسوية",
    OrderInProgress: "الطلب قيد المعالجة",
    OrderPickup: "استلام الطلب",
    OrderDelivery: "توصيل الطلب",
    SubInvoiceHistory: "سجل الفواتير الفرعية",
    history: "السجل",
    // #endregion wallet
  },
};
